{
  "accessibility": {
    "closeModal": "Stäng modal",
    "useSetting": "Använd inställning",
    "srOnly": {
      "close": "Stäng",
      "loading": "Läser in ..."
    }
  },
  "account": {
    "salesResources": {
      "title": "Försäljningsresurser",
      "searchDocuments": "Sök dokument",
      "minimalRating": "Minimalt betyg",
      "maxRating": "Maxbetyg"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Aktivera återfakturering för den här klienten för att tjäna upp till 10 gånger vinst på användning av telefon, e-post, automatiseringar etc.",
      "enableRebilling": "Aktivera återfakturering",
      "servicesActivateAfterPayment": "Återfaktureringstjänster kommer att vara aktiva efter att kunden har lagt till en betalningsmetod. Fram till dess kommer kundens kontoåtkomst att vara begränsad.",
      "cannotModifyOnHold": "Det går inte att ändra återfaktureringskonfigurationer eftersom det här kontot redan har ett SaaS-abonnemang på paus. Återfaktureringspåslag konfigureras enligt abonnemanget när klienten lägger till en betalningsmetod.",
      "rebillingSettings": "Återfaktureringsinställningar"
    }
  },
  "affiliates": {
    "aboutMe": "Om mig",
    "error": {
      "unableToSend": "Det gick inte att skicka e-post"
    },
    "industriesServed": "Branscher som betjänas",
    "sendAMessage": "Skicka ett meddelande",
    "sendMessageIntro": "Skicka ett meddelande för att importera dig själv till den här rådgivaren. Inkludera detaljer om dig själv och de tjänster du letar efter.",
    "socialSites": "Sociala webbplatser",
    "success": {
      "emailSent": "E-postmeddelande har skickats"
    },
    "validationErrors": {
      "validEmail": "Ange en giltig e-postadress.",
      "validMessage": "Ange ett giltigt meddelande.",
      "validName": "Ange ett giltigt namn."
    },
    "yearsInBusiness": "År i branschen",
    "yourEmail": "Din e-postadress",
    "yourName": "Ert namn",
    "paymentDetailsAccessMessage": " Avsnittet med betalningsuppgifter är endast tillgängligt och redigerbart för <strong>byråägaren</strong>. Om du behöver hjälp, kontaktar du din <strong>byråägare ({ agencyOwnerEmail })</strong>.",
    "partnerBadgeAlt": "Partneremblem",
    "photoAlt": "Partnerfoto",
    "defaultCompany": "Inget företag",
    "moreServices": "+ {count} fler tjänster"
  },
  "agency": {
    "saas": {
      "saasMode": "SAAS-läge",
      "pendingPaymentInformation": "Information om väntande betalning",
      "customerId": "Kund-ID",
      "noPaymentMethods": "Det verkar som att inga betalningsmetoder har lagts till! Lägg till en betalningsmetod för att aktivera Saas-läget",
      "enableSaasDescription": "Aktivera SaaS på den här platsen för att skapa prenumeration, återfakturera telefon- och e-postanvändning",
      "missingEmailAddress": "Det saknas en e-postadress för kontot, lägg till detaljer först.",
      "toConvertToSaaS": "För att konvertera det här kontot till SaaS måste du först lägga till en platsadministratör och försöka igen",
      "newUser": "Skapa ny användare",
      "stripeCustomerConnected": "Stripe-kund har anslutits framgångsrikt!",
      "requestClientPaymentDetails": "Begär kunders betalningsuppgifter",
      "saasLocationDescription": "Platser i SaaS-läge behöver din kunds kreditkort för att fungera. Du kan begära det genom att skicka ett e-postmeddelande, sms eller dela en URL",
      "selectSpace": "Välj utrymme för att fortsätta",
      "spaceDescription": "Det utrymme som du väljer här kommer att användas för att lagra kundens information, behandla deras betalningar och hantera deras prenumerationer.",
      "stripe": "Stripe",
      "freeCreditsDescription": "När en användare registrerar sig kan du erbjuda dem gratis krediter för att använda e-post- telefonitjänster.",
      "thatAboutMinsInCalls": "Det är ungefär {count} meddelanden eller {count1} minuter i samtal",
      "subscriptionSettings": "Abonnemangsinställningar",
      "toUpgradeOrCancelPlan": "För att uppgradera eller avbryta abonnemanget",
      "allowClientUpgrade": "Tillåt kunden (underkontot) att uppgradera till ett högre abonnemang.",
      "addNewPlanFeatures": "Lägg till nya funktioner i abonnemanget vid uppgradering.",
      "upgradeFeatureDescription": "När du uppgraderar till ett högre abonnemang får underkonton tillgång till de extra funktionerna i det nya abonnemanget. komma åt de extra funktionerna i det nya abonnemanget.",
      "allowClientCancel": "Tillåt kunden (underkontot) att avbryta sitt abonnemang.",
      "snapshotDescription": "Den valda ögonblicksbilden kommer automatiskt att läggas till den nyss skapade SaaS-platsen",
      "ownSnapshots": "Egna lägesbilder",
      "selectAndContinue": "Välj och fortsätt"
    },
    "advancedSettings": {
      "controlLocationSettings": "Hantera platsinställningarna",
      "disableAddSmtp": "Inaktivera knappen Lägg till e-posttjänst i underkontots inställningar för e-posttjänster",
      "disableAddSmtpDescription": "Begränsa underkontoanvändarnas möjlighet att lägga till sin egen e-posttjänsteleverantör",
      "enableReVerification": "Aktivera återverifiering i 90 dagar",
      "lcEmailNotEnabled": "Platsen har inte LeadConnector som standard e-postleverantör",
      "onlyVisibleForAgency": "Du kan bara se dessa inställningar aktiverade för byrån",
      "reVerificationDescription": "Varje e-postverifieringsstatus kommer att återkallas efter 90 dagar (skydda ditt rykte och säkerställ maximal leveransbarhet till inkorgen)",
      "account": {
        "accountDetails": "Kontodetaljer",
        "advancedEmailSettings": "Avancerade e-postinställningar",
        "hipaa": "HIPAA",
        "hipaaCompliant": "HIPAA-kompatibel",
        "smsEmailLimits": "Gränser för SMS/e-post",
        "socialProfiles": "Sociala profiler",
        "subscribed": "Prenumererad"
      },
      "activityTracking": {
        "history": "Historik"
      },
      "addAccount": {
        "accountInfo": "Kontoinformation",
        "accountSnapshots": "Kontoupplägg",
        "businessNiche": "Affärsnisch",
        "chooseBusinessNiche": "Välj affärsnisch …",
        "pickSnapshot": "Välj en lägesbild",
        "selectSnapshot": "Välj lägesbild",
        "title": "Lägg till underkonto",
        "accountInfo1": "Kontoinformation"
      },
      "addBalance": {
        "addBalanceToWallet": "Lägg till saldo till plånboken",
        "addMoneyToWallet": "Lägg till pengar i din plånbok",
        "balanceAddedSuccessfully": "Saldo tillagt",
        "cardWillBeCharged": "Kortet som slutar på {cardNumber} kommer att debiteras",
        "complimentaryCredits": "Kostnadsfria krediter ({credits})",
        "creditsRemovedByAgency": "Krediter har raderats av byrån",
        "currentBalance": "Aktuellt saldo",
        "customerCCWillNotBeCharged": "Kundens kreditkort kommer inte att debiteras",
        "moneyWillBeAddedToWallet": "Pengar kommer att läggas till i plånboken",
        "pleaseProvideAmountBetween": "Vänligen ange ett belopp mellan {min} och {max}",
        "processing": "Behandlas",
        "removeBalance": "Rensa saldo",
        "transactionSuccessful": "Transaktionen har genomförts",
        "walletBalance": "Plånbokssaldo ({balance})"
      },
      "addPaymentMethod": {
        "adding": "Lägger till …",
        "cardDetails": "Kortuppgifter",
        "cardSuccessfullyAdded": "Kort har lagts till",
        "errorWhileAddingCard": "Fel vid tillägg av nytt kort!",
        "maximumCardUpdateLimitReached": "Max gräns för kortuppdatering har uppnåtts",
        "rateLimitMessage": "Det verkar som att du har nått det maximala antalet försök som är tillåtna för att lägga till kort idag. Försök igen om 24 timmar."
      },
      "aiProductRebilling": {
        "funnel": " tratt",
        "images": " Bilder,",
        "per1000Words": " /1 000 ord, ",
        "perFunnel": " /tratt",
        "perImage": " / Bild,",
        "pleaseCheckSupport": "kolla in vårt",
        "ratesMayDiffer": "Priserna kan variera beroende på region. De visade beräkningarna är baserade på priser för Storbritannien,",
        "ratesMayDifferUS": "Priserna kan variera beroende på region. Beräkningar visas enligt Twilio-priser för USA, kontrollera Twilio för mer information.",
        "pleaseCheckTwilioRates": "Utgående SMS för USA/Kanada debiteras med 0,0079 USD/segment. Inkommande SMS för 0,0075 USD/segment.",
        "words": " ord, "
      },
      "api": {
        "advancedFunctionalityNote": "Meddelande om avancerade funktioner",
        "agencyApiKeys": "Byråns API-nycklar",
        "apiAccess": {
          "partOfAdvancedApi": "Detta är en del av det avancerade API:et som är tillgängligt med Pro-planen.",
          "toUpgrade": "att uppgradera."
        },
        "createNew": "Skapa ny",
        "developerCouncilInfo": "Information om utvecklarrådet",
        "noAccess": "Du har inte tillgång till det här avsnittet.",
        "securityAlert": "Säkerhetsvarning",
        "table": {
          "fetchingKeys": "Hämtar företagsnycklar ...",
          "noKeysYet": "Du har inga API-nycklar än.",
          "toCreateFirstKeys": "för att skapa dina första API-nycklar."
        },
        "zapierNote": "Meddelande om Zapier"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Möjlighet att välja Google-kalendrar för att 'lägga till' + 'Konflikt'-kalendrar för att kontrollera och beräkna tillgänglighet för varje användare",
        "abilityToAllocateRoundRobin": "Möjlighet att fördela möten enligt Round Robin-principen",
        "abilityToChooseSpecificUser": "Möjlighet att välja en specifik användare som mötet ska bokas med",
        "adminAbilitySeeEveryUser": "Admin – Möjlighet att se varje användares möten i kalendern",
        "adminAbilityViewAllCalendar": "Admin – Möjlighet att visa alla användares möten i kalendern",
        "adminsCanDeleteIntegrations": "Administratörer kan radera vilka integrationer de vill, men användare kan bara ta bort sina egna",
        "adminsCanSeeAllIntegrations": "Administratörer kan se alla integrationer oavsett vem som skapat dem, men användare kan bara se integrationer som de själva har skapat",
        "contactDetailAppointments": "Kontaktdetaljer > Möten (ny)",
        "conversationsScheduleAppointment": "Konversationer > Schemalägg möte (ny)",
        "essentialConsiderations": "Väsentliga överväganden",
        "funnelsWebsitesCalendar": "Trattar/webbplatser > Kalender (ny)",
        "helpReorientTriggers": "Under samtalet hjälper vi till att justera utlösarna så att de passar den nya kalenderkonfigurationen",
        "iAgreeMessage": "Om du godkänner ovanstående ändringar, klicka på \"Jag godkänner\" och kom igång med Kalender (Beta) på denna plats",
        "integrationNew": "Integration (ny)",
        "loseAbilityToViewEdit": "I den nya versionen kan användarna inte längre visa/redigera möten (som skapats i den tidigare versionen) via modalfönstret för möjlighetsdetaljer, men de kan fortfarande utföra alla åtgärderna på sidan Möten",
        "newOldTriggersCoexist": "De nya och gamla utlösarna kommer att samexistera",
        "nonAdminAbilityViewPersonal": "Inte admin – Möjlighet att bara visa sina personliga möten (tilldelade data/kalendermappning under TEAMHANTERING har ingen inverkan)",
        "nonAdminViewPersonalOnly": "Inte admin – Möjlighet att bara visa sina personliga möten",
        "notAtMoment": "Inte för tillfället. Men vi arbetar hårt för att göra det tillgängligt på mobiler så snart som möjligt.",
        "oldAppointmentsCanBeViewed": "De gamla mötena kan enkelt visas på mötessidan med hjälp av en växlingsknapp.",
        "oldAppointmentsDisplayed": "Gamla möten visas tillsammans med nya möten i samma lista",
        "oldCalendarVersionAppointments": "Gammal kalenderversion + gamla möten",
        "onlyNewCalendarWidget": "Endast ny kalenderwidget kan läggas till",
        "opportunityAddAppointment": "Möjlighet > Lägg till möte (ny)",
        "profilePageAdmin": "Profilsida för admin (ny)",
        "profilePageAllUsers": "Profilsida (alla användare)",
        "providesAllOptions": "Tillhandahåller alla alternativ (grupper + tjänster) som krävs för att konfigurera den nya kalendern",
        "reintegratingConnectionsRequired": "Det kan bli nödvändigt att återintegrera alla anslutningar när Kalender Beta aktiveras för en plats",
        "roundRobinHighlight": "Möjligheten att fördela möten enligt Round Robin-principen mellan olika agentgrupper är den främsta nyheten i denna uppdatering.",
        "schedulingCalendarAppointments": "Schemaläggning > Kalender/möten (nya filter + växla mellan nya och gamla möten)",
        "settingsCalendarBeta": "Inställningar > Kalender (Beta)",
        "surfacingFirstTime": "Visar det för första gången",
        "teamManagementAdminOnly": "Teamhantering (endast tillgängligt för administratörer)",
        "toggleOffNewVersion": "Stäng av (ny version)",
        "toggleOnOldVersion": "Slå på (gammal version)",
        "whatChangesWithNewVersion": "Vilka förändringar innehåller den nya versionen av kalendern?",
        "whatDoesCalendarEntail": "Vad innebär Kalendern (Privat Beta)?",
        "whatHappensToOldAppointments": "Vad händer med våra gamla möten efter övergången?",
        "whatWillWeSeeMobile": "Vad kommer vi att se på mobil under Beta?",
        "willOldAppointmentsBeFactored": "Tas de gamla mötena med i beräkningen när tillgängligheten för nya möten beräknas?",
        "willOldCalendarUrlsWork": "Kommer våra gamla kalender-URL:er att fortsätta fungera efter övergången?",
        "willWeGetNewVersionMobile": "Kommer vi att få använda den nya versionen på mobil under betan?",
        "yesOldSettingsPageContinues": "Ja. Den gamla inställningssidan kommer faktiskt att finnas kvar, och du kan fortfarande göra ändringar där. Den gamla kalenderwidgeten och den nya kalenderwidgeten kommer att fungera oberoende av varandra men vara ständigt synkroniserade med varandra för att säkerställa korrekt beräkning av din tillgänglighet i de två systemen. För att undvika förvirring rekommenderar vi starkt att du använder de nya URL:erna när det är möjligt, så att du slipper övervaka två olika URL:er för samma användargrupper.",
        "yesSyncOnGoogleCalendar": "Ja, eftersom enkelriktad synkronisering är aktiverad kommer Google Kalender att se till att otillgängliga tidsluckor blockeras."
      },
      "companyPlansModal": {
        "billedAnnually": "Faktureras årligen",
        "billedMonthly": "Faktureras varje månad",
        "changePlanFor": "Ändra schema för {locationName}",
        "notAuthorized": "Du är inte behörig att utföra den här åtgärden. Endast byråanvändare/administratörer och platsadministratörer kan utföra detta.",
        "payAnnually": "Betala årligen",
        "payMonthly": "Betala varje månad"
      },
      "locationBillingHistory": {
        "billingHistory": "Faktureringshistorik",
        "cardNo": "Kortnummer",
        "errorWhileFetchingInvoices": "Fel vid hämtning av fakturor, klicka för att försöka igen",
        "invoiceDescription": "Fakturabeskrivning",
        "invoiceNo": "Fakturanummer",
        "noInvoices": "Inga fakturor",
        "refunded": "Återbetald",
        "succeeded": "lyckades",
        "view": "VISA"
      },
      "locationWallet": {
        "autoRechargeWith": "Autopåfyllning med",
        "balance": "Saldo:",
        "credits": "Krediter",
        "seeTransactions": "Se transaktioner",
        "whenBalanceLowerThan": "när saldot är lägre än"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Kontrollera din e-post ({emails}).",
        "csvSentMessage": "Vi kommer att skicka en CSV-fil till din e-post. Det tar vanligtvis 7–10 minuter.",
        "enterEmailAddress": "Ange e-postadress",
        "exportAndSendCsv": "Exportera och skicka CSV",
        "exportTransactions": "Exportera transaktioner",
        "itUsuallyArrives": "Det kommer vanligtvis inom 10 minuter.",
        "useCommasToSeparate": "Använd kommatecken för att separera flera e-postadresser."
      },
      "modifySubscription": {
        "cancelClientDescription": "Avsluta din klients prenumeration och stäng kontot",
        "cancelDescription": "Avsluta din prenumeration och stäng kontot",
        "cancelImmediately": "Annullera omedelbart",
        "cancelNow": "Avbryt nu",
        "cancelSubscription": "Annullera abonnemang",
        "changedYourMind": "Har du ändrat dig?",
        "changedYourMindClient": "Du kan återuppta din kunds abonnemang",
        "changedYourMindYou": "Du kan återuppta ditt abonnemang",
        "confirmByTyping": "Bekräfta genom att skriva {text} nedan",
        "confirmCancellation": "Bekräfta annullering",
        "modifySubscription": "Ändra abonnemang",
        "modifyYourSubscription": "Ändra ditt abonnemang",
        "resumeSubscription": "Återuppta abonnemang",
        "subscriptionWillBeCancelledOn": "Detta kommer att schemalägga att ditt abonnemang annulleras på {date}. Du kan återuppta prenumerationen genom att avbryta den schemalagda uppsägningen när som helst.",
        "subscriptionWillBeCancelledOnClient": "Detta kommer att schemalägga din klients abonnemang att avbrytas den {date}. Du och dina kunder kan återuppta prenumerationen genom att avbryta den schemalagda uppsägningen när som helst.",
        "subscriptionWillBeCancelledOnDate": "Ditt abonnemang kommer att annulleras den {date}.",
        "subscriptionWillBeCancelledOnDateClient": "Din klients prenumeration kommer att sägas upp den {date}.",
        "subscriptionWillBeResumed": "Ditt abonnemang kommer att återupptas och du kommer att börja faktureras som vanligt.",
        "subscriptionWillBeResumedClient": "Din klients prenumeration kommer att återupptas och de kommer att börja faktureras som vanligt.",
        "upgradeDescription": "Byt till ett högre abonnemang",
        "weAreGladYouStaying": "Det glädjer oss att du stannar kvar!",
        "nextBillingDate": "Nästa faktureringsdatum: {date}",
        "cancelImmediatelyTitle": "Vill ni verkligen avsluta prenumerationen omedelbart?",
        "cancelNowDescription": "Din prenumeration är planerad att avbrytas {date}. Om du väljer att avbryta nu kommer ditt konto, inklusive all utgående aktivitet som schemalagda meddelanden och e-postmeddelanden, att stoppas omedelbart.",
        "cancelNowDescriptionClient": "Din kunds prenumeration är planerad att avbrytas {date}. Om du väljer att avbryta nu kommer din kunds konto, inklusive all utgående aktivitet som schemalagda meddelanden och e-postmeddelanden, att stoppas omedelbart.",
        "modifyDescription": "Du kan {action} ditt abonnemang",
        "modifyDescriptionClient": "Du kan {action} din kunds abonnemang"
      },
      "noPaymentMethodWarning": {
        "addNow": "Lägg till nu",
        "youNeedToEnterCardInfo": "Du måste ange din kortinformation.",
        "youNeedToEnterClientCardInfo": "Du måste ange din klients kortinformation."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "Avgifterna baseras på tokens. Ordantalet som visas nedan är uppskattningar som hjälper dig att förstå användningen. Faktiska avgifter kan variera.",
        "examplePricingGpt4oMini": "Exempelprissättning – GPT-4o Mini",
        "for750kWords": "(för 750 000 ord) ",
        "gpt4oMini": " GPT-4o-mini ",
        "input": "Indata",
        "or": "eller ",
        "output": "Utdata",
        "perImage": " / Bild",
        "perResultSelection": " / resultatval",
        "ratesMayDifferUK": "Priserna kan variera beroende på region. De visade beräkningarna är baserade på priser för Storbritannien, kolla in vårt",
        "ratesMayDifferUS": "Priserna kan variera beroende på region och nummertyp. Beräkningarna visas enligt Twilio-priser för USA,",
        "pleaseCheckSupport": "kolla in vårt",
        "resultSelection": " Resultatval",
        "supportDoc": "supportdokument",
        "forMoreDetails": "för mer detaljer",
        "words": " ord"
      },
      "removePaymentMethod": {
        "endingIn": "Slutar på *{cardNo}",
        "no": "Nej",
        "removeCard": "Ta bort kortet?",
        "removing": "Raderar..",
        "yesRemove": "Ja, ta bort"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Begär kundens betalningsinformation",
        "saasLocationDescription": "Konfigurera en SaaS-prenumeration för den här platsen",
        "selectSpace": "Välj yta",
        "spaceDescription": "Välj var du vill konfigurera faktureringen för denna plats"
      },
      "saasEnableProducts": {
        "disable": "Inaktivera",
        "enableDisableProducts": "Aktivera/inaktivera produkter",
        "feature": "Funktion",
        "unsavedChanges": "Osparade ändringar"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "Nästa fakturering för den här klienten verkar ha passerat. Detta händer när din byrås Stripe-konto inte fungerar korrekt. Logga in på din byrås Stripe för att åtgärda det.",
        "copiedText": "kopierad text:",
        "couldNotCopy": "Async: Kunde inte kopiera text: ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Nästa faktureringsdatum: ",
        "plan": "Abonnemang",
        "pleaseContactAgency": "Kontakta byrån för att aktivera din prenumeration.",
        "stripeSubscriptionId": "Stripe-abonnemangs-ID:",
        "subscriptionPlans": "Abonnemangsplaner",
        "subscriptionWillBeCancelledOn": "Ditt abonnemang kommer att annulleras den {date}",
        "subscriptionWillBeCancelledOnClient": "Din klients prenumeration kommer att sägas upp den {date}",
        "toModifyClientSubscription": "att ändra din kunds abonnemang",
        "toModifyYourSubscription": "för att ändra din prenumeration",
        "whatsappNumberSubscription": "WhatsApp-nummerprenumeration",
        "yourBillingDatePast": "Ditt nästa faktureringsdag verkar ha passerat. Kontakta {email} för att åtgärda detta. Allt kommer att fortsätta som vanligt under tiden."
      },
      "salesResources": {
        "certifiedUser": "Certifierad användare",
        "clearFilter": "Rensa filter",
        "dateRange": "Datumintervall"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "Du kommer att betala {amount} USD/månad, som faktureras {interval}",
        "planUpgradeFailed": "Ditt abonnemang kunde inte uppgraderas!!",
        "planUpgraded": "Ditt abonnemang har uppgraderats!",
        "retryUpgrade": "Försök uppgradera igen",
        "upgradeFailed": "Uppgraderingen av ditt abonnemang misslyckades. Försök igen.",
        "upgradedSuccessfully": "Du har uppgraderat ditt abonnemang {oldPlan} till {newPlan}"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "faktureras som en avgift varje månad på {amount} /månad",
        "billedAsYearlyCharge": "faktureras som en årlig avgift på {amount} per år",
        "upgradeFrom": "Uppgradera från",
        "whatYouWillGet": "Vad du får:"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Saldo efter transaktionen:",
        "callDuration": "Samtalslängd:",
        "callSid": "Samtal-SID:",
        "charge": "Avgift:",
        "contact": "Kontakt:",
        "contactName": "Kontaktens namn:",
        "contactPhone": "Kontaktnummer:",
        "credit": "Kredit:",
        "creditsAfterTransaction": "Krediter efter transaktionen:",
        "dateSent": "Skickat datum",
        "deleted": "<Deleted>",
        "discount": "Rabatt:",
        "eventId": "Händelse-ID:",
        "from": "Från:",
        "noContactFound": "Ingen kontakt hittades",
        "noOfSegments": "Antal segment:",
        "openContactPage": "Öppna kontaktsida",
        "openConversation": "Öppna konversation",
        "openEvent": "Öppna händelse",
        "originalCharge": "Originalavgift:",
        "received": "Mottagen",
        "smsSid": "SMS-SID:",
        "timeBilled": "Fakturerad tid:",
        "timeOfCall": "Tidpunkt för samtal",
        "transactionDetails": "Transaktionsuppgifter –",
        "transactionId": "Transaktions-ID:",
        "type": "Typ:",
        "segments": "Segment"
      },
      "calendarSettings": {
        "meetings": "Möten",
        "services": "Tjänster",
        "hideCalendarWarning": "Om du vill dölja kalendermodulen helt kan du göra det från Inställningar för underkonto > Min personal > Roller och behörigheter.",
        "calendarSettingsUpdated": "Kalenderinställningarna har uppdaterats",
        "meetingDescription": "Aktivera det här alternativet för att tillåta underkonton att använda mötesfunktionen som är utformad för att hantera säljkalendrar, introduktionssamtal, round robin-schemaläggning, teamsamarbeten, kursbokningar, intervjuer med mera. Perfekt för företag som behöver flexibla och samarbetsvänliga schemaläggningsverktyg.",
        "serviceDescription": "Aktivera Tjänster för att ge underkonton tillgång till en komplett bokningslösning för tjänstebaserade företag. Detta inkluderar att skapa bokningssidor med flera tjänster, hantera resurser, hantera flera platser, sätta personalspecifika priser, lägga till tjänstevariationer eller tillägg med mera."
      }
    },
    "apiKeys": {
      "apiKey": "ApiKey",
      "copied": "Kopierad!",
      "copyApiKey": "Kopiera API-nyckel",
      "createApiKey": "Skapa API-nyckel",
      "deleteAllKeys": "Ta bort alla nycklar",
      "nameRequired": "Namnfältet krävs.",
      "somethingWentWrong": "Hoppsan! Något gick fel! Försök igen.",
      "updatedSuccessfully": "Uppdaterad"
    },
    "billing": {
      "accountPaused": "Ditt konto {name} har pausats.",
      "accountProvisioned": "Ditt konto håller på att skapas.",
      "activateSubAccount": "Aktivera underkonto",
      "activeServices": "Aktiva tjänster",
      "addNewCard": "Lägg till nytt kort",
      "addNewService": "Lägg till ny tjänst",
      "addPaymentMethod": "lägg till en betalningsmetod",
      "alertIcon": "alertIcon",
      "approve": "Godkänn",
      "authenticateCardMessage": "För extra säkerhet måste du autentisera dina kortuppgifter igen.",
      "badActorWarning": "Om du tror att det här underkontot har skapats av en bedragare rekommenderar vi att du tar bort underkontot och avbryter det tillhörande abonnemanget.",
      "callUs": "Ring oss",
      "cancelAndDelete": "Annullera abonnemanget och radera underkontot",
      "completeFormNextStep": "Fyll i formuläret i nästa steg",
      "congratulations": "🎉 Grattis! 🎉",
      "contactAgency": "Kontakta din byrå för att åtgärda problemet",
      "contactThroughEmailOrPhone": "Du kan antingen kontakta oss via e-post eller telefon för att lösa detta",
      "dataSafe": "Alla dina data är säkra och alla automatiseringar, webbsidor etc. kommer att fungera igen efter att betalningen har genomförts.",
      "declineSubAccount": "Avböj underkontot",
      "deleteRecommendation": "Det rekommenderas att du tar bort det här underkontot. Eller så kan du göra det senare från sidan Underkonton > Hantera kund.",
      "emailUsAt": "Mejla oss på",
      "moveToDashboard": "Gå till kontrollpanel",
      "noPaymentMethods": "Det verkar som att inga betalningsmetoder har lagts till! Vänligen",
      "paymentMethod": "Betalningsmetod",
      "paymentMethodUpdated": "Din betalningsmetod har uppdaterats",
      "paymentNotCompleted": "Du ser det här meddelandet eftersom betalningen inte har slutförts.",
      "proceedToNextStep": "Fortsätt till nästa steg",
      "questionMark": "?",
      "reachOutMessage": "Kontakta oss gärna om du har några frågor.",
      "reactivateBillingFor": "Återaktivera faktureringen för {location}",
      "retryPayment": "Försök betala igen",
      "secureSystemMessage": "Vi har gått över till ett säkrare faktureringssystem.",
      "setupMessage": "Någon kommer att kontakta dig för att konfigurera kontot. Det tar vanligtvis 12–24 timmar,",
      "signout": "Logga ut",
      "subAccountId": "Underkonto-ID:",
      "successfullyInitiated": "{product} har initierats",
      "systemError": "Det finns ett systemfel",
      "toReactivate": "att återaktivera kontot",
      "userImage": "userImage",
      "verificationSkipped": "E-post- och telefonverifieringen kommer att hoppas över för detta underkonto, och kunden kommer att kunna komma åt det.",
      "verifyAccount": "Verifiera kontot",
      "verifyAfterAttempt": "Du kan verifiera det här kontot efter minst ett verifieringsförsök från underkontoadministratören",
      "verifySubAccount": "Verifiera underkontot",
      "recommendedPlans": "Rekommenderade abonnemang",
      "buildYourOwnPlan": "BYGG DIN EGEN PLAN",
      "resetToDefaults": "Återställ till standardinställningarna",
      "paymentMethodChange": "Om du behöver byta betalningsmetod",
      "approveSubAccount": "Godkänn underkontot",
      "approveSubAccountDescription": "Underkontot kommer att återupptas och administratörerna för underkontot kommer att kunna komma åt och använda det.",
      "productInitiated": "Produkten har initierats"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "Den här åtgärden kan inte återkallas.",
      "cancelKeep": "Avbryt, behåll",
      "confirmDeletionInstructions": "Bekräfta borttagningen genom att skriva {word} nedan:",
      "enterConfirm": "Ange {word} för att återskapa",
      "message": "Denna platsens API-nyckel kommer att raderas.",
      "title": "Vill du ta bort platsens API-nyckel?",
      "yesDelete": "Ja, radera"
    },
    "generalDetails": {
      "noPermission": "Du har inte behörighet att ladda upp filer. Kolla dina behörigheter med din byråadministratör.",
      "relatedContacts": "Relaterade kontakter ({count})"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "Är du säker på att du vill ta bort alla API-nycklar för platser?",
      "deleteAllConfirmTitle": "Radera alla API-nycklar för plats?",
      "deleteConfirmMessage": "Detta kommer att ta bort API-nyckeln för plats: {location}. Vill du fortsätta?",
      "deleteAgencyApiKeyConfirmMessage": "Detta kommer att radera API-nyckeln. Vill du fortsätta?",
      "fetchingLocations": "Hämtar platser ...",
      "maxApiKeysMessage": "Du kan ha högst 5 API-nycklar.",
      "noLocationsFound": "Inga platser hittades",
      "old": "Gammal",
      "proPlanRequiredMessage": "Detta är en del av det avancerade API:et som är tillgängligt med Pro-planen.",
      "searchLocation": "Sök efter plats",
      "title": "API-nyckel för plats"
    },
    "locationCard": {
      "deletionScheduledMessage": "Det här underkontot kommer att raderas på {date}, om du har ändrat dig",
      "emailUsageNotRebilled": "E-postanvändning återfaktureras inte",
      "emailUsageRebilled": "E-postanvändning faktureras vidare till din klient",
      "listings": "Annonser",
      "manageClient": "Hantera kund",
      "paymentPending": "Betalning väntar",
      "remainingWalletBalance": "Återstående saldo i plånboken för denna SaaS-plats",
      "requestPaymentAgain": "Begär betalning igen",
      "saasModeActivated": "SaaS-läget är aktiverat",
      "saasModeNotActivated": "SaaS-läget är inte aktiverat",
      "saasSubscriptionNotEnabled": "SaaS-abonnemangsplanen är inte aktiverat",
      "saasSubscriptionRunning": "SaaS-abonnemangsplanen är igång",
      "social": "Social",
      "switchToSaaS": "Byt till SaaS",
      "switchToSubAccount": "Byt till underkonto",
      "telephoneUsageNotBilled": "Telefonanvändning faktureras inte",
      "telephoneUsageRebilled": "Telefonanvändning återfaktureras till din klient",
      "wordpressActive": "Wordpress aktiv",
      "wordpressInactive": "Wordpress inaktiv",
      "wordpressNotSoldYet": "WordPress har inte sålt ännu",
      "wordpressSaleSuccessful": "WordPress-försäljningen har genomförts",
      "yextActive": "Yext aktiv",
      "yextInactive": "Yext inaktiv",
      "yextNotSoldYet": "Yext har inte sålt ännu",
      "yextSaleSuccessful": "Yext-försäljningen har genomförts",
      "reviews": "Recensioner"
    },
    "messageUsage": {
      "acceptTnc": "Acceptera villkoren",
      "cannotPerformAction": "Kan inte utföra den här åtgärden. Kontakta supporten.",
      "currentLimit": "Nuvarande gräns",
      "days": "Dag(ar)",
      "failedToUpdate": "Misslyckades med att uppdatera meddelandeanvändningen",
      "helpCentre": "Hjälpcenter",
      "increaseLimitFurther": "Öka gränsen ytterligare",
      "increaseLimitNow": "Öka gränsen nu",
      "lessThanUsage": "Nuvarande användning är {usage}, och vald användning är mindre än aktuell användning.",
      "lessThanUsageModal": "Nuvarande användning är {usage}, gränsen kan inte vara lägre än den aktuella användningen",
      "limitAlreadyUnlocked": "Gräns är redan upplåst",
      "limitReached": "Gränsen nådd",
      "limitUpdatedFrom": "{type}-gränsen uppdaterades från {old} till {new}",
      "lookingForSmsLimit": "Letar du efter SMS-gräns?",
      "minLimitShould": "Minimigränsen bör vara {limit}",
      "newLimit": "Ny {type}-gräns",
      "perDay": "/ Dag",
      "sameLimit": "Vald gräns är samma som aktuell gräns!",
      "smsLimitLocation": "SMS-gränsen finns nu på platsnivå",
      "smsLimitSettingsInfo": "Du hittar nu inställningarna under Meddelandegräns i Avancerade inställningar.",
      "timesInLast30Days": "Gånger under de senaste 30 dagarna",
      "todaysUsage": "Dagens användning",
      "typePerDay": "{type} / dag",
      "updateLimit": "Uppdatera gräns",
      "updateLimitFor": "Uppdatera {type}-gräns för {name}"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "Aktiva {type}",
      "contactSource": "Kontaktkälla",
      "customer": "Kund",
      "noPastCampaignsWorkflows": "Ingen tidigare {type}",
      "pastCampaignsWorkflows": "Tidigare {type}"
    },
    "settings": {
      "affiliateSettings": "Partnerinställningar",
      "agencyBilling": "Byråfakturering",
      "agencyTeamManagement": "Byråteamhantering",
      "apiKeys": "API-nycklar",
      "compliance": "Efterlevnad",
      "customMenuLink": "Anpassad menylänk",
      "launchpadSettings": "Launchpad-inställningar",
      "phoneSystemTwilio": "Telefonsystem – Twilio",
      "smtpService": "SMTP-tjänst",
      "userSettings": "Användarinställningar",
      "agencySettings": "Byråinställningar",
      "mailgun": "MailGun"
    },
    "snapshot": {
      "errorCreating": "Fel vid skapande av lägesbild",
      "pickAnAccount": "Du måste välja ett konto.",
      "snapshotName": "Lägesbildens namn",
      "snapshotNameRequired": "Du måste ge lägesbilden ett namn"
    },
    "socialDetails": {
      "blogRss": "Blogg RSS",
      "foursquare": "Foursquare",
      "foursquareUrl": "Foursquare URL",
      "googlePlacesId": "Google Plats-ID",
      "googlePlus": "Google+",
      "googlePlusUrl": "Google+ URL",
      "instagramUrl": "Instagram-URL",
      "linkedInUrl": "LinkedIn URL",
      "pinterest": "Pinterest",
      "pinterestUrl": "Pinterest-URL",
      "yelp": "Yelp",
      "yelpUrl": "Yelp URL",
      "youTube": "YouTube"
    },
    "requestSms": "Begäran via SMS",
    "iAlreadyHaveACustomer": "Jag har redan en kund",
    "noAccountFound": "Inget konto hittades!!",
    "thisIs": "Detta är",
    "pleaseEnterValueBetween0To30Days": "Var god ange ett värde mellan 0 och 30 dagar",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Läs om hur du lägger till en engångsavgift för konfiguration av dessa abonnemang",
    "doNotDeleteStripeProductsWarning": "Vänligen <span style=\"font-weight: bold;\">radera inte</span> dessa produkter i ert Stripe-konto",
    "opportunityStats": "Möjlighetsstatistik",
    "createNewSnapshot": "Skapa ny lägesbild",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Byråns kontrollpanel är synlig för",
      "onlyMe": "Bara jag",
      "allAgencyAdmins": "Alla byråadministratörer",
      "stripeConnect": "Kommer snart att tas ur bruk. Byt till Stripe Connect",
      "recommendStripe": "Vi rekommenderar att använda Stripe Connect för ökad säkerhet",
      "switchToStripeConnect": "Byt till Stripe Connect",
      "highLevelAccess": "HighLevel kommer att ha tillgång till dina uppgifter och kan skapa betalningar och kunder på dina vägnar.",
      "stripeAccountWarning": "När Stripe-kontot väl är anslutet kan det inte ändras senare. Vi rekommenderar att du använder ett nytt Stripe-konto som är avsett för Highlevel-intäkter.",
      "connectToStripeAccount": "Anslut till ditt Stripe-konto",
      "unverified": "Stripe-kontot som är kopplat till denna byrå är inte verifierat och kan inte ta emot betalningar. Slutför verifieringen genom att logga in på ditt Stripe-konto.",
      "loginToStripe": "Logga in på Stripe",
      "connectedAccount": "Anslutet konto",
      "verified": "VERIFIERAD",
      "totalPendingBalance": "Totalt utestående saldo",
      "disconnectStripe": "Koppla från Stripe",
      "removeSaasPlanConfigurations": "Ta bort alla SaaS-abonnemangskonfigurationer?",
      "haveSaasPlans": "Du har SaaS-planer skapade i Stripe-kontot!",
      "disconnectWarning": "Om du kopplar bort det går alla SaaS-abonnemang förlorade och du måste skapa dem igen.",
      "acknowledgeDisconnect": "Jag är medveten om att alla mina SaaS-abonnemang kommer att gå förlorade och jag kommer att behöva bygga om dem.",
      "disconnect": "Koppla från"
    },
    "zoomSuccess": {
      "title": "Hoppas du hade en bra upplevelse!",
      "message": "Tack för att du deltog i samtalet. Vi ser fram emot att få välkomna dig igen!"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "Din specialist på provperiodsupplevelser",
      "successSpecialist": "Din framgångsspecialist",
      "supportSpecialist": "Din supportspecialist",
      "jumpOnZoomCall": "Hoppa in i ett Zoom-samtal med mig för ditt uppstartssamtal.",
      "jumpOnChat": "Starta en chatt med mig för att få hjälp",
      "joinVideoCallNow": "Gå med i videosamtalet nu",
      "whatToExpect": "Vad kan man förvänta sig?",
      "helpArticles": "Hjälpartiklar",
      "changelog": "Ändringslogg",
      "ideasBoard": "Idétavla"
    },
    "saasDashboard": {
      "title": "SaaS-kontrollpanel",
      "plansAndPricing": "Abonnemang och prissättning"
    },
    "listAccounts": {
      "newInterfaceAvailable": "Ett renare och snabbare gränssnitt finns nu tillgängligt för den här sidan. Testa gärna!",
      "enableInLabs": "Aktivera i Labs",
      "pendingTransferRequests": "Du har väntande förfrågningar om överföring av underkonton.",
      "otherAgenciesRequested": "Andra byråer har bett om att få överföra underkonton till dig.",
      "reviewRequests": "Recensionsförfrågningar",
      "clientList": "Kundlista (underkonton)",
      "subAccountTransfers": "Överföring av underkonton"
    },
    "implementationModal": {
      "title": "Ditt HighLevel-videosamtal börjar snart!",
      "videoCall": "Videosamtal",
      "whatsNext": "Vad kommer härnäst?",
      "enteringLobby": "Du kommer in i vår lobby tillsammans med andra HighLevel-användare som du!",
      "successConcierge": "Vår Success Concierge hälsar dig välkommen och kopplar dig till nästa tillgängliga rådgivare för ett personligt möte.",
      "haveReady": "Ha följande redo",
      "stableInternet": "Stabil internetanslutning.",
      "videoNameMatches": "Ditt videonamn matchar ditt användarnamn på HighLevel.",
      "estimatedDuration": "Beräknad mötestid",
      "firstVisit": "Första besöket: HighLevel onboarding-session: (45–60 minuter).",
      "returning": "Återkommande: fortsatt hjälp med implementeringen (15–25 minuter).",
      "meetingBegins": "Ditt möte börjar automatiskt om <span class=\"text-[#155EEF]\">{ countdown } sekunder</span>.  Du kan också gå med direkt genom att klicka på knappen nedan:",
      "joinNow": "Gå med nu"
    },
    "gdpr": {
      "logo": "GDPR-logotyp",
      "dataProtection": "Dataskydd och GDPR",
      "introduction": "Introduktion",
      "intro1": "HighLevel har åtagit sig att skydda våra användares och deras kunders integritet. Vi håller oss uppdaterade om utvecklingen inom dataskyddslagar för att säkerställa att du kan vara trygg kring säkerheten när du använder vår plattform.",
      "intro2": "Den här sidan är avsedd att förklara vilka reglerna är, hur de gäller för din användning av HighLevel-plattformen och vilka åtgärder vi har vidtagit för att följa dem.",
      "intro3": " Du bör granska detta dokument samt vår integritetspolicy och kontakta en specialiserad jurist om du behöver mer information eller råd.",
      "gdprRegulation": "Allmänna dataskyddsförordningen (GDPR)",
      "regulation1": "Förordning (EU) 2016/679, mer känd som den allmänna dataskyddsförordningen (GDPR), är en EU-förordning som syftar till att samordna dataskydds- och integritetslagstiftningen i hela EU. Bestämmelserna i GDPR gäller i alla fall där det rör sig om personuppgifter om en registrerad person inom EU.",
      "regulation2": "GDPR syftar till att ge individer större kontroll över hur deras uppgifter används av företag och att göra insamlingen och behandlingen av uppgifter mer transparent.",
      "regulation3": "GDPR införlivades direkt i brittisk lagstiftning efter övergångsperioden för Brexit, vilket innebär att brittiska företag fortfarande måste följa dess bestämmelser genom den ”brittiska GDPR”.",
      "basicConcepts": "Grundläggande GDPR-begrepp",
      "controllerAndProcessor": "Personuppgiftsansvariga och personuppgiftsbiträden",
      "controllerProcessorObligation": "GDPR medför olika skyldigheter för en person beroende på om denne är personuppgiftsansvarig eller personuppgiftsbiträde.",
      "controllerDefinition": " En personuppgiftsansvarig är en enhet som beslutar om behandling av personuppgifter och fattar beslut om grunden för behandlingen och de metoder som ska användas. Personuppgiftsansvariga har vissa skyldigheter gällande personuppgifter, som du bör bekanta dig med innan du samlar in personuppgifter från dina kunder.",
      "processorDefinition": "Ett personuppgiftsbiträde är en enhet som behandlar uppgifter för och på uppdrag av en personuppgiftsansvarig. De fattar inga självständiga beslut om uppgifterna eller deras behandling, eftersom de endast behandlar dem på uppdrag av den personuppgiftsansvarige och måste följa alla instruktioner från den personuppgiftsansvarige.",
      "youAreController": "När du använder HighLevel-tjänsten är du en personuppgiftsansvarig. Du har kontroll över vilka data du laddar upp till HighLevel-systemet, vad du gör med dem och varför. Därför är du ansvarig för att säkerställa att du har en rättslig grund för att behandla uppgifterna, och att du inte lagrar uppgifterna längre än nödvändigt.",
      "highlevelIsProcessor": "Du bör se till att du förstår dina skyldigheter som personuppgiftsansvarig och uppdatera dina egna system och policyer så att laglig överföring av personuppgifter till HighLevel är möjligt. HighLevel är ett personuppgiftsbiträde. Vi lagrar och hanterar de uppgifter du har samlat in enligt dina instruktioner via HighLevel-plattformen. Vi kommer aldrig att använda personuppgifterna som du har laddat upp till HighLevel-systemet för våra egna ändamål eller utan din instruktion.",
      "legalBasisForProcessing": "Rättslig grund för behandling",
      "legalBasisRequirement": "Personuppgifter får endast samlas in och behandlas om det finns en rättslig grund för det. De tillåtna rättsliga grunderna anges i GDPR.",
      "processorReliesOnCustomers": "Som personuppgiftsbiträde förlitar sig HighLevel på att våra kunder väljer rätt grund för insamling och behandling av personuppgifter, och att de utfärdar lämpliga meddelanden och samtycken. Innan du använder HighLevel-tjänsten bör du ta dig tid att identifiera vilken rättslig grund som kan vara tillgänglig för dig och endast samla in och lagra personuppgifter i den utsträckning som är nödvändig för att uppfylla den grunden. Du bör inte ändra grunden för insamling av personuppgifter utan mycket goda skäl, så det är viktigt att förstå kraven för de olika grunderna och se till att du väljer rätt från början.",
      "dataSubjectAccessRights": "De registrerades rättigheter till dataåtkomst",
      "dataSubjectRights": "GDPR ger registrerade personer (dvs. dina kunder) vissa rättigheter avseende deras personuppgifter, inklusive rätten att få tillgång till, korrigera och/eller radera alla uppgifter som rör dem.",
      "highlevelEasySystems": "HighLevel har infört enkla system för att du ska kunna informera oss om du får en sådan begäran från en registrerad person, och för att vi ska kunna informera dig om vi får en sådan begäran. Vi kommer att se till att dessa förfrågningar omedelbart efterlevs i enlighet med dina instruktioner. Du bör bekanta dig med de skyldigheter som åligger dig, inklusive skyldigheter som rör personuppgifter som du lagrar i dina egna system eller tjänster utöver HighLevel.",
      "transfersToUSA": "Överföring av data till USA",
      "transfersRestrictions": "Personuppgifter får inte överföras utanför EES förutom under särskilda omständigheter. Vi använder standardavtalsklausulerna som en del av vårt databehandlingsavtal som vi tecknar med alla våra kunder.",
      "dataSecurity": "Datasäkerhet",
      "securitySafeguards": "Vi har infört strikta säkerhetsåtgärder och skyddsmekanismer för att säkerställa att alla personuppgifter vi hanterar lagras säkert. Vi testar regelbundet våra produkter för att identifiera buggar och sårbarheter.",
      "backupSystems": "Vi ser till att vi har system för regelbunden säkerhetskopiering och system och processer för dataåterställning och dataintegritet för att minimera risken för skadade eller förlorade personuppgifter.",
      "stepsForCompliance": "Åtgärder vi har vidtagit för att säkerställa efterlevnad av GDPR",
      "dutyAsProcessor": "Vi tar våra skyldigheter som personuppgiftsbiträde på största allvar. Vi har infört ett antal rutiner och vidtagit ett antal åtgärder för att säkerställa att vi fortsätter att följa GDPR och att du lagligen kan skicka personuppgifter som du samlat in till oss, till exempel:",
      "standardContractualClauses": "Vårt databehandlingsavtal använder standardavtalsklausuler för att säkerställa att du lagligen kan skicka personuppgifter till oss i USA.",
      "detectBreaches": "Vi kan upptäcka intrång i personuppgifter och informera våra kunder så snart som möjligt.",
      "dealWithAccessRequests": "Vi kan hantera begäran om tillgång till uppgifter och begäran om rätt till radering, och vi ser till att informera dig när en registrerad person har skickat en sådan begäran till oss.",
      "assessedDocumented": "Vi har bedömt och dokumenterat personuppgifterna som vi behandlar för din räkning.",
      "assessedSecurity": "Vi har utvärderat vår säkerhet och uppgraderat den där det behövdes för att säkerställa att den är anpassad till den risknivå vi står inför i samband med ett dataintrång.",
      "dataProcessingAgreement": "Avtal om databehandling",
      "dateUpdated": "Uppdaterat: 1 april 2023",
      "downloadAgreement": "Ladda ner avtalet",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "Har du några frågor?"
    },
    "sendGridSettings": {
      "title": "SendGrid-inställningar",
      "settingsForLocations": "SendGrid-inställningar för platser",
      "sendGrid": "SendGrid",
      "last12Months": "Senaste 12 månaderna",
      "totalSent": "Totalt antal skickade",
      "opens": "Öppnar",
      "clicks": "Klick",
      "bounces": "Avvisade"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Inaktivera Launchpad för alla mina platser.",
      "description1": "Launchpad är en väl genomtänkt landningssida som har visat sig öka kundnöjdheten och kundlojaliteten genom att öka produktanvändningen. ",
      "description2": "Det har visat sig att man kan behålla kunderna under längre tid genom att ansluta GMB, FB, webbchattillägg och att använda mobilappar.",
      "confirmDisable": "Är du säker på att du vill inaktivera Launchpad?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "Det här är din partnerlänk. När personer du känner registrerar sig för ett konto via den här länken får du 40 % av deras månatliga återkommande intäkter under hela livstiden.",
      "appendToUrls": "Lägg till detta i slutet av era URL:er:",
      "needToSignUp": "Behöver du registrera dig?",
      "goToUrl": "Gå till URL:",
      "andSignUpUsing": "och registrera dig med e-postadressen",
      "asYourEmailAddress": "som din e-postadress för FirstPromoter.",
      "pageSettings": "Sidinställningar",
      "facebookPixelId": "Facebook Pixel-ID",
      "pixelId": "Pixel-ID"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "Från och med den 17 juni 2024 kommer Förstärkt kontosäkerhet att aktiveras automatiskt på ditt konto som standard. De förbättrade säkerhetsfunktionerna inkluderar:",
      "discontinuationOfAutoGeneration": "Upphörande av automatisk generering av API-nycklar för plats",
      "exclusionOfApiKeysInLocationCrudApis": "Uteslutning av API-nycklar i API för plats-CRUD",
      "optOutLink": "För att välja bort den här ändringen, inaktivera Förbättrad kontosäkerhet i <a href=\"/settings/company\">Inställningar &gt; Företag</a>",
      "advancedFunctionalityNote": "Detta API är avsett för avancerad funktionalitet. Vårt supportteam kan inte ge direkt hjälp med API-konfigurationen.",
      "developerCouncilInfo": "Vi erbjuder ett utvecklarråd som träffas under kontorstid en gång i månaden (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>) och en Slack-kanal för utvecklargemenskapen där du kan få hjälp från communityn och vårt API-team. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "För att använda Zapier behöver du använda Location API-nyckeln för den specifika platsen. Du kan hämta den från listan nedan eller genom att byta till kontot med hjälp av växlaren i vänstermenyn.",
      "partOfAdvancedApi": "Detta är en del av det avancerade API:et som är tillgängligt med Pro-planen.",
      "upgradeMessage": "Detta är en del av det avancerade API:et som är tillgängligt med Pro-planen. <a>Klicka här</a> för att uppgradera."
    },
    "accountMap": {
      "addAccountManually": "Lägg till konto manuellt"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Inställningar som grupper."
    },
    "accountDetails": {
      "basicDetails": "Grundläggande information",
      "saas": "SaaS",
      "rebilling": "Återfakturering",
      "marketplaceApps": "Marketplace-appar",
      "advancedEmailSettings": "Avancerade inställningar",
      "calendarSettings": "Kalenderinställningar"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Hantera platsinställningarna",
      "disableAddEmailService": "Inaktivera knappen Lägg till e-posttjänst i underkontots inställningar för e-posttjänster",
      "disableAddSmtp": "Inaktivera knappen Lägg till e-posttjänst i underkontots inställningar för e-posttjänster",
      "restrictSubAccountEmailProvider": "Begränsa underkontoanvändarnas möjlighet att lägga till sin egen e-posttjänsteleverantör",
      "disableAddSmtpDescription": "Begränsa underkontoanvändarnas möjlighet att lägga till sin egen e-posttjänsteleverantör",
      "enableReVerification": "Aktivera återverifiering i 90 dagar",
      "locationNoLeadConnector": "Platsen har inte LeadConnector som standard e-postleverantör",
      "lcEmailNotEnabled": "Platsen har inte LeadConnector som standard e-postleverantör",
      "onlyForAgency": "Du kan bara se dessa inställningar aktiverade för byrån",
      "onlyVisibleForAgency": "Du kan bara se dessa inställningar aktiverade för byrån",
      "reVerificationDescription": "Varje e-postverifieringsstatus kommer att återkallas efter 90 dagar (skydda ditt rykte och säkerställ maximal leveransbarhet till inkorgen)"
    }
  },
  "attributes": {
    "addAttribute": "Lägg till attribut",
    "attributeName": "Attributnamn",
    "enterAttributeName": "Ange attributnamn",
    "number": "Nummer",
    "selectAttributeType": "Välj attributtyp"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Ytterligare metadata",
      "title": "Tillagda/uppdaterade fält"
    }
  },
  "bulkActions": {
    "additionalDetails": "Ytterligare information",
    "allOnGivenDate": "Alla på angiven dag",
    "attempted": "Försökt",
    "batchQuantity": "Batchantal",
    "bulkActionProcessing": "Behandling av bulk-åtgärder",
    "bulkActionTitle": "Bulk-åtgärd",
    "campaignRequired": "Kampanj krävs",
    "currentStatus": "Nuvarande status",
    "delayBetweenBatches": "Fördröjning mellan batcher",
    "dispatchMode": "Sändningsläge: {mode}",
    "editBatchQuantity": "Redigera batchantal",
    "emailStats": "E-poststatistik",
    "enterBatchSprintLimit": "Ange en gräns för batchsprint",
    "hideStats": "Dölj statistik",
    "mode": "Läge",
    "nextProcessingOn": "Nästa bearbetning den",
    "noStatsFound": "Ingen statistik hittades",
    "parentBulkActionID": "Överordnat bulkåtgärds-ID",
    "pleaseEnterQuantity": "Ange ett antal",
    "processAllAsSoonAsPossible": "Behandla alla så snart som möjligt",
    "processAllOnGivenDate": "Behandla alla på angivet datum",
    "processDuring": "Bearbeta under",
    "processGraduallyDrip": "Behandla gradvis (dropp)",
    "processingAllowedOn": "Bearbetning tillåten på",
    "restoredBulkActionId": "Återställt bulkåtgärds-ID:",
    "revert": "Ångra",
    "revertedBulkActionId": "Återställt bulkåtgärds-ID:",
    "saveChanges": "Spara ändringar",
    "scheduledStart": "Schemalagd start",
    "showErrorLog": "Visa fellogg",
    "showImported": "Visa importerade",
    "showStats": "Visa statistik",
    "skipped": "Överhoppad",
    "statistics": "Statistik",
    "statuses": {
      "complete": "Slutförd",
      "next-drip": "Nästa gradvisa släpp",
      "notStarted": "Ej påbörjad",
      "processing": "Behandlas",
      "queueing": "Köhantering",
      "reading": "Läser",
      "resumed": "Återupptagen",
      "reverted": "återställd",
      "waiting": "Väntar"
    },
    "successful": "Klar",
    "tagsAdded": "Taggar tillagda",
    "tagsRemoved": "Taggar borttagna",
    "tagsRestored": "Taggar återställda",
    "timeElapsed": "Förfluten tid",
    "totalExported": "Totalt exporterade",
    "totalMerge": "Totalt sammanslagna",
    "unknownError": "Okänt fel",
    "updateBatchQuantity": "Uppdatera batchantal",
    "updated": "Uppdaterad",
    "usesDynamicList": "** Använder dynamisk lista",
    "workflowRequired": "Arbetsflöde krävs"
  },
  "business": {
    "addedToCompany": "Kontakter har lagts till i företaget",
    "cantAddMoreContacts": "Det går inte att lägga till fler än 50 kontakter åt gången",
    "cleanerUi": "Renare användargränssnitt",
    "common": {
      "addContact": "Lägg till kontakt",
      "internalServerError": "Internt serverfel",
      "to": "till"
    },
    "companiesNowHave": "Företag har nu",
    "companyNoteLabsText": "Företagsanteckningar är en labbfunktion",
    "contactRemoveCompany": "Är du säker på att du vill ta bort den här kontakten från företaget?",
    "moreFunctionalUx": "Mer funktionell användarupplevelse",
    "newCompanyUpdate": "Ny företagsuppdatering!",
    "tabs": "Flikar",
    "tasks": {
      "assignTask": "Tilldela uppgift",
      "assignee": "Tilldelad person",
      "deleteTask": "Radera uppgift",
      "editTask": "Redigera uppgift",
      "markAsComplete": "Markera som slutförd",
      "markAsPending": "Markera som väntar",
      "nameAndDescription": "Namn och beskrivning",
      "noTasksAvailable": "Inga aktiviteter tillgängliga"
    },
    "visitLabs": "Besök Labs"
  },
  "calendar": {
    "googleCalendar": "Google Kalender",
    "noSync": "Ingen synkronisering",
    "outlookCalendar": "Outlook-kalender"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Växla frontend-felsökaren"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "Ett fel uppstod, försök igen.",
    "tabs": "Flikar",
    "showPassword": "Visa lösenord",
    "hidePassword": "Dölj lösenord",
    "goToHomepage": "Gå till startsidan",
    "leadConnectorHqLogo": "Lead Connector HQ-logotyp",
    "companyLogo": "Företagslogotyp",
    "countries": {
      "australia": "Australien",
      "austria": "Österrike",
      "czechRepublic": "Tjeckien",
      "belgium": "Belgien",
      "brazil": "Brasilien",
      "canada": "Kanada",
      "chile": "Chile",
      "denmark": "Danmark",
      "switzerland": "Schweiz",
      "germany": "Tyskland",
      "estonia": "Estland",
      "spain": "Spanien",
      "finland": "Finland",
      "france": "Frankrike",
      "uk": "Storbritannien",
      "hongKong": "Hongkong",
      "hungary": "Ungern",
      "ireland": "Irland",
      "italy": "Italien",
      "japan": "Japan",
      "kenya": "Kenya",
      "lithuania": "Litauen",
      "mexico": "Mexico",
      "netherlands": "Nederländerna",
      "newZealand": "Nya Zeeland",
      "norway": "Norge",
      "philippines": "Filippinerna",
      "puertoRico": "Puerto Rico",
      "poland": "Polen",
      "portugal": "Portugal",
      "sweden": "Sverige",
      "singapore": "Singapore",
      "unitedStates": "USA",
      "vietnam": "Vietnam",
      "southAfrica": "Sydafrika"
    },
    "countryshortcodes": {
      "ca": "Kalifornien",
      "eu": "EU",
      "in": "IN",
      "na": "Ej tillgängligt",
      "us": "USA"
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10 ggr",
      "1 (555) 987-6543": "+1 (555) 987-6543",
      "1x": "1x",
      "3x": "3x",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND",
      "gbp": "GBP",
      "sms": "SMS",
      "api": "API",
      "otp": "OTP",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "MOMS",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "Mastercard",
      "dinersClub": "Diners Club",
      "2fa": "2FA",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "&quot; frameborder=&quot;0&quot; scrolling=&quot;auto&quot; width=&quot;100%&quot; height=&quot;500&quot;&gt;</iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Redigera nummerpool – <strong>{name}</strong>",
      "displayphonenumber": "displayPhoneNumber",
      "js_heap_memory": "JS Heap Memory",
      "vuex_store_modules": "Vuex Store-moduler",
      "vuex_store_size": "Vuex Store-storlek",
      "admanagerlogo": "ad-manager-logotyp",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "modellbild",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "filbild",
      "urlimage": "url-image",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}example.com",
      "httpexamplecom": "http://example.com",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com eller utm_campaign=xyz",
      "websitecom": "website.com",
      "strongshakenstirstrongVerifica": "<strong>SHAKEN/STIR-verifiering</strong> är slutförd för ditt underkonto. Skapa förtroende hos dina kunder genom verifierade samtal.",
      "mp3wavfile": "mp3/wav-fil",
      "usd": "$",
      "1_555_9876543": "+1 (555) 987-6543"
    },
    "stepProgress": "Steg {currentStep} av {totalSteps}",
    "loadMore": "Läs in mer",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "1 segment motsvarar ett SMS med 160 tecken. Klicka på ikonen för att få mer information om prissättning.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "1 segment motsvarar ett SMS med 160 tecken. Klicka på ikonen för att få mer information om prissättning.",
    "_email": "/ e-post",
    "_ip": "/ IP-adress",
    "_min": " / min",
    "_of_total": "% av totalen",
    "_please_add_a_payment_method_for": "! Lägg till en betalningsmetod för ",
    "_segment": " / segment",
    "_used": "% använt",
    "a_new_twilio_account_needs_to_be_created_before_we": "Ett nytt Twilio-konto måste skapas innan vi kan börja återfakturera",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "Ett underkonto kan ha upp till tio anpassade objekt. Om gränsen överskrids kommer inga anpassade objekt att skapas från den här lägesbilden.",
    "a_twilio_account_is_already_setup_for_this_location": "Ett Twilio-konto är redan konfigurerat för denna plats",
    "accountName": "Kontonamn",
    "account_sid": "Account SID:",
    "action": "Åtgärd",
    "actions": "Åtgärder",
    "activate": "Aktivera",
    "active": "Aktiv",
    "active_listeners": "Aktiva lyssnare",
    "active_subscriptions": "Aktiva abonnemang",
    "ad_manager": " Annonshanterare",
    "add": "Lägg till",
    "addAction": "Lägg till åtgärd",
    "add_eliza": "Lägg till Eliza",
    "add_image": "Lägg till bild",
    "add_payment_method": "Lägg till betalningsmetod",
    "add_to_account": "Lägg till på kontot",
    "add_user_icon": "Lägg till användarikon",
    "add_your_first_email": "Lägg till din första e-postadress.",
    "address": "Adress",
    "adwords_reporting": "Adwords-rapportering",
    "affiliate_manager": "Partnerhanterare",
    "agency": "Byrå",
    "agency_logo": "byråns logotyp",
    "agency_settings": "Byråinställningar",
    "agent_reporting": "Handläggarrapportering",
    "ai_employee": " AI-medarbetare ",
    "all": "Alla",
    "allow_subaccounts_to_cancel_their_subscription": "Tillåt underkonton att säga upp sina prenumerationer",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Tillåt underkonton att uppgradera till en högre plan",
    "allowed_format": "Tillåtet format:",
    "am": "AM",
    "announcements_click_to_open_in_new_tab": "Meddelanden – klicka för att öppna i en ny flik",
    "answers": "Svar",
    "app_name": "Appens namn",
    "appointments": "Möten",
    "apps": " appar",
    "ask_ai": "Fråga AI",
    "ask_anything": "Fråga om vad som helst ...",
    "assigned_to_another_user": "(Tilldelad till en annan användare)",
    "at_least_one_location_is_required": "Minst en plats krävs",
    "attach_snapshot": "Bifoga lägesbild",
    "attribution_reporting": "Attributionsrapportering",
    "authorized_representative": "Auktoriserad representant",
    "automation_type": "Automationstyp",
    "available_hours": "Tillgängliga timmar",
    "avg_memoryinstance": "Genomsnittligt minne/instans",
    "back": "Tillbaka",
    "base_url": "Bas-URL",
    "between_10_kb_and_5_mb": " Mellan 10 kB och 5 MB",
    "birthday_sms": "Födelsedags-SMS",
    "birthday_sms_with_image": "Födelsedags-SMS med bild",
    "blogging": "Bloggande",
    "bounced": "Avvisade",
    "bulk_requests": "Bulkförfrågningar",
    "business_email": "Företags-e-post",
    "business_hours_configurations": "Konfigurationer för öppettider",
    "business_industry": "Affärsbransch",
    "business_information": "Företagsinformation",
    "business_logo": "Företag Logotyp",
    "business_niche": "Affärsnisch",
    "business_phone": "Företagets telefon",
    "business_physical_address": "Företagets fysiska adress",
    "business_regions_of_operations": "Affärsregioner för verksamhet",
    "business_registration_id_type": "Typ av företagsregistrerings-ID",
    "business_registration_number": "Organisationsnummer",
    "business_type": "Företagstyp",
    "business_website": "Företagets webbplats",
    "busy": "Upptagen",
    "buttons": {
      "cancel": "Avbryt",
      "confirm": "Bekräfta",
      "deleteAll": "Ta bort alla",
      "view": "Visa",
      "close": "Stäng",
      "previous": "Föregående",
      "next": "Nästa",
      "clear": "Rensa",
      "save": "Spara",
      "edit": "Redigera",
      "delete": "Radera",
      "reset": "Återställ",
      "refresh": "Uppdatera",
      "nextLoading": "Nästa...",
      "copied": "Kopierad",
      "notNow": "Inte nu",
      "send": "Skicka",
      "send1": "Skicka",
      "download": "Ladda ner",
      "sendNow": "Skicka nu",
      "saved": "Sparad",
      "back": "Tillbaka",
      "update": "Uppdatera",
      "add": "Lägg till",
      "submit": "Skicka",
      "submitting": "Skickar",
      "done": "Klar",
      "manageUsers": "Hantera användare",
      "no": "Nej",
      "yes": "Ja"
    },
    "calendar": "Kalender",
    "calendar_groups": "Kalendergrupper",
    "call": "Ring",
    "call_reporting": "Samtalsrapportering",
    "call_tracking_is_disabled": "Samtalsspårning är inaktiverat",
    "call_voicemail_settings": "Inställningar för samtal och röstbrevlåda",
    "calls": " samtal",
    "campaign": "Kampanj",
    "campaigns": "Kampanjer",
    "cancel": " Avbryt ",
    "cancel_subscription": "Avbryt Abonnemang",
    "cancelled": "Annullerad",
    "certificates": "Certifikat",
    "change": "Ändra",
    "changed_data": "Ändrad data",
    "charge": " Avgift",
    "charged_to_customer": "Debiteras kunden",
    "chat": "Chatt",
    "chat_user": "Chattanvändare",
    "chat_widget_icon": "Chattwidget-ikon",
    "chats_will_be_saved_for_2_days": "Chattar kommer att sparas i 2 dagar",
    "check": "kontrollera",
    "check_number_validity_before_first_sms_block_incom": "Kontrollera numrets giltighet före första SMS:et, blockera inkommande spamsamtal och sök efter namn på okända uppringare innan Ni svarar i telefon. Ytterligare kostnader tillkommer",
    "cinque_terre": "Cinque Terre",
    "city": "Stad",
    "clear_history": "Rensa historik",
    "click_here": "Klicka här",
    "click_on_create_new_snapshot_to_add_one": " Klicka på Skapa ny lägesbild för att lägga till en.",
    "click_to_access_the_highlevel_welcome_course": "Klicka för att komma åt HighLevels välkomstkurs",
    "click_to_upgrade": "Klicka för att uppgradera",
    "clicked": "Klickad",
    "clio": "Clio",
    "cloning": "Kloning",
    "close_debugger": "Stäng felsökningsverktyget",
    "close_whatsapp_template_creator": "Stäng WhatsApp-mallskaparen",
    "collection": "Samling",
    "columns": "Kolumner",
    "coming_soon": "Kommer snart",
    "company_email_": "Företagets e-post (",
    "complete_component_data": "Fullständig komponentdata",
    "complete_event_data": "Fullständig händelsedata",
    "complete_query_data": "Fullständig frågedata",
    "completed": "Slutförd",
    "complimentary_credits": "Kostnadsfria krediter",
    "component": "Komponent",
    "component_name": "Komponentnamn",
    "component_type": "Komponenttyp",
    "components": " komponenter",
    "condition": "Villkor",
    "confirm": "CONFIRM",
    "confirmation_message": "Bekräftelsemeddelande",
    "confirmed": "Bekräftat",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Prata med en certifierad administratör – klicka för att öppna i en ny flik",
    "connect_with_us_start_live_chat": "Kom i kontakt med oss – starta livechatt",
    "connect_your_stripe_account": "anslut ditt Stripe-konto ",
    "connect_zoom": "Anslut Zoom",
    "consider_leaving_it_blank_should_you_choose_to_use": "Du kan eventuellt lämna den tom om du vill använda den förinställda mötesplatsen",
    "contact": "Kontakt",
    "contact_support": "kontakta support",
    "contact_us_call_highlevel_at_18887324197": "Kontakta oss – ring HighLevel på +1(888)732-4197",
    "contacts": "Kontakter",
    "content_ai": "Content AI",
    "controls": "Kontroller",
    "conversations": "Konversationer",
    "copied": "Kopierad",
    "cost_borne_by_you": " som du står för",
    "count": "Antal",
    "country": "Land",
    "createNewFolder": "Skapa ny mapp",
    "credit_balance": "KREDITSALDO",
    "current_location_id": "Nuvarande plats-ID",
    "custom": "Anpassad",
    "custom_email": "Anpassat e-postmeddelande",
    "custom_niche": "Anpassad nisch",
    "customer_notifications": "Kundaviseringar",
    "customize": "Anpassa",
    "customize_chat_widget": "Anpassa chattwidgeten",
    "dashboard_stats": "Dashboardstatistik",
    "data_keys": "Datanycklar",
    "date": "Datum",
    "days": "Dagar",
    "dedicated_ip": "Dedikerad IP-adress ",
    "default": "Standard",
    "default_snapshots": "Standardlägesbilder",
    "delete": "Radera",
    "deleted": "raderad",
    "delivered": "Levererad",
    "description": "beskrivning",
    "details": "Detaljer",
    "disable_gbp_messaging_not_recommended": "inaktivera GBP-meddelanden (rekommenderas inte)",
    "disable_tracking": "Inaktivera spårning",
    "disabled": "Inaktiverad",
    "dismiss": "Avfärda",
    "display_name": "Visningsnamn",
    "do_not_delete": "radera inte",
    "do_something": "GÖR NÅGOT",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "Vill ni behålla samma eller skapa en ny?",
    "download_application_icon": "Ladda ner applikationsikonen",
    "draft": "Utkast",
    "dropdown_icon": "rullgardinsmenyikon",
    "duplicate": "Duplicera",
    "duration": "Varaktighet",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Eliza Bypass-tagg (valfritt)",
    "eliza_is_required": "Eliza krävs.",
    "eliza_service": "Eliza-tjänst",
    "email": "E-post",
    "email_resell_settings": "Inställningar för återförsäljning av e-post",
    "email_sending": "Utskick av e-post",
    "email_signature": "E-postsignatur",
    "enable": "Aktivera",
    "enable_beta": " Aktivera Beta",
    "enable_company_automation": "Aktivera företagsautomatisering",
    "enable_disable_deprecated_features": "Aktivera/inaktivera föråldrade funktioner",
    "enable_gbp_call_tracking": " Aktivera GBP-samtalsspårning ",
    "enable_gbp_messaging": "aktivera GBP-meddelandetjänster",
    "enable_signature_on_all_outgoing_messages": "Aktivera signatur på alla utgående meddelanden",
    "enabled": "Aktiverad",
    "notEnabled": "Inte aktiverad",
    "enter_a_logical_name": "Ange ett logiskt namn",
    "enter_the_exact_business_address_as_it_appears_in_": "Ange den exakta företagsadressen så som den visas i EIN-listningen.",
    "enter_the_exact_legal_business_name_as_registered_": "Ange det exakta juridiska företagsnamnet, så som det är registrerat hos EIN.",
    "enter_the_full_street_address_as_it_appears_in_the": "Ange hela gatuadressen så som den visas i EIN-listan.",
    "enter_user_email": "Ange användarens e-postadress",
    "enter_user_phone_number": "Ange användarens telefonnummer",
    "enter_your_business_registration_id_type": "Ange typ av företagsregistrerings-ID",
    "enter_your_business_vertical_eg_travel": "Ange din företagsvertikal (t.ex. resor)",
    "error_code": "Felkod",
    "error_code_chart": "Diagram över felkod",
    "error_while_copying_api_key": "Fel vid kopiering av API-nyckel!",
    "event": "Händelse",
    "event_bus_listeners": "Event Bus-bevakare",
    "events": " händelser",
    "everything_in": "Allt i ",
    "exact": "Exakt",
    "execute_this_action_if_the_current_time_falls_in_t": "Exekvera åtgärden om den aktuella tidpunkten infaller i detta tidsfönster, annars vänta tills nästa tidsfönster för att exekvera åtgärden.",
    "extension": "Tillägg",
    "facebook": "Facebook",
    "facebook_ads": "Facebook Ads",
    "facebook_ads_reporting": "Rapportering av Facebook-annonser",
    "facebook_adsets": "Facebook AdSets",
    "facebook_campaigns": "Facebook-kampanjer",
    "facebook_icon": "Facebook-ikon",
    "facebook_page": "Facebooksida",
    "feature_image": "bildfunktion",
    "features": "Funktioner:",
    "feedback": "Feedback: ",
    "file_path": "Filsökväg",
    "firestore_listeners": "Firestore-lyssnare",
    "forms": "Formulär",
    "free": "Gratis",
    "fri": "fre",
    "friendly_business_name": "Vänligt företagsnamn",
    "from": " från ",
    "funnels": "försäljningsprocesser",
    "gbp_call_tracking": "GBP-samtalsspårning",
    "gbp_configuration": "GBP-konfiguration",
    "general": "Allmänt",
    "general_information": "Allmän information",
    "generating_link_please_wait": "Genererar länk, vänligen vänta...",
    "google_ads_adgroups": "Google Ads-annonsgrupper",
    "google_ads_ads": "Google Ads-annonser",
    "google_ads_campaigns": "Google Ads-kampanjer",
    "google_ads_keywords": "Google Ads-nyckelord",
    "google_business_messaging": "Google Business Messaging",
    "google_business_profile": "Google Business Profile",
    "google_my_business_icon": "Google My Business-ikon",
    "hello": "Hej ",
    "here": "här",
    "hhmm_a": "tt:mm A",
    "hi": "Hej ",
    "hide": "Dölj",
    "highlevel_events_click_to_open_in_new_tab": "Highlevel Events – klicka för att öppna i ny flik",
    "how_can_i_help_you_today": "Hur kan jag hjälpa dig idag?",
    "how_did_the_call_go": "Hur gick samtalet?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "Hur beräknar jag min e-postkostnad? Klicka på ikonen om du vill veta mer",
    "how_does_it_work": "Hur det fungerar",
    "htmlElement": "HTML-element (TODO):",
    "html_element_todo": "HTML-element (TODO): ",
    "id": "ID: ",
    "if": "Om",
    "if_activated_the_sender_information_will_be_automa": "Om det är aktiverat kommer avsändarinformationen automatiskt att läggas till i det första SMS:et i alla bulkmeddelanden för att säkerställa efterlevnad och högre leveransfrekvens.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "Om det är aktiverat kommer vi att infoga länkar för avregistrering i sidfoten på dina e-postmeddelanden så att mottagarna kan avregistrera sig utan att markera e-postmeddelandet som ett klagomål eller skräppost.",
    "ignore_this_update": "Ignorera denna uppdatering",
    "image": "bild",
    "image_turned_on": "Bild aktiverad",
    "imported_date": "Importerad den",
    "imported_snapshots": "Importerade lägesbilder",
    "inbound": "Inkommande",
    "inbound_number": "Inkommande nummer",
    "incoming_call_timeout": "Timeout för inkommande samtal",
    "instance_id": "Instans-ID",
    "instances": "Instanser: ",
    "instructions_mentioned_in_this_page": "instruktionerna som nämns på denna sida",
    "internal": "Internt",
    "intro_message": "Introduktionsmeddelande",
    "intro_question": "Introduktionsfråga",
    "invalid": "Ogiltig",
    "invoicing": "Fakturering",
    "is_scheduled_for_deletion_on": " är schemalagd för radering den ",
    "job_position": "Jobbposition",
    "job_title": "Jobbtitel",
    "join_our_facebook_group_click_to_open_in_new_tab": "Gå med i vår Facebook-grupp – klicka för att öppna i ny flik",
    "jpg_or_png": " JPG eller PNG ",
    "just_one_sec": "Bara en sekund...",
    "key_sizes": "Viktiga storlekar",
    "label": "etikett",
    "labels": {
      "sortDirection": "Sorteringsriktning",
      "tableStyling": "Tabellstil",
      "loadingMore": "Läs in fler ...",
      "loading": "Läser in ...",
      "filter": "Filter",
      "search": "Sök ...",
      "sortBy": "Sortera efter",
      "perPage": "Per sida",
      "date": "Datum",
      "time": "Tid",
      "readMore": "Läs mer",
      "day": "Dag",
      "slot": "Tidslucka",
      "template": "Mall",
      "city": "Stad",
      "country": "Land",
      "state": "Status",
      "customerName": "Kundens namn",
      "friendlyName": "Vänligt namn",
      "required": "* krävs",
      "addressLine1": "Adressrad 1",
      "addressLine2": "Adressrad 2",
      "postalCode": "Postnummer",
      "searchUsers": "Sök efter användare",
      "unknown": "Okänd",
      "businessName": "Företagsnamn"
    },
    "last_updated": "Senast uppdaterad",
    "launchpad_icon": "Launchpad-ikon",
    "lead": "Potentiell kund",
    "leadconnector": "LeadConnector",
    "learn_how": "(Lär dig hur?)",
    "legal_business_name": "Juridiskt företagsnamn",
    "limit_updated_from": " gräns uppdaterad från ",
    "listeners": " lyssnare",
    "loading_your_conversation_history": "Läser in din konversationshistorik ...",
    "location": "Plats",
    "locations": " platser",
    "logical_name": "Logiskt namn",
    "logical_name_is_required": "Logiskt namn krävs.",
    "logo": "Logotyp",
    "mailgun": "MailGun",
    "making_calls": "Ringa samtal",
    "manage_custom_email": "Hantera anpassad e-post",
    "marketing": "Marknadsföring",
    "maximize": "Maximera",
    "me_": "Mig (",
    "member_since": "Medlem sedan",
    "membership": "Medlemskap",
    "memory_analysis": "Minnesanalys",
    "memory_api_not_available": "Memory API är inte tillgängligt",
    "message": "Meddelande",
    "minimize": "Minimera",
    "minimum_must_be": " Minsta antal måste vara ",
    "miscellaneous_charges": "Övriga avgifter",
    "missed_call_text_back": "Textåterkoppling för missat samtal",
    "missed_text_back_call_message": "Meddelande i textåterkoppling för missat samtal",
    "model": "Modell",
    "module": "Modul",
    "modules": " moduler",
    "mon": "Mån",
    "month": "/månad",
    "monthly": "varje månad",
    "more_emails_in_thread": " fler e-postmeddelanden i tråden",
    "mount_count": "Montera antal",
    "mount_time": "Monteringstid",
    "moved_to_calendar_settings": "Flyttad till kalenderinställningarna",
    "multiple_locations_using_same_twilio_account": "Flera platser använder samma Twilio-konto",
    "must_be_in_range_of_0": " Måste vara inom intervallet 0-",
    "must_be_less_than_monthly_plan_12": " Måste vara mindre än månadsplan * 12 ",
    "my_business_is": "Mitt företag är ",
    "my_snapshots": "Mina lägesbilder",
    "name": "Namn",
    "name_of_other_registration_id_type": "Namn på annan typ av registrerings-ID",
    "newFolder": "Ny mapp",
    "new_task_update": "Ny uppdatering av uppgift!",
    "next": "Nästa",
    "no_answer": "Inget svar",
    "no_bigger_than_25mb": "inte större än 2,5 MB",
    "no_customer_selected": "Ingen kund vald",
    "no_error_data_found": "Inga feldata hittades",
    "no_payment_method_available": "Ingen betalningsmetod tillgänglig",
    "no_provider_found": "Ingen leverantör hittades",
    "no_snapshots_found": "Inga lägesbilder hittades!",
    "noshow": "Uteblev",
    "not": "Inte",
    "not_now": "Inte nu",
    "not_saved": "Ej sparad",
    "notes": "Anteckningar",
    "notifications": "Aviseringar",
    "now": "Nu",
    "numbers_and": " nummer och ",
    "objective": "Mål:",
    "of": "av",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Introduktionsvideohandledningar – klicka för att öppna i en ny flik",
    "online_listings": "Onlineannonser",
    "only_assigned_data": "Endast tilldelade data",
    "open_performance_debugger": "Öppna prestandafelsökare",
    "opened": "Öppnad",
    "opportunities": "Möjligheter",
    "options": {
      "ascending": "Stigande",
      "descending": "Fallande",
      "none": "-- Inga --"
    },
    "or_drag_and_drop": "eller dra och släpp",
    "outbound": "Utgående",
    "pagination": "Sidnumrering",
    "pass_body_content_here": " Sätt brödtextinnehåll här ",
    "password": "Lösenord",
    "paused": "Pausad",
    "payment_links": "Betalningslänkar",
    "payment_methods": "Betalningsmetoder",
    "payment_refund": "Återbetalning av betalning",
    "payment_settings_navigation": "Navigering för betalningsinställningar",
    "payments": "Betalningar",
    "payments_integration": "Betalintegrering",
    "pending": "Väntar",
    "per_page": "Per sida",
    "percentage": "Procentsats",
    "permanently_delete_this_email": "Radera denna e-postadress permanent",
    "personal_logo": "Personlig logotyp",
    "phone": "Telefon",
    "phone_number_with_country_code": "Telefonnummer (med landskod)",
    "pick_a_niche": "Välj en nisch",
    "pick_a_snapshot": "Välj en lägesbild",
    "pick_business_industry": "Välj affärsbransch",
    "pick_business_registration_id_type": "Välj typ av företagsregistrerings-ID",
    "pick_business_type": "Välj företagstyp",
    "pick_job_position": "Välj jobbposition",
    "plans_pricing": "Abonnemang och prissättning",
    "please_enter_a_value_greater_than_20": "Var god ange ett värde som är större än 20.",
    "pm": "PM",
    "points": "Poäng",
    "postalzip_code": "Postnummer",
    "previous": "Föregående",
    "privacy_policy_url": "URL för integritetspolicy",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "Integritetspolicyns URL kommer att visas i din Google-agentinformation.",
    "process_your_payment": "Behandla din betalning",
    "profile_picture": "Profilbild",
    "profit": "Vinst",
    "prospecting": " Prospektering ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Ge de nya kontona lägesbilder före versioner.",
    "queries": " frågor",
    "questions": "Frågor",
    "quick_actions_icon": "Snabbåtgärdsikon",
    "re_generate_key": "Generera om nyckel",
    "read_only": "Skrivskyddad",
    "receipts_settings": "Kvittoinställningar",
    "receiving_calls": "Ta emot samtal",
    "recent_events": "Senaste händelser",
    "recommended": "Rekommenderad",
    "recommended_resolution": "Rekommenderad lösning:",
    "reconnect": "Återanslut ",
    "record_payment": "Registrera betalning",
    "registered": " registrerad.",
    "renameFolder": "Byt namn på mapp",
    "replied": "Svarade",
    "representative_email": "Representantens e-post",
    "resell_settings": " Återförsäljningsinställningar",
    "reset": "Återställ",
    "resolve_now": "Åtgärda nu",
    "resource_counts": "Resursantal",
    "restore": "Återställ",
    "results": "Resultat",
    "reviews": "Recensioner",
    "rollover_unused_credits_to_next_month": "Överför outnyttjade krediter till nästa månad",
    "row": " rad",
    "runNow": "Kör nu",
    "sample_data": "(Exempeldata)",
    "sat": "lör",
    "save": "Spara",
    "save_missed_call_text_settings": "Spara inställningar för missade samtal",
    "save_staging_url": "Spara URL för testmiljö",
    "saved": "Sparad",
    "saving": "Sparar ...",
    "search": "Sök",
    "search_active_apps": "Sök efter aktiva appar ...",
    "search_components": "Sök efter komponenter ...",
    "search_customer": "Sök efter kund",
    "search_email": "Sök efter e-post",
    "search_history": "Sök historik ...",
    "search_icon": "sök-ikon",
    "search_listeners": "Sök efter lyssnare ...",
    "search_modules": "Sök i moduler ...",
    "search_queries": "Sök frågor ...",
    "see_this_review_on_gbp": "Se den här recensionen på GBP ",
    "segments": " segment",
    "select": "Välj",
    "select_a_snapshot": "Välj en lägesbild",
    "monetary": "MONETÄRT",
    "pleaseSelectAValue": "Välj ett värde",
    "select_account": "Välj konto",
    "select_an_account": "Välj ett konto",
    "select_eliza_bypass_tag": "Välj Eliza Bypass-tagg",
    "select_phone_number": "Välj telefonnummer",
    "select_send_to_eliza_tag": "Välj Skicka till Eliza-tagg",
    "select_snapshot": " Välj lägesbild",
    "select_upto": "Välj högst ",
    "selected": "Valt: ",
    "send": "Skicka",
    "send_to_eliza_tag_optional": "Skicka till Eliza-tagg (valfritt) ",
    "seo": " SEO ",
    "settings": "Inställningar",
    "setup_pending": "Konfiguration väntar",
    "share": "Dela",
    "shared_snapshots": "Delade lägesbilder",
    "shared_type": "Delad typ",
    "shipping_and_delivery": "Frakt och leverans",
    "shipping_origin": "Avsändningsort",
    "show": "Visa",
    "showed": "Deltog",
    "signin_with_single_signon": "Logga in med enkel inloggning",
    "size": "Storlek",
    "sms_message_sent_to_customer": "SMS skickat till kund",
    "snapshot_date": "Datum för lägesbild",
    "snapshot_name": "Lägesbildens namn",
    "social_planner": "Planering för sociala medier",
    "sortBy": "Sortera efter",
    "sortOptions": {
      "createdDate": "Skapad den"
    },
    "source": "Källa",
    "sources": "Källor:",
    "spent": "Spenderat",
    "staging_url_settings_for_db_event": "Inställningar för testmiljöns URL (för databashändelse)",
    "state": "Delstat",
    "state_prov_region_": "Delstat/provins/region *",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alaska",
      "arizona": "Arizona",
      "arkansas": "Arkansas",
      "california": "Kalifornien",
      "colorado": "Colorado",
      "connecticut": "Connecticut",
      "delaware": "Delaware",
      "district_of_columbia": "District of Columbia",
      "florida": "Florida",
      "georgia": "Georgia",
      "hawaii": "Hawaii",
      "idaho": "Idaho",
      "illinois": "Illinois",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Kansas",
      "kentucky": "Kentucky",
      "louisiana": "Louisiana",
      "maine": "Maine",
      "maryland": "Maryland",
      "massachusetts": "Massachusetts",
      "michigan": "Michigan",
      "minnesota": "Minnesota",
      "mississippi": "Mississippi",
      "missouri": "Missouri",
      "montana": "Montana",
      "nebraska": "Nebraska",
      "nevada": "Nevada",
      "new_hampshire": "New Hampshire",
      "new_jersey": "New Jersey",
      "new_mexico": "New Mexico",
      "new_york": "New York",
      "north_carolina": "North Carolina",
      "north_dakota": "North Dakota",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregon",
      "pennsylvania": "Pennsylvania",
      "rhode_island": "Rhode Island",
      "south_carolina": "South Carolina",
      "south_dakota": "South Dakota",
      "tennessee": "Tennessee",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermont",
      "virginia": "Virginia",
      "washington": "Washington",
      "west_virginia": "West Virginia",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "Inga poster hittades",
      "noEntriesToShow": "Inga poster att visa",
      "unsuccessful": "Misslyckades",
      "pending": "Väntar",
      "noUsersFound": "Inga användare hittades"
    },
    "status": "Status",
    "stop_delete_operation": "Avbryt raderingsåtgärden",
    "street_address": "Gatuadress",
    "street_address_as_it_appears_in_the_ein_listing": "Gatuadress så som den visas i EIN-listningen.",
    "stripe_icon": "Stripe-ikon",
    "stripe_integration": "Stripe-integration",
    "stripe_secret_key": "Hemlig Stripe-nyckel",
    "subscriptions": "Abonnemang",
    "sun": "sön",
    "surveys": "Undersökningar",
    "suspend_subaccount_when_their_saas_subscription_fa": "Stäng av underkontot när deras SaaS-prenumeration misslyckas.",
    "switchAccount": "Byt konto",
    "switch_off_sections_below_to_disable": "Stäng av sektionerna nedan för att inaktivera",
    "tags": "Nyckelord",
    "tax_settings": "Skatteinställningar",
    "team_management": "Teamhantering",
    "team_notifications": "Teamaviseringar",
    "template": "Mall",
    "terms_and_conditions": "Regler och villkor",
    "test_mobile_no": "Testa mobilnummer",
    "text_messages": "SMS",
    "the_proposed_size_is_350px_180px": "Den föreslagna storleken är 350px * 180px",
    "the_proposed_size_is_512512px": "Den föreslagna storleken är 512*512 px",
    "the_selected_language_will_be_used_by_the_system_a": "Det valda språket kommer att användas av systemet som standard.",
    "the_welcome_message_automatically_appears_after_a_": "Välkomstmeddelandet visas automatiskt efter att en användare startar en ny konversation.",
    "these_are_margins_that_are_billed_to_your_clients_": "Det här är marginaler som faktureras till dina kunder utöver ",
    "this_data_will_be_used_for_future_compliance_regis": "Dessa data kommer att användas för framtida efterlevnadsregistrering.",
    "this_is_my_twilio_use_same": "Detta är mitt Twilio-konto, använd samma",
    "this_is_visible_to_both_agency_and_location": "Detta är synligt både för byrån och platsen",
    "this_name_will_be_visible_to_leads_chatting_with_y": "Det här namnet kommer att synas för potentiella kunder som chattar med ditt företag",
    "this_setting_is_applicable_with_only_team_calendar": "Den här inställningen är endast tillämplig på teamkalendrar.",
    "this_stripe_customer_is_already_connected_to_anoth": "Denna Stripe-kund är redan ansluten till ett annat underkonto.",
    "thu": "tors",
    "tiktok": "Tiktok",
    "time_signed": " Tid för underskrift: ",
    "time_zone_": "Tidszon *",
    "timestamp": "Tidsstämpel",
    "title": "Titel",
    "to_resolve_this_problem_follow_the": "För att åtgärda detta problem, följ ",
    "token": "Token:",
    "total": "Totalt: ",
    "trigger_link": "Utlösarlänk",
    "triggers": "Utlösare",
    "tue": "tis",
    "twilio": "Twilio",
    "twilio_setup_pending": "Twilio-konfiguration väntar",
    "type": "Typ",
    "type_campaign_objective": "Ange kampanjmål",
    "type_message": "Skriv ett meddelande",
    "unsavedChangesWarning": "Dina ändringar kommer inte att sparas. Är du säker på att du vill lämna sidan?",
    "unsaved_changes": "Osparade ändringar",
    "unsubscribed": "Avprenumererade",
    "unsuccessful": "Misslyckades",
    "update_business_profile_details": "Uppdatera företagsprofilens detaljer",
    "update_is_inprogress_visit_integrations_page_to_fi": "Uppdatering pågår, besök integrationssidan för att få mer information.",
    "update_url": "Uppdatera URL",
    "updated_date": "Uppdaterad den",
    "updates": " uppdateringar",
    "updating": "Uppdaterar ...",
    "upgrade_to_agency_pro": "uppgradera till Agency Pro ",
    "upload": "Ladda upp",
    "upload_a_file": "Ladda upp en fil",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Använd detta för Zapier- och API-integration.",
    "user_email": "Användarens e-postadress",
    "user_permissions": "Användarbehörigheter",
    "user_role": "Användarroll",
    "user_type": "Användartyp",
    "valid": "Giltig",
    "verification_status": "Verifieringsstatus",
    "verify": "Verifiera",
    "verify_email_using_otp": "Verifiera e-post med OTP",
    "view_less": " Visa mindre ",
    "visiblehidden": "Synlig/Dold",
    "visit_our_help_center_click_to_open_in_new_tab": "Besök vårt hjälpcenter – klicka för att öppna i en ny flik",
    "voicemail": "Röstbrevlåda",
    "wave_integration": "Wave-integration",
    "we_have_found_some_errors_in_your_contact_fields_c": "Vi har hittat några fel i dina kontaktfält. Klicka på mappen för att visa och lösa.",
    "websites": "Webbplatser",
    "wed": "ons",
    "welcome_message": "Välkomstmeddelande",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "WhatsApp-ikon",
    "when": "När",
    "when_selected_calls_will_be_routed_to_your_mobile_": "När valda samtal kommer att vidarekopplas till din mobilapp. (Stöds i både iOS och Android)",
    "when_selected_calls_will_be_routed_to_your_web_app": "När valda samtal kommer att vidarekopplas till din webbapp.",
    "which_business_do_you_want_to_link_to_this_locatio": "Vilket företag vill du länka till den här platsen?",
    "widget_code": "Widgetkod",
    "will_give_you_about": " kommer att ge er ungefär",
    "wordpress": "WordPress",
    "wordpress_icon": "WordPress-ikon",
    "workflows": "Arbetsflöden",
    "xero_integration": "Xero-integration",
    "you_need_to_complete_few_easy_steps_to_delete_this": "Du måste slutföra några enkla steg för att radera den här platsen",
    "you_are_not_authorized_to_perform_this_action_only": "Du är inte behörig att utföra den här åtgärden. Endast byråadministratörer kan ta bort underkonton.",
    "your_email_cost": "Er e-postkostnad",
    "your_facebook_page_has_been_integrated_however_the": "Din Facebook-sida har integrerats. Dock kommer följande funktioner inte att fungera eftersom LeadConnector inte har de nödvändiga behörigheterna. ",
    "your_outlook_connection_has_expired_please_disconn": "Din Outlook-anslutning har löpt ut. Koppla bort och återanslut sedan till kontot för att upprätta anslutningen.",
    "zip_code": "Postnummer",
    "zoom_connected_please_close_this_modal": "Zoom anslutet, stäng denna modal",
    "hidden": "Dold",
    "messageDetails": "Information om meddelandet",
    "openOptions": "Öppna alternativ",
    "progress": "Framsteg",
    "close": "Stäng",
    "loading": "Läser in",
    "fullName": "Fullständigt namn",
    "languages": "Språk",
    "phoneNumber": "Telefonnummer",
    "phoneNumberWithCountry": "Telefonnummer med landskod",
    "sendMessage": "Ladda upp Meddelande",
    "services": "Tjänster",
    "servicesProvided": "Tillhandahållna tjänster",
    "pleaseProvideAValid": "Ange ett giltigt telefonnummer.",
    "copy": "Kopiera",
    "editApiKey": "Redigera API-nyckel",
    "confirmPay": "Bekräfta och betala",
    "contactUs": "Kontakt oss",
    "decline": "Avböj",
    "deleteSubaccount": "Radera underkontot",
    "disabled1": "inaktiverad",
    "purchaseSummary": "Sammanfattning av köp",
    "subscriptionPlan": "Abonnemangsplan",
    "businessName": "Visningsnamn för WhatsApp Företag",
    "chooseOne": "Välj en …",
    "stateProvRegion": "Delstat/provins/region",
    "streetAddress": "Gatuadress",
    "timeZone": "Tidszon",
    "website": "Webbplats",
    "zipPostalCode": "Postnummer",
    "apiKey": "API-nyckel",
    "createdAt": "Skapad",
    "deleteAllLocationApi": "Radera alla API-nycklar för plats",
    "deleteApiKey": "Ta bort API-nyckel",
    "generatedBy": "Skapad av",
    "lastUsedAt": "Senaste användningstidpunkt",
    "pageNavigation": "Sidnavigering",
    "somethingWentWrong": "Någonting gick fel!",
    "clickHere": "Klicka här",
    "emailRebillingActive": "Återfakturering via e-post är aktiv",
    "saasSubscriptionActive": "SaaS-abonnemanget är aktivt",
    "scheduledForDeletion": "Schemalagd för radering",
    "twilioRebillingActive": "Återfakturering via Twilio är aktiv",
    "iAcknowledgeThisIs": "Jag bekräftar att detta är ett giltigt underkonto och jag har verifierat användningsfallet för att skicka mer än {limit} {type} /dag",
    "iAcknowledgeThisIs1": "Jag bekräftar att detta är ett giltigt underkonto och jag har verifierat användningsfallet för att skicka och därmed justera den dagliga SMS-gränsen.",
    "emailSentByLocation": "E-post skickade av plats hittills idag.",
    "goToSmsLimit": "Gå till SMS-gränsinställningar",
    "toIncreaseTheLimit": "För att höja gränsen ytterligare, kontakta supportteamet.",
    "newLimitOfLimit": "Den nya gränsen för {limit} är ogiltig. Ange ett värde mellan {min} och {max}",
    "typeLimitUpdatedSuccessfully": "{type} -gränsen har uppdaterats",
    "locationsCurrentLimitIs": "Platsens nuvarande gräns är {current}. Du kan bara uppdatera gränsen mellan {min} och {max} härifrån. För eventuella gränsuppdateringar utöver {maxAllowed}, kontakta supportteamet.",
    "notNow": "Inte nu",
    "smsSentByLocation": "SMS skickade av plats hittills idag.",
    "youHaveSuccessfullyUpdated": "Du har framgångsrikt uppdaterat gränsen",
    "willAutoUnlockIn": "Kommer att låsas upp automatiskt om",
    "contactType": "Kontakttyp",
    "createdBy": "Skapad av:",
    "createdOn": "Skapad den:",
    "dateOfBirth": "Födelsedatum",
    "emailAddress": "E-postadress",
    "firstName": "Förnamn",
    "lastName": "Efternamn",
    "twilioLookupMarkedThis": "Twilio Lookup markerade detta telefonnummer som ogiltigt.",
    "twilioLookupStatedThis": "Twilio Lookup uppgav att detta är ett {type} -nummer, så det kan inte ta emot SMS.",
    "accountSnapshot": "Kontoöversikt",
    "auditLogs": "Granskningsloggar",
    "account": "Konto",
    "selectAccount": "Välj konto",
    "facebookUrl": "Facebook-URL",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "Twitter",
    "twitterUrl": "Twitter-URL",
    "youtubeUrl": "YouTube-URL",
    "text": "Text",
    "allTagsLinkedTo": "Alla taggar som är kopplade till de markerade kontakterna bör tas bort",
    "automation": "Automatisering",
    "bulkOperation": "Bulk-process",
    "campaign1": "Kampanj",
    "created": "Skapad",
    "dateTime": "Datum och tid",
    "description1": "Beskrivning",
    "drip": "Drip",
    "edit": "Redigera",
    "someStatsAreNot": "Vissa statistikuppgifter är inte tillgängliga om leverantören är SMTP. Mätvärdenas noggrannhet beror på mottagarens domän.",
    "error": "Fel",
    "from1": "Från",
    "immediately": "Omedelbart",
    "pause": "Pausa",
    "processed": "Bearbetad",
    "queued": "I kö",
    "restored": "Återställd",
    "resume": "Återuppta",
    "sent": "Skickat",
    "scheduled": "Schemalagd",
    "success": "Framgång",
    "templateName": "Mallnamn",
    "total1": "Totalt",
    "totalAttempted": "Totalt antal försök",
    "user": "Användare",
    "viewDetails": "Visa detaljer",
    "workflow": "Arbetsflöde",
    "company": "Företag",
    "note": "Anteckning",
    "perPage": "per sida",
    "showing": "Visning",
    "task": "Uppgift",
    "tasks": "Uppgifter",
    "customFields": "Anpassade fält",
    "dueDate": "Förfallodatum",
    "tryNow": "Prova nu!",
    "archive": "Arkivera",
    "markAsRead": "Markera som läst",
    "markAsUnread": "Markera som oläst",
    "youNeedToAdd": "Du måste lägga till en kalender för att börja schemalägga möten.",
    "additionalNotes": "Ytterligare anteckningar",
    "appointmentStatus": "Mötesstatus",
    "appointmentTitle": "Mötestitel",
    "contactName": "Kontaktens namn",
    "contactTimezoneUsedFor": "Kontaktens tidszon (används för påminnelse)",
    "day": "Dag",
    "editAppointment": "Redigera möte",
    "nameRequired": "Namnet krävs",
    "slotRequired": "Tidslucka krävs",
    "teamMemberIsRequired": "Teammedlem krävs.",
    "meetingLocation": "Mötets plats",
    "pickTeamMember": "Välj teammedlem",
    "phoneNumbers": "Telefonnummer",
    "roundRobin": "Round Robin",
    "selectCalendar": "Välj kalender",
    "selectTeamMember": "Välj teammedlem",
    "actionRequired": "Åtgärd krävs",
    "scheduleAppointment": "Schemalägg möte",
    "considerLeavingItBlank": "Du kan eventuellt lämna den tom om du vill använda den förinställda mötestiteln",
    "assignedTo": "Tilldelad till",
    "download": "Ladda ner",
    "loadingTranscription": "Läser in transkription ...",
    "mute": "Tysta",
    "playpause": "Spela upp/pausa",
    "playbackSpeed": "Uppspelningshastighet",
    "remove": "Ta bort",
    "stop": "Stopp",
    "timePlayedTotalTime": "Uppspelad tid : Total tid",
    "viewTranscript": "Visa transkription",
    "below": "under",
    "calls1": "Samtal",
    "liveChat": "Livechatt",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Chattsamtal tilldelat",
    "youAreChoosingNot": "Du väljer att inte ta bort och stänga LC Phone-underkontot, vilket innebär att du fortfarande kommer att debiteras för all användning oavsett om platsen debiteras eller inte.",
    "thingsAreJustGetting": "Det här är bara början, nu ska vi utforska hur GHL kan hjälpa dig att bygga upp ditt företag.\nUnder tiden kan du fortsätta skicka meddelanden så mycket du vill",
    "wohooConversationsAreFlowing": "Jippie! Konversationerna flyter på nu",
    "conversationBegan": "Konversationen inleddes",
    "fetchOlderMessages": "Hämta äldre meddelanden",
    "inboundDndHasBeen": "Inkommande DND har aktiverats för den här kontakten",
    "internalComment": "Intern kommentar",
    "confirmByTyping": "Bekräfta genom att skriva",
    "iConfirmToDisconnect": "Jag bekräftar att koppla från och stänga LC Phone-kontot för den här platsen. Jag är medveten om att detta skulle innebära att alla nummer och A2P-kampanjer kommer att raderas och inte kan återställas.",
    "iConfirmThatI": "Jag bekräftar att jag har diskuterat detta med min kund och har befogenhet att vidta denna åtgärd",
    "connect": "Anslut",
    "disputeThisReview": "Bestrid den här recensionen",
    "dndIsActiveFor": "DND är aktivt för samtal",
    "off": "AV",
    "done": "Klar",
    "downloadFile": "Ladda ner filen",
    "AddAccount": "+ Lägg till ett konto",
    "attachFile": "Bifoga fil",
    "clickHereToAdd": "Klicka här för att lägga till en.",
    "customerName": "Kundens namn",
    "customerPhone": "Kundens telefonnummer",
    "orEnterAMessage": "Eller ange ett meddelande",
    "fromEmail": "Avsändarens e-post",
    "fromName": "Från namn",
    "youDontHaveAny": "Du har inga mallar än.",
    "requestPayment": "Begär betalning",
    "schedule": "Schema",
    "selectATemplate": "Välj en mall",
    "sendNow": "Skicka nu",
    "smtpProvidersHasSome": "SMTP-leverantörer har vissa begränsningar. Klicka här om du vill veta mer.",
    "subject": "Ämne",
    "useATemplateSnippet": "Använd en mall (utdrag)",
    "deliveredtotalDelivered": "{delivered}/{total} skickade",
    "countMoreEmailsIn": "{count} fler e-postmeddelanden i tråden",
    "primary": "(Primär)",
    "reply": "Svara",
    "respond": "Svara",
    "retry": "Försök igen",
    "to": "Till:",
    "fbCommentReplyDm": "Svar på FB-kommentar – DM",
    "fbMessage": "FB-meddelande",
    "theseAttachmentsMayNot": "Dessa bilagor kanske inte längre stöds.",
    "urlCannotBeFound": "URL kan inte hittas",
    "activity": "Aktivitet",
    "filters": "Filter",
    "goToPost": "Gå till inlägg",
    "inboundCall": "Inkommande samtal",
    "instagramDm": "Instagram DM",
    "internalChat": "Intern chatt",
    "search2": "Sök...",
    "starred": "Stjärnmärkt",
    "leftAVoicemail": "Lämnade ett röstmeddelande",
    "manual": "Manuell",
    "mergeFields": "Sammanfoga fält",
    "addToDocuments": "Lägg till i dokument",
    "failedToAddAttachments": "Det gick inte att tillfoga bilagor i dokument",
    "attachmentsAddedToDocuments": "Bilagorna har lagts till i dokument",
    "newCommentOnPagename": "Ny kommentar på {pageName} inlägget.",
    "outboundCall": "Utgående samtal",
    "replyAsDm": "Svara med DM",
    "replyingAsAPrivate": "Det går inte att svara med ett privat DM på kommentarer som är äldre än sju dagar.",
    "reportFeedbackForAi": "Rapportera feedback för AI",
    "storyMention": "Story Omnämnande",
    "storyReply": "Svar på story",
    "bulkRequest": "Bulk-förfrågan",
    "eventsAreCurrentlyCaptured": "Händelser registreras för närvarande endast för kontaktens e-postadress.",
    "failed": "Misslyckades",
    "gbpMessage": "GBP-meddelande",
    "pageName": "Sidnamn",
    "unknown": "Okänd",
    "typeAMessage": "Skriv ett meddelande",
    "new": "Ny",
    "newAppointmentBookedBy": "Nytt möte bokat av",
    "customerNameRequired": "Kundens namn krävs",
    "messageIsRequired": "Meddelande krävs",
    "pickATemplateTo": "Välj en mall att använda.",
    "newMessage": "Nytt meddelande",
    "newTask": "Ny uppgift",
    "toMakeACall": "För att ringa ett samtal, ange ett telefonnummer i det här fältet.",
    "primary1": "Primär",
    "provider": "Leverantör",
    "refresh": "Uppdatera",
    "resetPassword": "Återställ lösenord",
    "thisReviewHasAlready": "Denna recension har redan publicerats på {network}. Är du säker på att du vill publicera det igen?",
    "seeThisReviewOn": "Se den här recensionen på GBP",
    "reviewResponse": "Svar på recension",
    "searchUsers": "Sök efter användare",
    "sendEmail": "Skicka e-post",
    "sending": "Skickar ...",
    "thisSubaccountHasPhonenumberco": "Det här underkontot har {phoneNumberCount} nummer och {campaignsCount} A2P-kampanjer. Om kontot raderas kommer det fortfarande att medföra fakturering om LC Phone System-kontot inte kopplas bort och stängs.",
    "thisSubaccountDoesNot": "Detta underkonto har inga nummer och inga A2P-kampanjer. Om kontot pausas kommer det inte att medföra några avgifter, men vi föreslår att du kopplar bort och stänger LC Phone-kontot.",
    "summary": "Sammanfattning",
    "unassigned": "Ej tilldelad",
    "viewSubmission": "Visa inlämning",
    "contactSupport": "Kontakta support",
    "create": "Skapa",
    "illDoThisLater": "Jag gör detta senare",
    "enterBusinessName": "Ange företagsnamn",
    "firstNameOfThe": "Förnamn på företagets ägare",
    "mobileBusinessPhone": "Mobil/företagstelefon",
    "iDontHaveA": "Jag har ingen webbplats",
    "clientName": "Kundens namn",
    "letUsSetupYour": "Nu skapar vi ett eget konto åt dig eller din första kund",
    "clientNameIsRequired": "Kundnamn krävs",
    "pleaseEnterAValid": "Ange en giltig e-postadress",
    "emailAddressIsRequired": "E-postadress krävs",
    "firstNameIsRequired": "Förnamn krävs",
    "lastNameIsRequired": "Efternamn krävs",
    "phoneNumberIsRequired": "Telefonnummer krävs",
    "copyOfName": "Kopia av {name}",
    "goToDashboard": "Gå till kontrollpanelen",
    "permissionsNotEnabled": "Behörigheter är inte aktiverade!",
    "createAndSellCustom": "Skapa och sälj anpassade produkter med dropshipping med print-on-demand-funktion",
    "viewApp": "Visa appen",
    "seamlessFulfillmentRealtimeShi": "Sömlös leverans och leveranskostnader i realtid för dina e-handelsbutiker",
    "learnMore": "Läs mer",
    "activateFormMapping": "Aktivera formulärmappning",
    "avatarName": "Avatar-namn",
    "formFields": "Formulärfält",
    "formName": "Formulär",
    "mapFields": "Mappa",
    "update": "Uppdatera",
    "pauseSubaccount": "Pausa underkonto",
    "pausing": "Pausar …",
    "subaccount": "underkonto",
    "howItWorks": "Hur det fungerar",
    "uponCompletingThisAction": "När denna åtgärd har slutförts kommer överföringsbegäran att skickas till den mottagande byrån ({relNo}). Underkontot kommer att överföras omedelbart efter att de har accepterat det. Observera att åtgärden inte kan ångras.",
    "ejectSubaccount": "Gör underkontot fristående",
    "newAgencyCreationMail": "E-post för skapande av ny byrå skickades till markerad användare. Användaren kan skapa en ny byrå genom att klicka på länken som skickats i e-postmeddelandet.",
    "unableToTransferSubaccount": "Det går inte att överföra underkontot till denna byrå.",
    "nominateAccountOwnerFor": "Nominera kontoägare för det nya kontot",
    "pleaseConfirmOwnershipWill": "Bekräfta att ägarskapet överförs till",
    "scheduledDate": "Schemalagt datum",
    "thisDateIsBased": "Detta datum är baserat på företagets tidszon, som är {timezone}",
    "campaignName": "Kampanjnamn",
    "copyCampaign": "Kopiera kampanj",
    "endTime": "Sluttid",
    "event10xEmail4": "Händelse: 10X e-post 4 (listningsdistribution) ",
    "10xEmail1Reviews": "10X Email 1 (Recensioner)",
    "fromAddress": "Från adress",
    "leadValue": "Värde för potentiell kund",
    "option1": "Alternativ 1",
    "option2": "Alternativ 2",
    "option3": "Alternativ 3",
    "preview": "Förhandsgranska",
    "selectCampaign": "Välj kampanj",
    "startTime": "Starttid",
    "time": "Tid",
    "users": "Användare",
    "noRecordsFound": "Inga poster hittades",
    "pageDetail": "Siddetalj",
    "selectAll": "Markera alla",
    "submission": "Inl\tmn\nng",
    "addProduct": "Lägg till produkt",
    "visitors": "besökare",
    "By": " av",
    "conversions": "Konverteringsfrekvens ",
    "liveReviews": "Liveomdömen",
    "liveVisitors": "Livebesökare",
    "pageVisits": "Sidbesök",
    "stream": "Flöde",
    "addOneOrMore": "Lägg till en eller flera sid-URL:er eller kopiera dem direkt från din webbläsare.",
    "WeWillAutomatically": " Vi kommer automatiskt att spåra dina webbplatsbesökare i realtid. ",
    "connectYourLocationsFacebook": "Anslut Facebook-kontot för din plats",
    "connected": "Ansluten!",
    "Contains": " innehåller ",
    "expression": "Uttryck",
    "facebookAccount": "Facebook-konto",
    "wowYouDontNeed": "Wow! Du behöver inte konfigurera någonting här, du kan gå vidare.",
    "Regex": " regex ",
    "selectUrlMatchType": "Välj URL-matchningstyp",
    "Simple": " enkel ",
    "LivePreview": " Live-förhandsvisning",
    "seconds": "sekunder",
    "launch": "Lansera ",
    "decorativeVector1": "Dekorativ vektor 1",
    "showingFromToTo": "Visar {from} till {to} av {total} poster",
    "cloneProduct": "Klona produkt",
    "connectFacebookInstagram": "Anslut Facebook och Instagram",
    "connectPage": "Anslut sidan!",
    "everythingIn": "Allt i",
    "agentChat25": "Agentchatt (~2–5 minuters väntetid)",
    "aiSupportChat": "AI-supportchatt",
    "startChat": "Starta chatt",
    "locations1": "platser",
    "phone1": "telefon",
    "slack": "Slack",
    "segments1": "segment",
    "areYouSureYou": "Är du säker på att du vill radera den här mappen?",
    "verified": "Verifierad",
    "highlevelPrice": "HighLevel-pris",
    "howDoesItWork": "Hur fungerar det?",
    "payNow": "Betala nu",
    "priceMustBeMore": "Priset måste vara lika med eller högre än HighLevel-priset",
    "saving2": "Sparar",
    "yourPrice": "Ditt pris",
    "yourProfit": "Din vinst",
    "youNeedToComplete": "Du måste slutföra några enkla efterlevnadssteg för att inaktivera SaaS-läge för denna plats",
    "youAreNotAuthorized": "Du är inte behörig att utföra den här åtgärden. Endast byråadministratörer kan utföra den.",
    "disableSaasModeFor": "Inaktivera SaaS-läge för {name}",
    "companyBilling": "Företagsfakturering",
    "bccEmailsCommaDelimited": "BCC-e-postadresser (separerade med kommatecken)",
    "unableToDeleteMailgun": "Det går inte att radera Mailgun-kontot. Kontakta supporten.",
    "forwardingAddress": "Adress för vidarebefordran",
    "forwardingAddressesCommaDelimi": "Adresser för vidarebefordran (separerade med kommatecken)",
    "amount": "Antal",
    "billingDate": "Faktureringsdatum",
    "debugWalletTransactionsTotal": "DEBUG-plånbokstransaktioner, totalt: {count}",
    "detailedTransactions": "Detaljerade transaktioner",
    "transactionsOnlyAfter26th": "Endast transaktioner efter den 26 april 2022 listas och kan exporteras",
    "someRecordsMayTake": "Det kan ta 24 timmar att uppdatera vissa register här.",
    "totalBalance": "Totalt saldo",
    "walletTransactions": "Plånbokstransaktioner",
    "walletTransactionsAllDate": "Plånbokstransaktioner – alla – {date}",
    "enterMessage": "Skriv meddelande",
    "applyThisChangeTo": "Tillämpa ändringen på alla underkonton.",
    "characters": "Tecken",
    "iConfirmThatI1": "Jag bekräftar att jag har diskuterat detta med min kund och fått deras godkännande.",
    "iConfirmThatI2": "Jag bekräftar att jag kommer att säkerställa att alla sms-meddelanden som skickas från detta konto följer den aktuella policyn.",
    "theContentsOfThis": "Innehållet i det här meddelandet kommer automatiskt att läggas till i det första sms:et som skickas via bulkmeddelanden.",
    "iConfirmThatSms": "Jag bekräftar att sms endast kommer att skickas till kontakter som har valt att ta emot sms.",
    "quickTip": "Snabbtips",
    "messageWillBeAppended": "Meddelandet kommer att läggas till i det första sms:et för en konvertering om det inte innehåller språk för avanmälan",
    "readMore": "Läs mer",
    "noncompliantActivityMayLead": "Aktiviteter som inte uppfyller kraven kan leda till att ditt kontos sms- och röstrelaterade funktioner stängs av.",
    "typeConfirmBelowTo": "Skriv Confirm nedan för att fortsätta",
    "products": "Produkter",
    "chooseCountry": "Välj land...",
    "email2": "E-post*",
    "firstName1": "Förnamn*",
    "lastName1": "Efternamn*",
    "brandDetails": "Varumärkesinformation",
    "brandName": "Namn på varumärke*",
    "useEitherLegalName": "Använd antingen det juridiska namnet på organisationen som skickar meddelandena eller ditt eget namn om varumärket inte tillhör en organisation.",
    "businessIndustry": "Affärsbransch*",
    "chooseVertical": "Välj vertikal ...",
    "mobileNumberForOtp": "Mobilnummer för OTP-verifiering (med landskod)*",
    "pleaseProvideAMobile": "Ange ett mobilnummer som du har tillgång till så att du kan bekräfta OTP-verifiering. Endast amerikanska/kanadensiska nummer kommer att godkännas. Du får inte använda ett CPaaS-telefonnummer som ett som erhållits från LeadConnector. Du kan inte använda samma mobilnummer för att registrera fler än tre varumärken för enskild firma. Denna gräns hanteras av TCR.",
    "increasedDeliveryRate": "Ökad leveransfrekvens",
    "sendUpto3000Segments": "Skicka upp till 3 000 segment per dag",
    "businessDetails": "Företagsinformation",
    "thereWasSomeIssue": "Det uppstod ett problem när profilen skulle skickas in.",
    "yourProfileSubmissionFailed": "Din profilinlämning misslyckades.",
    "endUserConsent": "Slutanvändarens samtycke",
    "minLength40Characters": "Minsta längd: 40 tecken. Maximal längd: 2 048 tecken.",
    "closeExamples": "Stäng exempel",
    "sampleMessage1": "Exempelmeddelande #1*",
    "seeExamples": "Se exempel",
    "enterCampaignDetails": "Ange kampanjdetaljer",
    "youWillReceiveAn": "Du kommer att få ett OTP-meddelande från TCR på ditt angivna mobilnummer för verifiering. Svara Ja inom 24 timmar efter att du mottagit SMS:et.",
    "brandNameIsRequired": "Varumärkesnamn krävs.",
    "businessVerticalIsRequired": "Affärsvertikal krävs.",
    "mobileNumberIsRequired": "Mobilnummer krävs.",
    "hideDetail": "Dölj detaljer",
    "showDetail": "Visa detaljer",
    "people": "personer",
    "person": "person",
    "after": "efter",
    "before": "före",
    "hour": "timme",
    "hours": "timmar",
    "minute": "minut",
    "minutes": "minuter",
    "triggerLinksEmbeddedIn": "klickade utlösarlänkar (inbäddade i meddelandet) som % av skickade meddelanden",
    "addNewEvent": "Lägg till ny händelse",
    "addTask": "Lägg till uppgift",
    "manualCall": "Manuellt samtal",
    "manualSms": "Manuellt SMS",
    "messenger": "Messenger",
    "wait": "Vänta",
    "webhook": "Webhook",
    "about": "Om",
    "accessRestricted": "Åtkomst begränsad",
    "addPartner": "Lägg till partner",
    "addPartnerForm": "Lägg till partnerformulär",
    "affiliatePortal": "Partnerportal",
    "badges": "Emblem",
    "aBriefBio": "En kort biografi",
    "dashboard": "Kontrollpanel",
    "experience": "Erfarenhet",
    "industryServed": "Bransch som betjänas",
    "instagramAccount": "Instagram-konto",
    "invoiceHistory": "Fakturahistorik",
    "englishGermanHindi": "English, German, Hindi",
    "linkToWebsite": "länk till webbplats",
    "linkedinAccount": "LinkedIn-konto",
    "locationId": "Plats-ID",
    "partnerName": "Partnernamn",
    "partnerStatus": "Partnerstatus",
    "paymentDetails": "Betalningsuppgifter",
    "paymentHistory": "Betalningshistorik",
    "profilePhoto": "Profilfoto",
    "profilePhotoUrl": "profilfotots URL",
    "promoterReports": "Promoter-rapporter",
    "searchPartner": "Sök efter partner",
    "twitterAccount": "Twitter-konto",
    "updatePartner": "Uppdatera partner",
    "updatePartnerForm": "Uppdatera partnerformulär",
    "yearOfExperience": "års erfarenhet",
    "youtubeAccount": "YouTube-konto",
    "serviceProvided": "Tillhandahållen tjänst",
    "controlTheSubaccountSettings": "Kontrollera inställningarna för underkontot",
    "generalInfo": "Allmän information",
    "okay": "Okej",
    "proceed": "Fortsätt",
    "addCard": "Lägg till kort",
    "makeThisCardPrimary": "Gör detta kort till det primära",
    "nameOnCard": "Namn på kortet",
    "chargedToCustomer": "Debiteras till kunden",
    "clientBillingPage": "Klientfaktureringssida",
    "companyStripeIntegrationPage": "företagets Stripe-integrationssida",
    "enableRebilling": "Aktivera återfakturering",
    "enabling": "Aktiverar ...",
    "forMoreDetails": "för mer information.",
    "youreOnTheFreelancer": "Du har Freelancer-abonnemanget som begränsar dig till 1,05x i påslag.",
    "minimumAmountShouldBe": "Minimibeloppet bör vara mellan ${min} och ${max}",
    "beforeEnablingThisFeature1": "Innan du aktiverar den här funktionen, vänligen anslut ditt Stripe-konto på",
    "planToSetYour": "abonnemanget för att ställa in högre marginaler.",
    "rebillAmount": "Belopp för återfakturering",
    "supportDoc": "supportdokument",
    "10WillGiveYou": "10 USD ger dig cirka",
    "minimumMustBeBetween": "Minimum måste vara mellan 0,0001 och 0,005",
    "sorryYouCannotRebillAtTheMarkup": "Tyvärr! Du kan inte återfakturera med påslaget på Freelancer-planen, vänligen",
    "modifyingTheseSettingsWillChange": "Om du ändrar de här inställningarna ändras kostnaden för dina kunder framöver.",
    "pleaseDoNotModifyThese": "Ändra dem inte om du inte är säker på vilka effekter det får.",
    "theseSettingsWillApply": "De här inställningarna kommer att gälla för dina nya kunder framöver",
    "congratulationsYourDedicatedIp": "Grattis! Ditt dedikerade IP-återförsäljningsvärde har sparats framgångsrikt.",
    "youHaveAgreedToProvide": "Du har samtyckt till att tillhandahålla dedikerade IP-adresser direkt till ett underkonto. Byrån kommer att täcka kostnaderna för underkontots räkning.",
    "youHaveDiscontinuedToProvide": "Du har slutat att tillhandahålla dedikerade IP-adresser direkt till ett underkonto. Byrån kommer inte längre att täcka kostnaderna för underkontot.",
    "oopsSomethingWentWrongAndWeCouldnt": "Hoppsan! Något gick fel och vi kunde inte spara din dedikerade IP-återförsäljningskonfiguration. Försök igen senare.",
    "pleaseAgreeToTheTerms": "Var vänlig och godkänn villkoren",
    "errorWhileFetchingDomains": "Fel vid hämtning av domäner",
    "sameStripeCustomerProfileCantBeMapped": "Samma Stripe-kundprofil kan inte kopplas till mer än ett underkonto.",
    "pleasePickADifferentStripeCustomer": "Välj en annan Stripe-kundprofil eller använd alternativet ”Dela en länk” så att vi kan skapa en ny Stripe-kundprofil för detta underkonto.",
    "clickNextToChooseAPlan": "Klicka på \"Nästa\" för att välja ett schema och skapa ett nytt abonnemang.",
    "youDontHaveAnyActiveSubscriptions": "Du har inga aktiva abonnemang",
    "youCanEitherSelectAnExistingSubscription": "Du kan antingen välja en befintlig prenumeration eller skapa en ny prenumeration i nästa steg.",
    "useCommasToSeparateMultipleEmails": "Använd kommatecken för att separera flera e-postadresser.",
    "useCommasToSeparateMultiplePhoneNumbers": "Använd kommatecken för att separera flera telefonnummer.",
    "noUserFoundInThisLocation": "Ingen användare hittades på denna plats",
    "noPhoneNumberAttached": "Inget telefonnummer kopplat",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Använd följande länk för att bifoga din betalningsmetod.",
    "allowDuplicateContact": "Tillåt duplicerad kontakt",
    "allowDuplicateOpportunity": "Tillåt duplicerad möjlighet",
    "mergeFacebookContactsByName": "Sammanfoga Facebook-kontakter efter namn",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Endast inkommande meddelanden från Facebook kommer att slås ihop om de matchar en befintlig kontakts namn. Namn är skiftlägeskänsliga.",
    "disableContactTimezone": "Inaktivera kontaktens tidszon",
    "markEmailsAsInvalidDueToHardBounce": "Markera e-postmeddelanden som ogiltigt på grund av hårdstuds",
    "contactsEmailsWillBeMarkedAsInvalid": "Kontaktens e-postmeddelanden kommer automatiskt att markeras som Ogiltiga när de hårdstudsar. E-poståtgärder i automatiseringar kommer att hoppas över för kontakter med ogiltiga e-postmeddelanden.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Samla information om okända telefonnummer",
    "makeSmsCompliantByAddingAnOptOutMessage": "Gör sms överensstämmande genom att lägga till ett meddelande för avanmälan.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "Om det aktiveras kommer meddelandet för avanmälan automatiskt att läggas till i det första SMS:et som skickas via bulkmeddelanden för att säkerställa efterlevnad och öka leveransfrekvensen.",
    "platformLanguage": "Plattformsspråk",
    "outboundCommunicationLanguageForCustomValues": "Språk för utgående kommunikation för anpassade värden",
    "updateInformation": "Uppdatera information",
    "upgradeToTheAgency": "Uppgradera till Agency Pro",
    "yourCost": "Din kostnad",
    "addACalendarTo": "Lägg till en kalender för att börja boka möten.",
    "addselectAContactTo": "Lägg till/välj en kontakt för att schemalägga möten",
    "appointmentSlotIsNot": "Tidslucka för mötet är ännu inte valt",
    "loading1": "Läser in …",
    "teamMemberIsRequired1": "Teammedlem krävs",
    "currentPlan": "Nuvarande plan",
    "features1": "Funktioner",
    "upgrade": "Uppgradera",
    "viewLess": "Visa mindre",
    "viewMoreCount": "Visa mer (+{count})",
    "cardNumber": "Kortnummer",
    "expiryDate": "Utgångsdatum",
    "paymentMethods": "Betalningsmetoder",
    "primaryCard": "Primärt kort",
    "removeCurrentCard": "Ta bort aktuellt kort",
    "AddBalance": "+ Lägg till saldo",
    "complimentaryCredits": "Kostnadsfria krediter:",
    "expiringOnDate": "Går ut den {date}",
    "apiVersion": "API-version",
    "application": "App",
    "ipAddress": "IP-adress",
    "related": "Relaterade",
    "request": "Förfrågan",
    "yourAccountIncludingAll": "Ditt konto, inklusive all utgående aktivitet som schemalagda meddelanden och e-postmeddelanden, kommer att stoppas omedelbart.",
    "yourAccountIncludingAll1": "Ditt konto, inklusive all utgående aktivitet som schemalagda meddelanden och e-postmeddelanden, kommer att stoppas omedelbart.",
    "nextBillingDateDate": "Nästa faktureringsdatum: {date}",
    "scheduledForCancellation": "Schemalagd för uppsägning",
    "abandoned": "Övergivna",
    "add1": "Lägg till",
    "addOpportunity": "Lägg till möjlighet --",
    "addOpportunityName": "Lägg till möjlighetens namn",
    "Task": "+ Uppgift",
    "bookupdateAppointment": "Boka/uppdatera möte",
    "companyName": "Företagets namn",
    "areYouSureYou1": "Är du säker på att du vill radera denna möjlighet?",
    "contactInfo": "Kontaktuppgifter",
    "editOpportunity": "Redigera möjlighet --",
    "enterValue": "Ange värde",
    "goToContactDetail": "Gå till sidan med kontaktuppgifter",
    "leads": "Potentiella kunder",
    "lost": "Förlorad",
    "nameIsRequired": "Namn krävs.",
    "youreNotAllowedTo": "Du kan inte ändra kundens namn!! Kontrollera dina behörigheter hos byråns administratör.",
    "open": "Öppen",
    "opportunity": "Möjlighet",
    "opportunityAlreadyExistsIn": "Möjligheten finns redan i denna pipeline",
    "opportunityInfo": "Info om möjlighet",
    "opportunityName": "Möjlighetens namn",
    "opportunitySource": "Möjlighetskälla",
    "owner": "Ägare",
    "pipeline": "Pipeline",
    "removeOwner": "Ta bort ägare",
    "selectPipeline": "Välj pipeline",
    "selectStage": "Välj stadie",
    "stage": "Stadium",
    "countTasks": "{count} uppgifter",
    "won": "Vunnen",
    "and": "och ",
    "addASubscription": "Lägg till ett abonnemang",
    "noSaasPlanEnabled": "Ingen SaaS-plan aktiverad",
    "per": "per",
    "assignTo": "Tilldela till",
    "assignedTo1": "Tilldelad till:",
    "areYouSureYou2": "Är du säker på att du vill ta bort den här uppgiften?",
    "due": "Förfaller:",
    "dueDateIsRequired": "Förfallodatum krävs",
    "dueIn": "Förfaller om",
    "dueToday": "Förfaller idag",
    "late": "Sen",
    "notAssigned": "Inte tilldelad",
    "taskDescription": "Uppgiftsbeskrivning",
    "taskTitle": "Uppgiftstitel",
    "annually": "årligen",
    "attachments": "Bilagor",
    "areYouSureYou3": "Är du säker på att du vill radera denna bulk-förfrågan?",
    "startImmediately": "Starta omedelbart",
    "customers": "Kunder",
    "tag": "Tagg",
    "pickType": "Välj typ",
    "whoShouldItRun": "Vem ska den köras för?",
    "addBulkRequest": "Lägg till bulk-förfrågan",
    "editBulkRequest": "Redigera bulk-förfrågan",
    "scheduledDateIsRequired": "Schemalagt datum krävs",
    "newCampaignName": "Namn på ny kampanj",
    "areYouSureYou4": "Är du säker på att du vill radera den här kampanjen?",
    "moveToFolder": "Flytta till mapp",
    "pleaseRename": "byt namn",
    "removeFromFolder": "Ta bort från mappen",
    "photoPreview": "förhandsgranska foto",
    "pleaseWait": "Vänta ett ögonblick ...",
    "customValues": "Anpassade värden",
    "whatActionShouldWe": "Vilken åtgärd bör vi utföra?",
    "entitynameName": "Namn för {entityName}",
    "useLcEmail": "Använd LC Email",
    "21Jun2018": "21 juni 2018",
    "930Am": "09:30",
    "Via": " via ",
    "createdTrackingNumbers": "Skapade spårningsnummer",
    "iUnderstandImBuyingadding": "Jag förstår att jag köper/lägger till {count} nya telefonnummer.",
    "forwardCallsTo": "Vidarekoppla samtal till",
    "numberName": "Numrets namn",
    "numberPoolName": "Namn på nummerpool",
    "numberToSwap": "Nummer att byta",
    "sameAsForwardingNumber": "Samma som vidarebefordringsnummer",
    "callFromSource": "Samtal från [Källa].",
    "callRecording": "Inspelning av samtal",
    "84Complete": "84 % slutfört",
    "thisCallWillBe": "Detta samtal kommer att spelas in för kvalitetssyften.",
    "whisperMessage": "Viskningsmeddelande",
    "allExceptDirect": "Alla utom direkt",
    "allExceptDirectOrganic": "Alla utom direkt och organisk",
    "allSearch": "Alla sökningar",
    "allVisitorsRecommended": "Alla besökare (rekommenderas)",
    "bing": "Bing",
    "direct": "Direkt",
    "visitorsWithoutAReferring": "Besökare utan en hänvisande webbplats",
    "for": "för",
    "google": "Google",
    "landingPageOrUrl": "Landningssida eller URL-parameter",
    "organic": "Organisk",
    "paid": "Betald",
    "pickOneYouCan": "Välj ett – du kan alltid ändra detta senare.",
    "ppcSearch": "PPC-sökning",
    "visitorsFromGoogleBing": "Besökare från sökning med Google, Bing och Yahoo PPC",
    "referringPage": "Refererande sida",
    "visitorsFrom": "Besökare från",
    "visitorsFromGoogleAds": "Besökare från Google Ads",
    "visitorsWhoAreReferred": "Besökare som hänvisas från",
    "visitorsWhoLandOn": "Besökare som landar på",
    "whichVisitorsDoYou": "Vilka besökare vill du spåra?",
    "yahoo": "Yahoo",
    "17Complete": "17 % klart",
    "callTimeoutS": "Timeout för samtal (s)",
    "callWhisper": "Samtalsscreening",
    "disableVoicemailDetect": "Inaktivera upptäckt av röstmeddelanden",
    "eventName": "Händelsens namn",
    "timeoutSeconds": "Timeout (sekunder)",
    "editCall": "Redigera samtal",
    "callWillPatchInstantly": "Samtalet kopplas omedelbart vidare, vi lyssnar inte för att se om röstbrevlådan har svarat hos kunden. Det innebär att kampanjen kommer att markeras som besvarad även om röstbrevlådan svarade.",
    "thisIsTheMessage": "Det här är meddelandet som du vill att personen som svarar i telefonen ska höra. Du kan använda anpassade variabler för att anpassa det.",
    "pleaseCheckTheLinks": "Kontrollera länkarna där du har ett anpassat värde. Det finns ett extra '%20' mellan {{ och custom_values.",
    "anErrorOcurredPlease": "Ett fel uppstod, försök igen.",
    "pleaseInsertATo": "Ange en adress.",
    "pickEmailTemplate": "Välj e-postmall",
    "sendTest": "Skicka test",
    "composeEmail": "Skriv e-post",
    "composeEmailTemplate": "Skapa e-postmall",
    "toAddress": "Att ta itu med",
    "addFileThroughUrl": "Lägg till dokument via URL",
    "appCharacters": "App-tecken:",
    "approximateCost": "Ungefärlig kostnad:",
    "estimatedCostForUs": "Uppskattad kostnad endast för SMS inom USA.",
    "mobilePhoneNumber": "Mobilnummer",
    "numSegments": "Antal segment",
    "pickMessageTemplate": "Välj meddelandemall",
    "pleaseProvideAPhone": "Ange ett telefonnummer att skicka testet till.",
    "composeEventtype": "Skapa {eventType}",
    "composeEventtypeTextTemplate": "Skapa textmall för {eventType}",
    "unsupportedSmsContentType": "SMS-innehållstypen {fileType}stöds inte",
    "countOfTheProvided": "{count} av de angivna URL-bilagorna {plural} inte en bild. Detta kan orsaka fel i Twilio. Vill du spara ändå?",
    "dropFileHereOr": "Släpp filen här eller klicka för att ladda upp",
    "ifYouHaveAdditional": "Om du har ytterligare frågor, se Vanliga frågor om röstbrevlådan i hjälpavsnittet.",
    "editVoicemail": "Redigera röstbrevlåda",
    "selectAMp3Or": "Välj en mp3- eller wav-fil. Vi stöder inte andra format.",
    "voicemailFile": "Röstbrevlådans fil",
    "warningVoicemailDropsAre": "Varning: Röstbrevlådan är ett best attempt-system som fungerar ungefär 70 % av gångerna.",
    "youNeedToPick": "Du måste välja minst 1 dag",
    "editWait": "Redigera väntetid",
    "url": "URL",
    "customTime": "Anpassad tid",
    "executeThisActionIf": "Exekvera denna åtgärd om den aktuella tiden infaller inom detta tidsfönster. Om den aktuella tiden är utanför detta tidsfönster, hoppa över steget och fortsätt till nästa åtgärd.",
    "pickDays": "Välj dagar",
    "pickTime": "Välj tid",
    "noRecordsFound1": "Inga poster hittades.",
    "formAnalyze": "Formuläranalys",
    "totalSubmission": "Total inlämning",
    "forgotPassword": "Glömt lösenordet?",
    "orContinueWith": "Eller fortsätt med",
    "signIn": "Logga in",
    "signIntoYourAccount": "Logga in på ditt konto",
    "thePasswordYouPicked": "Lösenordet du valde",
    "yourEmailAddress": "Din e-postadress",
    "newEmailFrom": "Nytt e-postmeddelande från",
    "newMessageFrom": "Nytt meddelande från",
    "hasLeftANew": "har lämnat en ny recension.",
    "repliedToTheReview": "svarade på recensionen.",
    "loaded": "Inläst",
    "snapshot": "Lägesbild",
    "appointment": "Möte",
    "appointmentDueInMinutes": "Möte om {minutes} minuter för {contactName}",
    "appointmentReminder": "Påminnelse om möte",
    "completedCount": "Slutförda: {count}",
    "conversation": "Konversation",
    "facebookReview": "Facebook-recension",
    "failedCount": "Misslyckades: {count}",
    "googleReview": "Google-recension",
    "internalChatMessage": "Internt chattmeddelande",
    "usernameMentionedYouIn": "{userName} har nämnt dig i en konversation med {contactName}",
    "newAppointmentAssigned": "Nytt möte tilldelat",
    "aNewAppointmentWith": "Ett nytt möte med {contactName} har tilldelats dig.",
    "newAppointmentBooked": "Nytt möte bokat",
    "youHaveNewAppointment": "Du har bokat ett nytt möte med {contactName}",
    "newCall": "Nytt samtal",
    "aNewChatWith": "En ny chatt med {contactName} har tilldelats dig.",
    "newEmail": "Nytt e-postmeddelande",
    "newMention": "Nytt omnämnande",
    "newReviewReceivedFrom": "Ny recension mottagen från {contactName}",
    "aNewTypeIs": "En ny {type} har mottagits från {contactName}",
    "notification": {
      "noRecentActivity": "Ingen senaste aktivitet"
    },
    "subAccount": "Underkonto",
    "subaccount1": "Underkonto:",
    "titleOnDateAt": "{title} den {date} kl. {time} för {contactName}",
    "titleDueInDuetime": "{title} förfaller om {dueTime} {unitOfTime} för {contactName}",
    "taskReminder": "Påminnelse om uppgift",
    "youHaveCountTasks": "Du har {count} uppgifter som förfaller idag",
    "youHaveCountTasks1": "Du har {count} uppgifter som är försenade fram till nu",
    "droppedVoicemailTo": "Röstmeddelande lämnat till",
    "errorWhileCloningProduct": "Fel vid kloning av produkten!",
    "productName": "Produktnamn",
    "selectLocations": "Välj platser",
    "selectUptoMaxselectablelocatio": "Välj upp till {maxSelectableLocations} platser",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "+ {count} till",
    "emails": "Mejl",
    "accountNotification": "Kontoavisering",
    "customerCare": "Kundtjänst",
    "deliveryNotification": "Leveransmeddelande",
    "fraudAlertMessaging": "Bedrägerivarningsmeddelande",
    "higherEducation": "Högre utbildning",
    "lowVolumeMixedRecommended": "Blandad låg volym (rekommenderas)",
    "mixed": "Blandad",
    "pollingAndVoting": "Opinionsundersökningar och röstning",
    "publicServiceAnnouncement": "Offentligt meddelande",
    "securityAlert": "Säkerhetsvarning",
    "mixedRecommended": "Blandad (rekommenderas)",
    "australiaCompanyNumberFrom": "Australien: Företagsnummer från ASIC (ACN)",
    "canadaCanadianBusinessNumber": "Kanada: Kanadensiskt företagsnummer (CBN)",
    "indiaCorporateIdentityNumber": "Indien: Organisationsnummer",
    "greatBritainCompanyNumber": "Storbritannien: Företagsnummer",
    "usaEmployerIdentificationNumbe": "USA: Arbetsgivaridentifikationsnummer (EIN)",
    "other": "Annat",
    "israelRegistrationNumber": "Israel: Registreringsnummer",
    "estoniaVatNumber": "Estland: Momsregistreringsnummer",
    "cooperative": "Kooperativ",
    "corporation": "Företag",
    "limitedLiabilityCompanyOr": "Aktiebolag eller enskild firma",
    "nonprofitCorporation": "Ideellt företag",
    "partnership": "Partnerskap",
    "ceo": "CEO",
    "cfo": "Ekonomichef",
    "director": "Direktör",
    "generalCounsel": "Chefsjurist",
    "onlineTrainingEducation": "Onlinekurser och utbildning",
    "financialServices": "Finansiella tjänster",
    "fitnessLifestyle": "Fitness och livsstil",
    "healthMedical": "Hälsa och sjukvård",
    "homeServices": "Hemtjänster",
    "legalServices": "Juridiska tjänster",
    "marketingAdvertising": "Marknadsföring och reklam",
    "others": "Andra",
    "realEstate": "Fastigheter",
    "restaurants": "Restauranger",
    "retailEcommerce": "Detaljhandel och e-handel",
    "yourInformationHasBeen": "Din information har skickats.",
    "somethingWentWrong1": "Något gick fel",
    "newPassword": "Nytt lösenord",
    "proceedToLogin": "Fortsätt till inloggning",
    "anyTime": "när som helst.",
    "callUsHighlevelSupport": "Ring HighLevel Support på",
    "troubleLoggingIn": "Har du problem med att logga in?",
    "sendSecurityCode": "Skicka säkerhetskod",
    "sendCodeToEmail": "Skicka kod till e-post",
    "verifySecurityCode": "Verifiera säkerhetskod",
    "privacyPolicy": "Integritetspolicy",
    "businessProfile": "Företagsprofil",
    "reserveWithGoogleIntegration": "Boka med Google Integration",
    "friendlyName": "Vänligt namn",
    "updateCallerId": "Uppdatera nummerpresentation",
    "internationalFormat": "Internationellt format",
    "localFormat": "Lokalt format",
    "poolNumbers": "Poolnummer",
    "swappingNumbers": "Byte av nummer",
    "selectField": "Välj fält",
    "surveyAnalyze": "Undersökningsanalys",
    "locationIsRequired": "Plats krävs.",
    "newSurveyName": "Namn på ny undersökning",
    "copySurvey": "Kopiera undersökning",
    "primaryCalendar": "Primär kalender",
    "cloneEntityname": "Klona {entityName}",
    "youHaveSuccessfullySubmitted": "Du har skickat in dokumenten",
    "addCustomValue": "Lägg till anpassat värde",
    "value": "Värde",
    "youHaveSuccessfullyDeleted": "Du har nu raderat paketet.",
    "bundleDeletedSuccessfully": "Paketet har raderats",
    "thereIsAnIssue": "Det finns ett problem med ett av dina kompletterande dokument. Granska de kompletterande dokumenten och dess orsak/orsaker till avslag.",
    "connect1": "Anslut!",
    "itSeemsEitherThe": "Det verkar som att antingen Google-anslutningen är bruten eller så skapas ingen anslutning på aktuell plats. Kontrollera integrationsinställningarna och återintegrera om anslutningen redan finns.",
    "selectPage": "Välj Sida",
    "somethingWentWrongPlease": "något gick fel, försök igen",
    "accept": "Godkänn",
    "moreThan1Phone": "Mer än ett telefonnummer är tillåtet",
    "byContinuingToUse": "Genom att fortsätta använda HighLevel-plattformen godkänner du våra nya {termsLink} och {privacyLink}.",
    "byContinuingToUse1": "Genom att fortsätta använda HighLevel-plattformen godkänner du våra nya",
    "termsOfService": "användarvillkor",
    "weHaveUpdatedOur": "Vi har uppdaterat våra användarvillkor och vår integritetspolicy, så kom ihåg att läsa igenom dem!",
    "newTriggerName": "Nytt utlösarnamn",
    "triggerName": "Utlösarens namn",
    "disableDndForSpecific": "Inaktivera DND för specifika kanaler",
    "selectAdAccount": "Välj Annonskonto",
    "selectAppointmentStatus": "Välj mötesstatus",
    "below1": "nedan.",
    "Required": "* krävs",
    "whenYouGetA": "När du får en ny recension publicerar vi den automatiskt på din Facebook-sida. Kom ihåg att det är bäst att publicera max. tre recensioner per dag på ditt konto.",
    "skip": "Hoppa över",
    "copyShareLink": "Kopiera delningslänk",
    "agencyRelationshipNumbers": "Byråns relationsnummer",
    "alteast1AgencyRelationship": "Minst ett byrårelationsnummer krävs.",
    "alteast1SubaccountId": "Minst 1 underkonto-ID krävs.",
    "somethingWentWrongWhile": "Något gick fel vid sparandet, försök igen senare!",
    "5PerPage": "5 per sida",
    "10PerPage": "10 per sida",
    "amountMustGreaterOr": "Beloppet måste vara minst 1 AUD.",
    "regions": {
      "africa": "Afrika",
      "asia_pacific": "Asien/Stillahavsområdet",
      "europe": "Europa",
      "latin_america": "Latinamerika",
      "usa_and_canada": "USA och Kanada",
      "asia": "Asien",
      "latinAmerica": "Latinamerika",
      "usaCanada": "USA och Kanada"
    },
    "expandIcon": "►",
    "noEntriesToShow": "Inga poster att visa",
    "clear": "Rensa",
    "filter": "Filter",
    "test": "Testa",
    "createNewTwilioSubAccountText": "Du måste skapa ett nytt Twilio-konto, uppdatera autentiseringsuppgifterna för det här kontot under Twilio-inställningar och flytta telefonnummer innan du aktiverar återfakturering.",
    "viewing": "Visning",
    "makeSmsCompliantByAddingASenderInformation": "Gör sms överensstämmande genom att lägga till avsändarinformation.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Gör e-post överensstämmande genom att lägga till en avprenumerationslänk i mejlet",
    "enableMissedCallTextBack": "Aktivera textåterkoppling för missade samtal",
    "productInventory": "Produktlager",
    "viewProductVariants": "Visa produktvarianter",
    "smtpSettings": "SMTP-inställningar",
    "locationOPMTrafficStatis": "Platsens OPM-trafikstatistik",
    "locationGPMTrafficStatis": "Platsens GPM-trafikstatistik",
    "blacklistMonitorReports": "Blacklist Monitor-rapporter",
    "twoFactorAuthentication": "Tvåfaktorsautentisering (2FA)",
    "recent": "Senaste",
    "noPermission": "Ni har inte behörighet att hantera mallar för den här produkten. Omdirigerar till kontrollpanelen.",
    "tasksNowHave": "Uppgifter har nu",
    "option": "Alternativ",
    "facebookAdsReporting": "Facebook Ads-rapportering",
    "googleAdsReporting": "Google Ads-rapportering",
    "adsDatePicker": "Datumväljare för annonser",
    "feedbackSubmitBtn": "Skicka feedback-knapp",
    "ifYouThinkMistakePleaseContact": "Om du tror att detta är ett misstag, kontakta",
    "forResolution": "för att lösa det.",
    "live": "Live",
    "payouts": "Utbetalningar",
    "greatChoice": "Utmärkt val!",
    "toNavigate": "att navigera",
    "teams": "Team",
    "role": "Roll",
    "searchAccounts": "Sök konton",
    "searchByNameEmailPhone": "Sök på namn, e-post eller telefon",
    "addEmployee": "Lägg till medarbetare",
    "removeFromLocation": "Ta bort från plats",
    "knowMore": "Läs mer",
    "usingNumberPool": "Använda nummerpool",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Granskare",
    "cancel1": "Avbryt",
    "delete1": "Radera",
    "call1": "Anrop",
    "message1": "Meddelande",
    "name1": "Namn",
    "voicemail1": "Röstbrevlåda",
    "title1": "Titel",
    "choose_one": "Välj en",
    "select_page": "Välj sida",
    "confirm1": "Bekräfta",
    "conversations1": "Konversationer",
    "copied1": "Kopierad",
    "timeOfDay": {
      "am": "AM",
      "pm": "PM"
    },
    "back1": "Tillbaka",
    "details1": "Detaljer",
    "month1": "/månad",
    "select1": "Välj",
    "share1": "Dela",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Blacklist Monitor-rapporter",
      "domainPurchase": "Domänköp"
    },
    "confirmDelete": "Är du säker på att du vill radera {name}?",
    "clicked1": "Klickad",
    "delivered1": "Levererad",
    "invalid1": "Ogiltig",
    "open_options": "Öppna alternativ",
    "_add_account": "Lägg till konto",
    "setTimezoneWarning": "Ställ in tidszonen för din plats för att få lämpliga lediga tidsluckor.",
    "save1": "Spara",
    "action1": "Åtgärd",
    "actions1": "Åtgärder",
    "all1": "Alla",
    "previous1": "Föregående",
    "results1": "Resultat",
    "next1": "Nästa",
    "payments1": "Betalningar",
    "settings1": "Inställningar",
    "total_js_heap": "Total JS Heap",
    "table": {
      "pagination": {
        "previous": "Föregående",
        "next": "Nästa"
      },
      "rowsSelected": "{count} rader har markerats",
      "cantRearrange": "{type} kan inte ändras om"
    },
    "ivrCall": "IVR-samtal",
    "sms": "SMS",
    "username": "Användarnamn",
    "stay": "Stanna kvar",
    "placeholders": {
      "selectCountry": "Välj ditt land",
      "nameOfBusiness": "Företagsnamn",
      "line1": "Rad 1",
      "line2": "Rad 2",
      "enterState": "Ange delstat",
      "enterCity": "Ange stad",
      "enterPostalCode": "Ange postnummer",
      "chooseCountry": "Välj land..."
    },
    "addressLine1": "Adressrad 1",
    "addressLine2": "Adressrad 2",
    "postalCode": "Postnummer",
    "nameOfBusiness": "Företagsnamn",
    "dispute_this_review": "Bestrid den här recensionen",
    "story_mention": "Omnämnande i story",
    "story_reply": "Svar på story",
    "no": "Nej",
    "yes": "Ja",
    "annual": "årlig",
    "plan": "Abonnemang",
    "errors": {
      "somethingWrong": "Något gick fel"
    },
    "zero": "0",
    "perMonth": "per månad",
    "emailCheckLinks": "Kontrollera länkarna där du har ett anpassat värde. Det finns ett extra ”%20” mellan {{ och custom_values.",
    "fileSizeTooLarge": "Filstorleken är större än 5 MB",
    "fileSizeTooLargeDescription": "Filen du försöker ladda upp är för stor. Prova med en mindre filstorlek.",
    "minMaxLength40Characters2048Characters": "Minsta längd: 40 tecken. Maximal längd: 2 048 tecken.",
    "sampleMessage2": "Exempelmeddelande nr 2*",
    "pleaseSelectWorkflow": "Välj ett arbetsflöde",
    "childrens": "Underordnade",
    "brandAndCampaignRegistration": "En engångsavgift på 20,95 $ debiteras för registrering av varumärke och kampanj. En extra kampanjavgift på upp till 2,25 $ per månad tillkommer i enlighet med TCR-reglerna.",
    "einRequiredForRegistration": "EIN krävs för registrering",
    "changed_props": "Ändrade egenskaper",
    "total_memory": "Totalt minne",
    "total_store_size": "Total butiksyta",
    "total_watchers": "Totalt antal bevakare",
    "update_count": "Uppdatera antal"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Bulk-åtgärder",
      "clickHere": "Klicka här för att visa listan över bulkåtgärder.",
      "mergedMessage": "Den här sida har slagits samman med lista över bulkåtgärder.",
      "title": "Kontaktförfrågningar"
    }
  },
  "conversations": {
    "noConversationsFound": "Inga {status} konversationer hittades",
    "create_new": "Skapa ett nytt meddelande​",
    "validations": {
      "minCharsRequired": "Minst 3 tecken krävs",
      "twoMoreCharsRequired": "2 ytterligare tecken krävs",
      "oneMoreCharRequired": "Ytterligare ett tecken krävs"
    },
    "sortLabels": {
      "latestAllMessages": "Senaste – alla meddelanden",
      "oldestAllMessages": "Äldsta – alla meddelanden",
      "latestManualMessages": "Senaste – manuella meddelanden",
      "oldestManualMessages": "Äldsta – manuella meddelanden",
      "latestAll": "Senaste-alla",
      "oldestAll": "Äldsta-alla",
      "latestManual": "Senaste-manuella",
      "oldestManual": "Äldsta-manuella",
      "highToLow": "{name} (Högt till Lågt)",
      "manualMessagesTooltip": "Sorteringsalternativet tillämpas på meddelanden som publicerats efter den 18 maj 2023."
    },
    "deleteConversation": {
      "title": "Bekräftelse",
      "confirmWithName": "Är du säker på att du vill radera konversationen med {name} för alltid? Det här går inte att ångra.",
      "confirmWithoutName": "Är du säker på att du vill radera den här konversationen för alltid? Det här går inte att ångra."
    },
    "makeCall": {
      "enterPhoneNumber": "För att ringa ett samtal, ange ett telefonnummer i det här fältet.",
      "invalidPhoneNumber": "Twilio Lookup markerade detta telefonnummer som ogiltigt."
    },
    "actions": {
      "markAsStarred": "Markera som stjärnmärkt",
      "unarchive": "Ångra arkivering",
      "unmarkAsStarred": "Avmarkera som stjärnmärkt"
    },
    "send": {
      "perMonthPerIp": "/månad/IP",
      "perIp": "/ IP-adress",
      "replyingTo": "Svarar på",
      "requestClientsPaymentDetails": "Begär kunders betalningsuppgifter",
      "saasModeCreditCardRequired": "SaaS-läge kräver ett kreditkort registrerat för kunden.",
      "please": "Vänligen",
      "firstBeforeEnablingSaaS": "först innan du aktiverar SaaS-läget.",
      "shareALink": "Dela en länk",
      "shareLinkInstructions": "Dela en länk med er klient för att samla in deras betalningsuppgifter",
      "requestViaEmail": "Begäran via e-post",
      "twilioRebillingDescription": "Återfakturera Twilio-kostnader ({twilioCopy}) till dina kunder och inkludera ett påslag",
      "seeHow": "Se hur",
      "phoneRebillingCardInfoRequired": "Telefonåterfakturering kräver att kunden har kortinformation registrerad.",
      "clientsCompanyBillingPage": "kundens företagsfaktureringssida",
      "ifYouPayForTwilioKeepUsing": "Om ni betalar för Twilio, fortsätt att använda samma Twilio-konto",
      "ifClientPaysForTwilioCreateNew": "Om klienten betalar för Twilio, skapa ett nytt Twilio-konto",
      "learnHow": "Lär dig hur",
      "createNewTwilioAccountInstructions": "Skapa ett nytt Twilio-konto för denna plats",
      "learnHowToMovePhoneNumbers": "Lär dig hur du flyttar telefonnummer",
      "thisIsMyClientsTwilioCreateNew": "Det här är min klients Twilio, skapa ett nytt konto",
      "featureUnderDevelopment": "Den här funktionen är under utveckling",
      "emailRebillingDescription": "Återfakturera e-postkostnader till dina kunder och inkludera ett påslag",
      "emailRebillingCardInfoRequired": "Återfakturering via e-post kräver att kortinformation finns registrerad för kunden.",
      "emailRebillingMarginsDescription": "Det här är marginaler som faktureras dina kunder utöver e-postkostnaderna",
      "provider": "Leverantör",
      "morePlanCustomizationsAvailable": "Fler anpassningar av abonnemang tillgängliga",
      "plansAndPricing": "Abonnemang och prissättning",
      "connectYourStripeAccountFirst": "Koppla ditt Stripe-konto först",
      "createRecommendedPlansOnStripe": "Skapa rekommenderade planer på Stripe",
      "createdPlanInStripe": "Skapade en plan i Stripe",
      "customizeYourSaasPlans": "Anpassa dina SaaS-planer",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "Ni kan erbjuda rekommenderade planer eller bygga era egna",
      "trialPeriod": "Provperiod",
      "enterNumberOfDaysForTrial": "Ange antalet dagar för provperioden",
      "nameCantBeEmpty": "Namnet får inte vara tomt.",
      "showStripeProductDetails": "Visa Stripe-produktdetaljer",
      "addEmail": "Lägg till e-postadress",
      "resetMountCounts": "Återställ monteringsantal",
      "connectReconnectGoogleForGbp": "Anslut eller återanslut Google för GBP",
      "downloadFile": "Ladda ner fil",
      "showOnlySlowQueries": "Visa endast långsamma frågor",
      "gmbMessagingAvailable": "GMB-meddelanden är nu tillgängliga",
      "reconnectGbpPageToEnable": "Återanslut din GBP-sida för att aktivera meddelanden",
      "failedPaymentsCheckBilling": "Misslyckade betalningar har upptäckts. Kontrollera din fakturering.",
      "onlyAgencyAdminsCanSeeWarning": "Endast byråadministratörer kan se denna varning.",
      "filter": "Filter",
      "stopDeleteOperation": "Avbryt raderingsåtgärden",
      "summary": "Sammanfattning",
      "enableTracking": "Aktivera spårning",
      "exportAll": "Exportera alla",
      "newConversationStarted": "En ny konversation har startats",
      "startNewConversation": "Starta ny konversation",
      "subAccountScheduledForDeletion": "Underkonto planerat för borttagning",
      "deleteSubAccountOnScheduledTime": "Radera underkonto vid schemalagd tidpunkt",
      "componentUpdatesDebuggerAlpha": "Debugger för komponentuppdateringar (Alpha)",
      "componentUpdateTrackingDisabled": "Komponentuppdateringsspårning är inaktiverad",
      "deleteSubAccount": "Ta bort underkontot",
      "subAccountHasNumbersAndCampaigns": "Detta underkonto har {phoneNumberCount} telefonnummer och {campaignsCount} kampanjer.",
      "subAccountNoNumbersOrCampaigns": "Detta underkonto har inga telefonnummer eller kampanjer.",
      "areYouSureDeleteSubAccount": "Är du säker på att du vill ta bort det här underkontot?",
      "confirmDiscussedWithClient": "Jag bekräftar att jag har diskuterat detta med min kund",
      "understandActionIrreversible": "Jag förstår att den här åtgärden inte kan ångras",
      "confirmDisconnectCloseLcPhone": "Jag bekräftar att jag vill koppla bort och avsluta LC Phone-kontot",
      "choosingNotDeleteLcPhoneWarning": "Varning: Om du väljer att inte ta bort LC Phone-kontot kommer du att fortsätta att debiteras för de telefonnummer som är kopplade till det här underkontot.",
      "deleteAccount": "Ta bort kontot",
      "send": "Skicka",
      "typeMessage": "Skriv ett meddelande",
      "requestPayment": "Begär betalning",
      "reply": "Svara",
      "retry": "Försök igen",
      "analyzeMemory": "Analysera minne",
      "memoryAnalysisApproximate": "🚧 Minnesanalys är ungefärlig och inte 100 % korrekt.",
      "subAccountScheduledForDeletionItWillBeDeleted": "Det här underkontot har schemalagts för borttagning. Det kommer att raderas av",
      "youCanChangeYourMindBeforeThisTime": "Du kan ändra dig innan den här tidpunkten.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Hoppa över",
          "cannotIdentifyContact": "Kan inte identifiera kontakten och dess plats.",
          "contactNotSelected": "Kontakten är inte markerad.",
          "messageRequired": "Kontrollera att du har fyllt i ett meddelande eller en markerad mall.",
          "noPhoneNumber": "Kontakten har inte något telefonnummer.",
          "genericError": "{message}",
          "stayPrompt": "Fortsätt"
        },
        "scheduledSuccess": "E-postmeddelandet har schemalagts",
        "confirmDelete": "Är du säker på att du vill radera {name}?"
      },
      "clear": "Rensa",
      "edit": "Redigera",
      "sendNow": "Skicka nu",
      "schedule": "Schemalägg",
      "useTemplate": "Använd en mall (utdrag)",
      "mergeFields": "Sammanfoga fält",
      "customVariablesError": "Det finns problem i dina anpassade variabler. Åtgärda dem innan du skickar.",
      "sendLater": "Skicka senare",
      "scheduledFor": "Schemalagd till {date}",
      "call": "Anrop",
      "leftVoicemail": "Lämnade ett röstmeddelande",
      "pleaseSelectCampaign": "Välj en kampanj",
      "whatsapp": {
        "no24HourMessage": "Du kan endast skicka mallmeddelanden utanför 24-timmarsfönstret. Välj en mall för att skicka."
      },
      "attachFile": "Bifoga fil",
      "email": {
        "fromEmail": "Avsändarens e-post",
        "fromName": "Från namn",
        "smtpWarning": "SMTP-leverantörer har vissa begränsningar. Klicka här om du vill veta mer.",
        "subject": "Ämne",
        "errors": {
          "cannotIdentifyContact": "Kan inte identifiera kontakten och dess plats.",
          "contactNotSelected": "Kontakten är inte markerad.",
          "genericError": "{message}",
          "bodyRequired": "E-postmeddelandet krävs för att en brödtext ska laddas upp.",
          "noEmailAddress": "Kontakten har ingen e-postadress."
        },
        "scheduledSuccess": "E-postmeddelandet har schemalagts"
      },
      "addCalendarToSchedule": "Du måste lägga till en kalender för att börja schemalägga möten.",
      "slotRequired": "Tidslucka krävs",
      "teamMemberRequired": "Teammedlem krävs."
    },
    "added": "har lagts till",
    "loadMore": "Läs in mer",
    "admin": "Admin",
    "aiEmployee": {
      "popupBlockedAlert": "Du har inaktiverat popup-fönster. Tillåt popup-fönster för den här webbplatsen för att omdirigera till Zoom-samtal automatiskt. Klicka på ”Gå med nu” för att omdirigeras till Zoom-samtalet direkt."
    },
    "alsoCloseAssociatedSubAccount": "Även nära associerad",
    "analyzeMemory": "Analysera minne",
    "announcements": "Meddelanden",
    "apply": "Tillämpa",
    "appointment": {
      "pickDay": "Välj en dag",
      "pickSlot": "Välj en tidslucka för ett möte",
      "selectDate": "Välj datum",
      "selectSlot": "Välj tidslucka",
      "slot": "Tidslucka",
      "day": "Dag"
    },
    "areYouReallySureDeleteSubAccount": "Är du säker på att du vill ta bort det här underkontot?",
    "areYouSureDeleteSubAccount": "Är du säker på att du vill ta bort det här underkontot?",
    "assignedContactOwner": "Tilldelad ({contact} ägare)",
    "assignedToMe": "Tilldelad till mig",
    "audio": {
      "browserNotSupported": "Din webbläsare har inte stöd för ljudelementet.",
      "loadingTranscription": "Läser in transkription ...",
      "viewTranscript": "Visa transkription",
      "stop": "Stopp",
      "playPause": "Spela upp/pausa",
      "timePlayed": "Uppspelad tid : Total tid",
      "mute": "Tysta",
      "playbackSpeed": "Uppspelningshastighet",
      "download": "Ladda ner",
      "remove": "Ta bort"
    },
    "automated": "Automatiserad",
    "avatar": {
      "aiGenerated": "Det här meddelandet genererades av Conversation AI",
      "messengerAutomation": "Messenger-automatisering",
      "workflowGenerated": "Det här meddelandet genererades av Conversation AI i en arbetsflödesåtgärd",
      "messageByAI": "Det här meddelandet genererades av Conversation AI",
      "messageByWorkflow": "Det här meddelandet genererades av Conversation AI i en arbetsflödesåtgärd",
      "agentPrefix": "E-",
      "unknownFallback": "?"
    },
    "bePartOfFastestGrowingCommunity": "Var en del av den snabbast växande communityn.",
    "callHighlevelAt": "Ring HighLevel på +1(888) 732-4197",
    "callQueueTooltip": "Det här samtalet finns i användarens samtalskö och väntar på att aktiveras.",
    "callTranscript": "Samtalstranskription",
    "clearFilters": "Rensa filter",
    "clientsCompanyBillingPage": "klientens företagsfaktureringssida",
    "closeChat": "Stäng chatten",
    "closeConversation": "Stäng konversation",
    "component": {
      "dismissMessage": "AVFÄRDA DETTA MEDDELANDE",
      "unblock": "Avblockera",
      "inboundDndActive": "Inkommande DND har aktiverats för den här kontakten",
      "fetchOlderMessages": "Hämta äldre meddelanden",
      "conversationBegan": "Konversationen började",
      "celebrationTitle": "Jippie! Konversationerna flyter på nu",
      "celebrationBody": "Det här är bara början, nu ska vi utforska hur GHL kan hjälpa dig att bygga upp ditt företag.\nUnder tiden kan du fortsätta skicka meddelanden så mycket du vill"
    },
    "componentUpdateTrackingDisabled": "Spårning av komponentuppdateringar är för närvarande inaktiverad",
    "componentUpdatesDebuggerAlpha": "🚧 Komponentuppdateringsfelsökare (Alpha) - Pågående arbete",
    "confirmDelete": "Radera konversationer?",
    "confirmDeleteTextLine11": "Är du säker på att du vill radera den här konversationen? Den här åtgärden kan inte ångras.",
    "confirmDeleteTextLine12": "konversationer markerade",
    "confirmDeleteTextLine21": "Den här åtgärden kan inte ångras. Vill du fortsätta ändå?",
    "confirmDisconnectedAllIntegrations": "Jag bekräftar att jag har kopplat bort alla integrationer som Twilio, Mailgun, GMB, domäner, Facebook, Zoom etc.",
    "confirmStoppedAllAutomations": "Jag bekräftar att jag har stoppat alla automatiseringar på det här underkontot",
    "connectReconnectGoogleForGbp": "Anslut / Återanslut din Google för att få GBP Messaging!",
    "connectWithCertifiedAdmin": "Anslut med en certifierad administratör",
    "connectWithTeamForHelp": "Kontakta vårt team för hjälp via ett livevideosamtal!",
    "connectWithUs": "Kontakta oss",
    "connectZoomAccount": "Anslut Zoom-konto",
    "contactEngagementScore": "{contact} engagemangspoäng",
    "dailyBrainstormingSessions": "Dagliga brainstorming-sessioner med Highlevel",
    "deleteAccount": "Ta bort kontot",
    "deleteSubAccountOnScheduledTime": "Ta bort underkonto vid schemalagd tidpunkt",
    "disableSaasMode": "Inaktivera SaaS-läget",
    "dnd": {
      "configure": "KONFIGURERA",
      "status": {
        "on": "PÅ",
        "partial": "Delvis"
      }
    },
    "editAppointment": {
      "updateButton": "Uppdatera möte",
      "scheduleAppointment": "Schemalägg möte",
      "editAppointment": "Redigera möte",
      "calendar": "Kalender",
      "selectCalendar": "Välj kalender",
      "roundRobin": "Roterande schemaläggning",
      "pickTeamMember": "Välj teammedlem",
      "selectTeamMember": "Välj teammedlem",
      "teamMemberRequired": "Teammedlem krävs.",
      "slotRequired": "Tidslucka krävs",
      "appointmentTitle": "Mötestitel",
      "appointmentTitleTooltip": "Du kan eventuellt lämna den tom om du vill använda den förinställda mötestiteln",
      "contactName": "Kontaktens namn",
      "name": "Namn",
      "nameRequired": "Namn krävs",
      "emailAddress": "E-postadress",
      "phoneNumber": "Telefonnummer",
      "phoneNumbers": "Telefonnummer",
      "dateOfBirth": "Födelsedatum",
      "contactTimezone": "Kontaktens tidszon (används för påminnelse)",
      "chooseOne": "Välj en …",
      "meetingLocation": "Mötets plats",
      "meetingLocationTooltip": "Du kan eventuellt lämna den tom om du vill använda den förinställda mötesplatsen",
      "status": "Status",
      "appointmentStatus": "Mötesstatus",
      "additionalNotes": "Ytterligare anteckningar",
      "notes": "Anteckningar",
      "actionRequired": "Åtgärd krävs",
      "confirmed": "Bekräftad",
      "invalid": "Ogiltig",
      "cancelled": "Annullerad",
      "showed": "Deltog",
      "noShow": "Uteblev",
      "busy": "Upptagen",
      "free": "Gratis",
      "noCalendarMessage": "Du måste lägga till en kalender för att börja schemalägga möten."
    },
    "email": {
      "errors": {
        "bodyRequired": "E-postmeddelandet krävs för att en brödtext ska laddas upp.",
        "cannotIdentifyContact": "Kan inte identifiera kontakten och dess plats.",
        "contactNotSelected": "Kontakten är inte markerad.",
        "noEmailAddress": "Kontakten har ingen e-postadress."
      },
      "thread": {
        "failedToFetch": "Det gick inte att hämta e-postinnehållet",
        "forward": "Vidarebefordra"
      },
      "reply": "Svara",
      "share": "Dela",
      "facebook": "Facebook",
      "twitter": "Twitter",
      "addAccount": "+ Lägg till ett konto",
      "respond": "Svara",
      "retry": "Försök igen",
      "moreEmailsInThread": "{count} e-postmeddelanden till i tråden",
      "fromName": "Från namn",
      "fromEmail": "Avsändarens e-post",
      "subject": "Ämne",
      "attachFile": "Bifoga fil",
      "useTemplate": "Använd en mall (utdrag)",
      "requestPayment": "Begär betalning",
      "clear": "Rensa",
      "sendNow": "Skicka nu",
      "schedule": "Schemalägg",
      "send": "Skicka",
      "smtpWarning": "SMTP-leverantörer har vissa begränsningar. Klicka här om du vill veta mer.",
      "chooseOne": "Välj ett …",
      "deliveredCount": "{delivered}/{total} har levererats",
      "typeMessage": "Skriv ett meddelande",
      "sendLater": "Skicka senare",
      "scheduledFor": "Schemalagd till {date}"
    },
    "emailRebillingCardInfoRequired": "För att aktivera återfakturering av e-post måste du ange din klients kortinformation på",
    "emailRebillingDescription": "Detta gör att du kan återfakturera e-postkostnader till dina kunder och inkludera ett påslag.",
    "emailRebillingMarginsDescription": "Det här är marginaler som faktureras till dina kunder utöver e-post-kostnaden som du står för.",
    "enableTracking": "Aktivera spårning",
    "exploreHighlevelExperts": "Utforska HighLevel-experter som kan hjälpa er att konfigurera ert system, automatisera arbetsflöden eller anpassa ert projekt.",
    "exportAll": "Exportera alla",
    "facebook": {
      "errors": {
        "generalError": "Ett fel har uppstått. Försök igen eller kontrollera Facebook-integrationen. Felmeddelande:",
        "noFacebookId": "Kontakten har inget Facebook-ID."
      }
    },
    "failedPaymentsCheckBilling": "Du har en eller flera misslyckade betalningar. Kontrollera din faktureringshistorik.",
    "fbMessengerDM": "FB Messenger DM",
    "filters": {
      "above": "Ovanför",
      "aiActionLogs": "AI-åtgärdsloggar",
      "inRange": "Inom intervall",
      "invoice": "Faktura",
      "messageDirectionTooltip": "Filtret kommer att tillämpas på meddelanden efter den 9 maj 2023",
      "appointments": "Möten"
    },
    "followed": "Följs av",
    "followedByMe": "Följs av mig",
    "followedBySpecificUser": "Följs av specifik användare",
    "follower": "Följare",
    "followerAssignmentContact": "Följare ({contact} tilldelning)",
    "gbp": {
      "errors": {
        "generalError": "Ett fel har uppstått. Försök igen eller bock integrationen med Google Business Profile. Felmeddelande:",
        "noGBPId": "Kontakten har inte ett GBP-ID."
      }
    },
    "gbpChatNoLongerAvailable": "Google Business Profile-chatt är inte längre tillgängligt",
    "getAccessToHighlevelWelcomeCourse": "Få tillgång till HighLevels introduktionskurs",
    "getPriorityTroubleshooting": "Få prioriterad felsökning, expertrådgivning och direktåtkomst till vårt tekniska team via Slack.",
    "gmbMessagingAvailable": "Google Business Messaging är tillgängligt för ditt konto.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Betyg:",
      "replyDate": "Svarsdatum:",
      "replyFrom": "Svar från:",
      "review": "Recensera",
      "reviewDate": "Recensionsdatum:",
      "reviewFrom": "Recension från:"
    },
    "highlevelEvents": "Highlevel-evenemang",
    "igMessengerDM": "IG Messenger DM",
    "includeSignatureBeforeQuotedText": "Inkludera denna signatur före citerad text i svar",
    "instagram": {
      "errors": {
        "generalError": "Ett fel har uppstått. Försök igen eller kontrollera Instagram-integrationen. Felmeddelande:",
        "noInstagramId": "Kontakten har inget Instagram-ID."
      }
    },
    "joinOurFacebookGroup": "Gå med i vår Facebook-grupp",
    "keepUpToDateWithLatestNews": "Håll dig uppdaterad med de senaste nyheterna och releaserna!",
    "lastMessageChannel": "Kanal för senaste meddelande",
    "lastMessageDirection": "Riktning för senaste meddelande",
    "lastOutboundMessageType": "Senaste utgående meddelandetyp",
    "learnHow": "Lär dig hur",
    "leftComment": "lämnade en kommentar",
    "leftPanel": {
      "recents": "Senaste",
      "unread": "Oläst",
      "createNewMessage": "Skapa ett nytt meddelande",
      "minCharsRequired": "Minst 3 tecken krävs",
      "twoMoreCharsRequired": "2 ytterligare tecken krävs",
      "oneMoreCharRequired": "Ytterligare ett tecken krävs"
    },
    "liveChat": {
      "endLiveChat": "Avsluta livechatt",
      "errors": {
        "generalError": "Ett fel har uppstått. Försök igen eller bock integrationen med Google My Business. Felmeddelande:"
      },
      "requestContact": "Begär kontakt"
    },
    "live_chat_message": "Livechattmeddelande",
    "made": "gjord",
    "memoryAnalysisApproximate": "🚧 Minnesanalys är ungefärlig och inte 100 % korrekt.",
    "mentioned": "Nämns till",
    "mentions": "Omnämnanden",
    "mentionsOfMe": "Mina omnämnanden",
    "mentionsOfSpecificUser": "Omnämnanden av specifik användare",
    "message": {
      "replyAll": "Svara alla",
      "details": "Detaljer",
      "reply": "Svara",
      "unsuccessful": "Misslyckades",
      "pending": "Väntar",
      "inboundCall": "Inkommande samtal",
      "outboundCall": "Utgående samtal",
      "ivrCall": "IVR-samtal",
      "leftVoicemail": "Lämnade ett röstmeddelande",
      "storyReply": "Svar på story",
      "storyMention": "Omnämnande i story",
      "replyAsDM": "Svara med DM",
      "newCommentOnPost": "Ny kommentar på inlägget {pageName}.",
      "goToPost": "Gå till inlägg",
      "replyNotAvailable": "Det går inte att svara med ett privat DM på kommentarer som är äldre än sju dagar.",
      "addToDocuments": "Lägg till i dokument",
      "attachmentsAddedSuccess": "Bilagorna har lagts till i dokument",
      "attachmentsAddedFailed": "Det gick inte att tillfoga bilagor i dokument",
      "reportFeedbackForAI": "Rapportera feedback för AI",
      "sms": "SMS"
    },
    "messageDetails": {
      "bcc": "BCC",
      "cancelScheduleConfirm": "Är du säker på att du vill avbryta det här schemat?",
      "cancelScheduledMessage": "Vill du avbryta det schemalagda meddelandet?",
      "cancelSend": "Avbryt utskick",
      "cancelScheduledSuccess": "Det schemalagda meddelandet har avbrutits",
      "cancelScheduledError": "Något gick fel när det schemalagda meddelandet skulle avbrytas",
      "cc": "CC",
      "channel": "Kanal",
      "createdBy": "Skapad av",
      "direction": "Riktning",
      "emailCampaign": "E-postkampanj",
      "facebookMessage": "Facebook-meddelande",
      "instagramMessage": "Instagram-meddelande",
      "messageId": "Meddelandets id",
      "messageIdLabel": "Meddelande-ID: ",
      "trigger": "Utlösare",
      "unanswered": "Ej besvarat",
      "yes": "Ja",
      "messageDetails": "Information om meddelandet",
      "from": "Från",
      "fromLabel": "Från:",
      "to": "Till",
      "toLabel": "Till:",
      "unknown": "Okänd",
      "unknownFrom": "Okänd avsändare",
      "unknownTo": "Okänd för",
      "unknownDirection": "Okänd riktning",
      "dateUnknown": "Datum okänt",
      "emailFromUnknown": "E-post från okänd",
      "smsFromUnknown": "SMS från okänd",
      "callFromUnknown": "Samtal från okänd",
      "voicemailFromUnknown": "Röstmeddelande från okänd",
      "emailToUnknown": "E-post till okänd",
      "smsToUnknown": "SMS till okänd",
      "callToUnknown": "Samtal till okänd",
      "voicemailToUnknown": "Röstmeddelande till okänd",
      "failed": "Misslyckades",
      "datetime": "Datum och tid",
      "manual": "Manuell",
      "automation": "Automatisering",
      "workflow": "Arbetsflöde",
      "campaign": "Kampanj",
      "bulkRequest": "Bulk-förfrågan",
      "delivered": "Levererat",
      "bounced": "Avvisat",
      "opened": "Öppnat",
      "sent": "Skickat",
      "scheduled": "Schemalagt",
      "pageName": "Sidnamn",
      "gbpMessage": "GBP-meddelande",
      "no": "Nej",
      "eventsTrackedForContactOnly": "Händelser registreras för närvarande endast för kontaktens e-postadress.",
      "completed": "Slutfört",
      "voicemail": "Röstbrevlåda",
      "busy": "Upptagen",
      "pending": "Väntar",
      "read": "Läs",
      "nativeIntegrations": "Inbyggda integrationer",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "E-post",
      "sms": "SMS",
      "phoneCall": "Telefonsamtal",
      "voiceMail": "Röstmeddelande",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "GBP Messenger",
      "reviews": "Recensioner",
      "others": "Andra",
      "partialDetailsWarning": "Ofullständiga detaljer kommer att vara tillgängliga för meddelanden före den 15 juli 2022.",
      "agencySystem": "Byråsystem",
      "reply": "Svara"
    },
    "multiplePhone": {
      "chooseNumber": "Välj ett nummer för att starta konversationen:",
      "continue": "Fortsätt",
      "noPhones": "Inga telefonnummer är tillgängliga"
    },
    "myChat": "Min chatt",
    "myInbox": "Min inkorg",
    "newConversationStarted": "En ny konversation har startats",
    "newMessage": {
      "title": "Nytt meddelande:",
      "errors": {
        "phoneRequired": "Telefonnummer krävs"
      }
    },
    "noConversationSelected": "Ingen konversation markerad",
    "noResultsToShow": "Inga resultat att visa",
    "onboardingVideoTutorials": "Videoguider för onboarding",
    "onlyAgencyAdminsCanSeeWarning": "Endast byråadministratörer kan se denna varning. För mer information",
    "onlyVisibleToUsers": "Endast synlig för användarna",
    "perMonthPerIp": "/månad/IP",
    "phone": {
      "call": "Ring {name}",
      "callingOptions": "{count} samtalsalternativ",
      "phoneNumbers": "Telefonnummer",
      "callOptions": "{count} samtalsalternativ",
      "dndActive": "DND är aktivt för samtal",
      "primary": "Primär"
    },
    "pleaseDisableSaasMode": "Inaktivera SaaS-läget för detta underkonto",
    "pleaseSelectCampaign": "Välj en kampanj",
    "premiumSupport": "Premiumsupport",
    "quickFilters": "Snabbfilter",
    "reconnectGbpPageToEnable": "Återanslut din GBP-sida för att aktivera det.",
    "replyAsDMTooltip": "Svara på denna kommentar som ett privat DM.",
    "replyingTo": "Svarar på",
    "resetMountCounts": "Återställ monteringsantal",
    "review": {
      "errors": {
        "generalError": "Ett fel har uppstått. Felmeddelande:",
        "googleIntegrationError": "Det gick inte att svara på recensionen. Det verkar finnas ett fel med din Google-integration. Anslut den igen under Inställningar -> Integrationer.",
        "noReviewId": "Konversationen har inget recensions-ID."
      },
      "reviewPostTo": "Recensionspublicering till {network}",
      "sharedOn": "Recension delad på {network}",
      "disputeReview": "Bestrid den här recensionen",
      "learnHow": "(Lär dig hur?)",
      "seeOnGBP": "Se den här recensionen på GBP",
      "alreadyShared": "Denna recension har redan publicerats på {network}. Är du säker på att du vill publicera det igen?"
    },
    "reviewId": "Recensionens id",
    "schedule": {
      "sendSchedule": "Utskicksschema",
      "timezone": "Tidszon ({heading})",
      "title": "Schemalägg ert {type}"
    },
    "scheduling": "Schemalägger...",
    "seeHow": "Se hur",
    "selectFilter": "Välj filter",
    "selected": "markerade",
    "sendEmail": {
      "recipientPlaceholder": "recipient{'@'}example.com",
      "subject": "Ämne:",
      "subjectPlaceholder": "E-postämne",
      "to": "Till:",
      "sending": "Skickar ...",
      "sendButton": "Skicka e-post"
    },
    "setupAccountWithFreeTutorials": "Konfigurera ditt konto med gratis guider",
    "showOnlySlowQueries": "Visa endast långsamma frågor (>{threshold}ms)",
    "sms": {
      "confirmSending": "Bekräfta meddelandeutskick",
      "editModal": {
        "compose": "Skriv SMS"
      },
      "errors": {
        "customVariablesIssue": "Det finns problem i dina anpassade variabler. Åtgärda dem innan du skickar.",
        "messageOrTemplateRequired": "Kontrollera att du har fyllt i ett meddelande eller en markerad mall.",
        "noPhoneNumber": "Kontakten har inte något telefonnummer."
      },
      "scheduledSuccessfully": "SMS har schemalagts",
      "sendAnyway": "Skicka ändå",
      "spamWarning": "Ditt SMS-innehåll kan innehålla referenser till cannabis, SHAFT, vape eller andra förbjudna ämnen. Att skicka sådant innehåll via SMS är strängt förbjudet och kan leda till kontobegränsningar. Granska ditt innehåll noggrant innan du fortsätter.",
      "send": "Skicka"
    },
    "startNewConversation": "Starta ny konversation",
    "subAccountAndDeleteAllPhoneNumbers": "underkonto och radera alla telefonnummer",
    "subAccountScheduledForDeletion": "Detta underkonto är schemalagt för borttagning",
    "subAccountScheduledForDeletionItWillBeDeleted": "Det här underkontot har schemalagts för borttagning. Det kommer att raderas av",
    "teamInbox": "Teaminkorg",
    "threshold": "Tröskelvärde",
    "understandActionIrreversible": "Jag förstår att denna åtgärd är oåterkallelig och att all data i detta underkonto kommer att gå förlorad",
    "unstarred": "Ej stjärnmärkt",
    "use_a_template": "Använd en mall",
    "userAvailability": "Användartillgänglighet",
    "userCalendarConfiguration": "Konfiguration av användarkalender",
    "userInfo": "Användarinfo",
    "userRoles": "Användarroller",
    "viewSupportTickets": "Visa dina supportärenden, våra supportartiklar och hjälpsamma vanliga frågor!",
    "visitOurHelpCenter": "Besök vårt Hjälpcenter",
    "welcomeCourse": "Introduktionskurs",
    "whatsapp_logo": "WhatsApp-logotyp",
    "youCanChangeYourMindBeforeThisTime": "Du kan ändra dig innan den här tidpunkten.",
    "zoomAccount": "Zoom-konto",
    "deleteEmails": "Radera {count} e-postmeddelande(n)",
    "fileAttachment": {
      "urlNotFound": "URL kan inte hittas",
      "unsupportedAttachment": "De här bilagorna kanske inte stöds längre.",
      "downloadFile": "Ladda ner filen"
    },
    "composer": {
      "internalComment": "Intern kommentar"
    },
    "dropdown": {
      "openOptions": "Öppna alternativ",
      "messageDetails": "Information om meddelandet"
    },
    "respond": "Svara",
    "selectTemplate": "Välj en mall",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "Du har inaktiverat popup-fönster. Tillåt popup-fönster för den här webbplatsen för att omdirigera till Zoom-samtal automatiskt. Klicka på ”Gå med nu” för att omdirigeras till Zoom-samtalet direkt.",
        "helpAndSupport": "Hjälp och support",
        "summerOfAI": "Summer of AI"
      }
    },
    "celebration": {
      "dismiss": "Avfärda",
      "body": "Det här är bara början, nu ska vi utforska hur GHL kan hjälpa dig att bygga upp ditt företag.\nUnder tiden kan du fortsätta skicka meddelanden så mycket du vill",
      "title": "Jippie! Konversationerna flyter på nu"
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "hjälpartikel här",
      "message": "Aktivera tredjepartscookies för att visa den här sidan korrekt. Du kan hänvisa till vår",
      "ok": "OK",
      "title": "Tredjepartscookies fungerar inte"
    }
  },
  "crash": {
    "message": "Vi beklagar, men något oväntat har hänt. Försök att uppdatera sidan.",
    "refresh": "Uppdatera sidan",
    "title": "Hoppsan! Något gick fel"
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "Avbryter borttagning för {name}",
      "confirmAbort": "Ja, avbryt",
      "keepDeleting": "Nej, fortsätt radera",
      "message": "Är du säker på att du vill avbryta?",
      "scheduledForDeletion": "Den här platsen är schemalagd för radering den {date}",
      "title": "Avbryt radering",
      "warning": "Observera: Platsen raderas på det schemalagda datumet om du inte avbryter raderingen."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Släpp filer här för att ladda upp",
      "uploadError": "Nätverksfel: Kunde inte skicka begäran till AWS. (Kanske CORS-fel)"
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "Lägg till {entityName}",
      "clonedMessage": "{entityName} klonad! Växla till ett konto där det klonades och upptäck det under {entityName}s flik.",
      "errorGettingDetails": "Det verkar bli fel när detaljer för {entityName} hämtades. Kontrollera URL:en eller försök igen!",
      "permissionError": "Behörighetsfel: Detta är en skyddad tratt och kan inte skapas här."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "GoogleKalender-logotyp"
    },
    "printful": {
      "logo": "Printful-logotyp",
      "title": "Printful: Tryck på begäran"
    },
    "printify": {
      "logo": "Printify-logotyp",
      "title": "Printify: POD"
    },
    "shipStation": {
      "logo": "ShipStation-logotyp",
      "title": "Shipstation"
    },
    "shippo": {
      "logo": "Shippo-logotyp",
      "title": "Shippo: Fraktintegration"
    },
    "tikTok": {
      "accountNotConnected": "Konto ej anslutet",
      "accountNotConnectedMessage": "Ditt konto är inte kopplat till TikTok Ad-kontot. Slutför integrationen för att visa formulär och mappa fält.",
      "advertiserId": "Annonsör-ID",
      "companyFields": "{companyName} Fält",
      "editFields": "Redigera fält",
      "errorSubscribing": "Fel vid prenumeration på sidan.",
      "formsNotAvailable": "Formulär är inte tillgängliga",
      "mandatoryFieldsNote": "Obs! Mappa något av följande obligatoriska fält för att få potentiella kunder till ditt konto. Fält: Förnamn, Efternamn, E-postadress, Telefonnummer",
      "noFormsMessage": "Du har för närvarande inte skapat något formulär för generering av potentiella kunder i ditt TikTok-annonskonto. Besök ditt TikTok-annonskonto och skapa ett för att komma igång.",
      "pageId": "Sid-ID",
      "selectAdvertiserAccount": "Välj annonsörskonto"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Annat / Jag vet inte",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "Du måste slutföra några enkla steg för att pausa detta underkonto"
    },
    "transfer": {
      "chooseDescription": "Välj din överföringsmetod",
      "chooseMethod": "Överför det här underkontot",
      "eject": {
        "description": "Tjäna 40 % återkommande provision på det nya kontots abonnemang.",
        "title": "Gör fristående som nytt konto"
      },
      "modal": {
        "confirmDetails": "Bekräfta detaljerna innan du överför",
        "confirmNomineePrefix": "Nominera ägare för",
        "confirmTransfer": "Bekräfta överföring",
        "consentText": "Jag har läst och förstått ovanstående guide och samtycker till alla begränsningar",
        "ejectErrorTitle": "Det går inte att göra underkontot fristående.",
        "ejectGenericError": "Underkontot som du försöker göra fristående kan inte göras fristående. Kontakta supporten.",
        "ejectGuidelines": "Riktlinjer för att göra underkonton fristående",
        "ejectSubject": "Att göra underkonton fristående är beroende av att användaren godkänner förfrågan om att skapa en ny byrå.",
        "ejectSuccessTitle": "Förfrågan om att göra underkontot fristående har skickats till markerad användare",
        "enterPassword": "Ange ditt lösenord för att bekräfta",
        "genericError": "Underkontot som du försöker överföra kan inte överföras. Kontakta supporten.",
        "guidelines": "Riktlinjer för överföring av underkonton",
        "guidelinesConsent": "Läs och godkänn",
        "hipaaDisclaimer": "Ansvarsfriskrivning",
        "hipaaText": "Du kanske vill meddela detta underkonto att de för närvarande omfattas av HIPAA-skyddet, men att de kanske inte får samma skydd hos den byrå som de överförs till.",
        "noUsersDescription": "Det finns inga användare kopplade till detta underkonto. Lägg till en användare på underkontot och fortsätt.",
        "noUsersSearch": "Inga användare hittades.",
        "noUsersTitle": "Inga användare hittades",
        "nomineeInstructions": "Den nominerade personen får en länk för att registrera sig på HighLevel",
        "passwordError": "Ogiltigt lösenord",
        "passwordErrorDescription": "Lösenordet du angav är felaktigt. Försök igen.",
        "relationshipError": "Ange korrekt relationsnummer",
        "relationshipNumber": "Mottagande byrås relationsnummer",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Begär överföring",
        "seeAllRequests": "Se alla förfrågningar",
        "successMessage": "Underkontot kommer att överföras när den mottagande byrån accepterar din överföringsförfrågan.",
        "successTitle": "Förfrågan om att överföra underkonto har skickats till mottagande byrå",
        "title": "Överför underkonto",
        "transferSubject": "Överföring av underkonto är beroende av att den mottagande byrån accepterar det till sitt konto.",
        "confirmNomineeSuffix": " till "
      },
      "transferExisting": {
        "description": "Överför hela underkontot till ett annat konto.",
        "title": "Överför till ett befintligt konto"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Nästa exekvering",
      "title": "Bulk-förfrågningar"
    },
    "campaign": {
      "account": "Konto",
      "accountBuffer": "Kontobuffert",
      "accountBufferDescription": "Det finns ingen gräns för antalet mottagare som läggs till i den här kampanjen varje dag (från en lista).",
      "accounts": "Konton",
      "activity": "Aktivitet",
      "acquire": "Förvärva",
      "acquisitionDescription": "Kundförvärvskampanjer hjälper dig att producera fler ”heta” säljleads som är redo att engagera sig.",
      "addEvent": "Lägg till händelse",
      "addUser": "Lägg till användare",
      "allMarket": "Hela marknaden",
      "allowMultiple": "Tillåt flera",
      "assignedToTooltip": "När kampanjen startades tilldelades denna kontakt den här användaren. Ändringar i kontaktens tilldelning kommer att återspeglas i händelserna, men ändrar inte detta initialvärde.",
      "atLeastOneEvent": "Minst en händelse krävs.",
      "automations": "Automatiseringar",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quaerat pariatur consequatur rerum neque a, id, nam nostrum iure accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod distinctio vero et quia omnis? Corporis omnis, ipsa in, quae iste libero minus, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur! Quis ratione iure modi eos quaerat facere molestiae. Quaerat voluptatibus distinctio sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "Avvisat",
      "buffering": "Buffrar",
      "campaignActivity": "Kampanjaktivitet",
      "campaignConfiguration": "Kampanjkonfiguration",
      "campaignConfigurationWarning": "Kampanjkonfigurationen påverkar alla marknader. Se till att du måste göra ändringar i dessa inställningar.",
      "campaignCreation": "Skapande av kampanj",
      "campaignId": "Kampanj-ID",
      "campaignStatusByRecipients": "Kampanjstatus per mottagare",
      "clickThroughRate": "Klickfrekvens",
      "clickedThrough": "Klickade genom",
      "conditionIfExplanation": "Kör denna kampanj eller händelse om den nuvarande tiden ligger inom detta fönster, om den nuvarande tiden ligger utanför detta fönster, hoppa över kampanjen eller händelsen och gå vidare till nästa.",
      "conditionWhenExplanation": "Kör händelserna i den här kampanjen när den aktuella tiden infaller i det här fönstret, annars vänta till nästa fönster med att köra händelserna.",
      "createCampaign": " Skapa kampanj",
      "ctr": "CTR",
      "customerAcquisition": "Kundanskaffning",
      "dateAdded": "Datum tillagt",
      "dateAddedTooltip": "Det exakta datumet och tiden då kontakten lades till i den här kampanjen. Första starttiden för händelsen kan variera beroende på konfigurationerna.",
      "deletedRestorePrompt": "Den här kampanjen är raderad! Vill du återställa den?",
      "delivered": "Levererad",
      "deliveryRate": "Leveransfrekvens",
      "draftMode": "Utkastläge",
      "draftModeDescription": "Den här kampanjen är ett utkast. Den kan inte användas förrän den har publicerats.",
      "dropped": "Upphörde",
      "emailActivity": "E-postaktivitet",
      "emailActivityFilterExample": "E-postaktivitet: Klickade genom",
      "event": "Händelse",
      "eventFilterExample": "Händelse: 10X e-post 4 (listningsdistribution)",
      "filters": "Filter",
      "emailPerformanceByAccount": "E-postprestanda per konto",
      "emailsNotSentOnDays": "E-postmeddelanden kommer inte att skickas på lördagar och söndagar.",
      "emailsSentOnDays": "E-postmeddelanden skickas på måndag, tisdag, onsdag, torsdag och fredag.",
      "eventStartDate": "Händelsens startdatum",
      "exampleAddress": "801 7th Avenue North, Saskatoon, SK",
      "exampleCompanyName": "City Perks Coffeehouse",
      "exampleDate": "8 maj 2017 13:27",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Se till att informationen inte är äldre än 30 dagar",
      "exampleEventName": "10X e-post 4 (listningsdistribution)",
      "getMoreCustomers": "Få Mer Kunder",
      "inProgress": "Pågående",
      "includedDays": "Inkluderade dagar",
      "internalSource": "Intern källa",
      "lastUpdate": "Senast uppdaterad den",
      "leadValuePlaceholder": "Värde av potentiell kund i USD",
      "loopDetected": "Den här kampanjen har låsts i utkaststatus eftersom den orsakar en loop. För att aktivera denna kampanj, kontakta supporten.",
      "market": "Marknad",
      "moreDetails": "Fler detaljer",
      "myCampaigns": "Mina kampanjer",
      "na": "Ej tillämpligt",
      "newFolder": " Ny mapp",
      "nextCampaign": "Nästa kampanj",
      "nextExecutionTime": "Nästa exekveringstid",
      "opened": "Öppnad",
      "openRate": "Öppningsfrekvens",
      "option2": "Alternativ 2",
      "option3": "Alternativ 3",
      "pageNavigation": "Exempel på sidnavigering",
      "processed": "Bearbetad",
      "published": "Publicerad",
      "recipient": "Mottagare",
      "recipients": "Mottagare",
      "sampleCampaign": "Exempelkampanj ",
      "scheduling": "Schemaläggning",
      "seeHotLeads": "Se heta potentiella kunder",
      "selectDateRange": "Välj datumintervall",
      "selectTimeZone": "Välj tidszon",
      "separator": " / ",
      "showingCount": "Visar {current} av {total}",
      "spamReport": "Skräppostrapport",
      "startByAddingEvent": "Börja med att lägga till en händelse i den här kampanjen.",
      "stopOnResponse": "Stopp på svar",
      "stopped": "Pausad",
      "time": "Tid",
      "timeConditionNote": "Obs! Om det första steget i kampanjer är inställt på Omedelbart gäller inte tidsvillkoret för det första steget.",
      "timeZoneDescription": "Den här inställningen påverkar tiden då ditt innehåll skickas.",
      "totalLeads": "Totalt antal potentiella kunder",
      "undeliverable": "Ej levererbar",
      "unsubscribe": "Avprenumerera",
      "upNext": "Kommer härnäst",
      "utc": "UTC",
      "window": "Fönster"
    },
    "embed": {
      "copyLinkInstructions": "Kopiera länken nedan och dela den enkelt var du vill.",
      "embed": "Inbäddad",
      "iframeEmbed": "Iframe-inbäddning",
      "integrateInstructions": "Använd följande alternativ för att integrera ditt anpassade formulär på en webbplats",
      "integrateYourForm": "Integrera ditt formulär",
      "link": "Länk",
      "saveAndExit": "Spara och avsluta"
    },
    "jotbox": {
      "deleteSubmission": "Ta bort inlämning",
      "downloadPdf": "Ladda ner PDF",
      "ofSubmissions": " av {total} inlämningar",
      "pages": "sidor",
      "records": "register",
      "searchPlaceholder": "Sök på namn, e-post, telefon och kontakt-id",
      "selectYourForm": "Välj ditt formulär",
      "timeSigned": "Tid för underskrift:",
      "totals": "Totaler:"
    },
    "survey": {
      "createNewSurvey": "Generera ny undersökning",
      "integrateYourSurvey": "Integrera er undersökning",
      "noSurveysForAnalyze": "Du har inga undersökningar än. Skapa en undersökning först för att se analysen här.",
      "noSurveysForSubmission": "Du har inga undersökningar än. Skapa en undersökning först för att se inlämningar här.",
      "noSurveysYet": "Du har inga undersökningar än.",
      "refreshData": "Uppdatera data",
      "searchSurveys": "Sök efter undersökningar",
      "surveyBuilder": "Undersökningsbyggare",
      "toCreateFirstSurvey": "för att skapa din första undersökning."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "Produkten klonad! Växla till ett konto där det klonades och upptäck det under fliken Medlemskap > Produkter.",
      "errorGettingDetails": "Det verkar bli fel när produktdetaljer ska hämtas. Kontrollera URL:en eller försök igen!"
    },
    "resetPassword": {
      "title": "Återställ lösenord",
      "button": "Återställ lösenord",
      "newPassword": "Nytt lösenord",
      "generateStrongPassword": "Skapa ett starkt lösenord",
      "sendEmailNotification": "Skicka även en e-postavisering.",
      "errorMessage": "Ett fel inträffade när du återställde lösenordet. Försök igen.",
      "updating": "Uppdaterar ..."
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ av",
      "combo": {
        "signedUp": "registrerade sig för ProveSource under det senaste dygnet",
        "verifiedBy": "verifierad via "
      },
      "conversions": {
        "recentlyBought": "nyligen köpte detta",
        "timeAgo": "under de senaste 16 minuterna ",
        "visitorsCount": "50 besökare"
      },
      "pageVisits": {
        "description": "verkar också vara hungriga.",
        "timeAgo": "under de senaste 21 minuterna                        ",
        "title": "50 matälskare"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " ProofMessage",
        "rating": "5-stjärnigt betyg",
        "recently": "Nyligen",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "registrerades för ProveSource",
        "location": "(London, Storbritannien)",
        "name": "Mike ",
        "timeAgo": "40 minuter sedan                        "
      },
      "visitors": {
        "description": "musikälskare online"
      }
    },
    "step1": {
      "combo": {
        "description": "Visa det totala antalet personer som utförde en specifik åtgärd under 24 timmar, 7 eller 30 dagar.",
        "title": "Combo"
      },
      "conversions": {
        "description": "Skapa social validering genom att visa hur många kunder som utförde en specifik åtgärd."
      },
      "liveReviews": {
        "description": "Visa dina besökare 4+-stjärniga recensioner i realtid från de senaste 6 månaderna."
      },
      "liveVisitors": {
        "beta": "Beta",
        "description": "Visa hur många besökare som just nu tittar på hela din webbplats i realtid."
      },
      "pageVisits": {
        "description": "Visa dina besökare att de inte är de enda på festen genom att lyfta fram de senaste sidbesöken."
      },
      "stream": {
        "description": "Vad är bättre än att sätta ett ansikte på det där sociala beviset? Visa dina senaste kunder och deras handlingar."
      }
    },
    "step2": {
      "captureDescription2": "Varje sid-URL måste ha ett e-postformulärfält",
      "captureDescription3": " och ProveSource installerat. ",
      "comboType": "Kombinationstyp",
      "connectAccounts": "Se till att koppla de konton du vill hämta recensioner från",
      "connectGoogleAccount": "Anslut Google-konto för din plats",
      "formSubmissions": "Inlämnade formulär",
      "googleAccount": "Google-konto",
      "howToTrack": "Hur du spårar",
      "howToTrackDescription": "Hur ska vi spåra dina konverteringar?",
      "pageUrl": "Sidans URL",
      "productPurchase": "Produktköp",
      "trackAllUrls": "Spåra alla sid-URL:er som innehåller följande uttryck. ",
      "trackVisitors": "Spåra besökare",
      "trackVisits": "Spåra besök",
      "urlTip": " Vi behandlar http://, https://, www och icke-www som separata versioner av URL:en och sidan. ",
      "urlValidationError": "Du måste inkludera minst en URL. URL:en är ogiltig. Se till att inkludera http:// eller https://",
      "userSignup": "Användarregistrering",
      "visits": " Besök",
      "webhookDescription": "Anropa följande slutpunkt för att informera oss om en händelse eller konvertering som inträffat på din sida och som är relaterad till den här aviseringen, så sköter vi resten.",
      "webhookRequest": "Webhook-begäran",
      "whatToTrack": "Vad vill du spåra?",
      "whereToCapture": "Var det ska registreras",
      "whereToCaptureDescription": "Var registrerar du konverteringar?",
      "whichPagesToTrack": "Vilka sidor vill du spåra?",
      "yourWebhookUrl": "Din webhook-URL"
    },
    "step3": {
      "allPages": " Alla sidor",
      "displayOnAllPages": "Visa på alla sid-URL:er som innehåller följande uttryck: ",
      "whereToDisplay": "Var ska det visas",
      "whereToDisplayActivity": "Var vill du att vi visar den här aktiviteten?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "för snygga ikoner (högerklicka på en ikon -> Kopiera bildadress)",
      "messageSettings": "Meddelandeinställningar",
      "messageText": "Meddelandetext",
      "referToVisitorsAs": "Hänvisa till besökare som",
      "visitIcons8": "Besök"
    },
    "step5": {
      "allowUsersToClose": " Tillåt användare att stänga aviseringen ",
      "behavior": "Beteende",
      "bottomLeft": "Botten till vänster",
      "bottomRight": "Botten till höger",
      "clickableNotification": " Klickbar avisering ",
      "customizeDescription": "Ändra följande inställningar för att styra beteendet och utseendet på din avisering",
      "design": "Design",
      "displayNotificationFor": "Visa avisering i",
      "displayRules": "Visningsregler",
      "hideOnMobileScreens": " Dölj på mobila skärmar ",
      "linkRelativeNote": " Om http:// utelämnas öppnas länken relativt till den visade sidan ",
      "minimumEventsToDisplay": "Minsta antal händelser att visa",
      "notificationLink": "Aviseringslänk",
      "notificationPosition": "Aviseringsposition",
      "openLinkInNewTab": "Öppna länk i ny flik",
      "selectPosition": "Välj position",
      "showOnlyOncePerSession": " Visa endast en gång per session ",
      "titleBackground": "Titelbakgrund",
      "titleColor": "Titelfärg",
      "topLeft": "Överst till vänster",
      "topRight": "Överst till höger",
      "typeUrlHere": "Skriv URL här"
    },
    "step6": {
      "identifyNotification": "Identifiera din avisering",
      "launchMessage": "Vi är på väg att lansera, inta ta din plats och fäst säkerhetsbältet.",
      "notificationName": "Aviseringsnamn",
      "notificationNamePrompt": "Vad heter din avisering?",
      "wellDone": "Bra gjort."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Prenumeration har skapats",
      "youCanNowSetupWordPress": "Nu kan du konfigurera din WordPress-webbplats",
      "subscriptionFailed": "Prenumerationen misslyckades",
      "resubscriptionSuccessful": "Återprenumeration lyckades",
      "successfullyReactivated": "Er WordPress-prenumeration har återaktiverats framgångsrikt",
      "reactiveSub": "Det gick inte att återaktivera prenumerationen",
      "resubscriptionFailed": "Återprenumeration misslyckades"
    },
    "v2": {
      "viewDetails": "Visa detaljer",
      "chatConversationAssigned": "Chattsamtal tilldelat",
      "internalChat": "Intern chatt",
      "newTask": "Ny uppgift",
      "appointmentReminder": "Påminnelse om möte",
      "facebookReview": "Facebook-recension",
      "googleReview": "Google-recension",
      "internalChatMessage": "Internt chattmeddelande",
      "newAppointmentAssigned": "Nytt möte tilldelat",
      "newAppointmentBooked": "Nytt möte bokat",
      "newCall": "Nytt samtal",
      "newEmail": "Nytt e-postmeddelande",
      "newMention": "Nytt omnämnande",
      "newReviewReceived": "Ny recension mottagen från {contactName}",
      "taskReminder": "Påminnelse om uppgift",
      "completed": "slutförd",
      "failed": "misslyckades",
      "subAccount": "Underkonto",
      "newMessage": "Nytt meddelande",
      "newAppointmentBookedWith": "Nytt möte bokat med {contactName}",
      "newAppointmentAssignedTo": "Nytt möte tilldelat till {contactName}",
      "appointmentDueIn": "Möte om {minutes} minuter med {contactName}",
      "newTypeReceived": "Ny {type} har mottagits från {contactName}.",
      "newChatAssigned": "Ny chatt har tilldelats från {contactName}",
      "taskDueDate": "Uppgiften {title} förfaller den {date} kl. {time} för {contactName}",
      "tasksDueToday": "{count} uppgifter förfaller idag",
      "tasksOverdue": "{count} uppgifter försenade",
      "taskDueIn": "Uppgift {title} förfaller om {dueTime} {unitOfTime} för {contactName}",
      "mentionedInConversation": "{userName} har nämnt dig i en konversation med {contactName}",
      "now": "nu"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Företagslogotyp"
      },
      "bestExperience": "bästa upplevelsen.",
      "optimizedFor": "Den här sidan är optimerad för",
      "portraitMode": "porträttläge",
      "toGiveYou": "för att ge dig den"
    }
  },
  "pagination": {
    "goToFirstPage": "Gå till första sidan",
    "goToLastPage": "Gå till sista sidan",
    "goToNextPage": "Gå till nästa sida",
    "goToPreviousPage": "Gå till föregående sida",
    "itemsSelected": "{count} markerade objekt",
    "showingEntries": "Visar {from} till {to} av {total} poster"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/ min",
    "_please_add_a_payment_method_for": "! Lägg till en betalningsmetod för",
    "_segment": "/ segment",
    "ad_manager": "Annonshanterare",
    "add": "[Lägg till:",
    "ai_employee": "AI-medarbetare",
    "billing": {
      "incompleteBillingInfo": "Du har ofullständiga faktureringsdetaljer på det här kontot. Uppdatera det omedelbart.",
      "updateNow": "Uppdatera nu"
    },
    "charge": "Avgift",
    "contactLimit": {
      "message": "Du har nått gränsen för att lägga till {contact} i ditt nuvarande abonnemang. För att fortsätta, uppgradera ditt abonnemang och lås upp ytterligare kapacitet.",
      "upgradeNow": "Uppgradera nu",
      "warningMessage": "Du har {current} kontakt(er) medan ditt abonnemang endast tillåter upp till {limit}.",
      "warningTitle": "Kontoanvändningen har överskridit gränsen. Uppgradera för att fortsätta arbeta utan avbrott."
    },
    "cost_borne_by_you": "som du står för",
    "dedicated_ip": "Dedikerad IP-adress",
    "electeditem": "Valt objekt",
    "feedback": "Feedback:",
    "hello": "Hej",
    "helpDrawer": {
      "aiSupportAssistant": "AI-supportassistent",
      "clickToCopy": "Klicka för att kopiera relationsnummer",
      "clickToCopyToClipboard": "Klicka för att kopiera relationsnummer till urklipp",
      "companyRelationshipNumber": "Företagsrelationsnummer",
      "hiImHighly": "Hej, jag är Highly!",
      "implementation": "Implementering",
      "joinImplementationVideo": "Delta i implementeringsvideosamtalet",
      "joinTrialZoom": "Delta i Zoom-provsamtal",
      "kickoff": "kick-off",
      "needHelpChatVideo": "Behöver du hjälp? Starta en chatt eller ett videosamtal med oss nu!",
      "openAIAssistant": "Öppna AI-supportassistenten",
      "premium": "Premium",
      "priority": "Prioritet",
      "raiseSupportTicket": "Skapa ett supportärende",
      "raiseTicket": "Skapa ärende",
      "relationshipNumber": "Relationsnummer",
      "startAISupportChat": "Starta AI-supportchatt",
      "startAgentChatWait": "Starta agentchatt med en väntetid på 2–5 minuter",
      "startChatChoose": "Starta chatt – välj mellan AI-support eller agentchatt",
      "startImplementationVideo": "Starta implementeringsvideosamtalet",
      "startZoom": "Starta Zoom",
      "startZoomCall": "Starta Zoom-samtal",
      "subtitle": "Oavsett om du vill prata med oss, communityn eller lära dig på egen hand så har vi allt du behöver!",
      "title": "Hjälp och support",
      "trialExperience": "Proverfarenhet",
      "useButtonsBelow": "Använd någon av knapparna nedan för att få hjälp!",
      "videoCallReward": "Gå med i ett videosamtal för att skapa ditt konto – och få {amount} krediterat till din plånbok när du deltar.",
      "videoCallType": "Gå med i ett videosamtal med mig för ditt {type}-samtal.",
      "yourPremiumSupportSpecialist": "Din {type}-supportspecialist",
      "yourSpecialist": "Din {type}-specialist",
      "yourSupportSpecialist": "Din supportspecialist",
      "videoCall": "Videosamtal",
      "active": "Aktiv",
      "announcementsAria": "Meddelanden – klicka för att öppna i en ny flik",
      "chat": "Chatt",
      "accessWelcomeCourseAria": "Klicka för att komma åt HighLevels välkomstkurs",
      "clickToUpgrade": "Klicka för att uppgradera",
      "connectCertifiedAdminAria": "Anslut med en certifierad administratör – klicka för att öppna i en ny flik",
      "connectWithUsAria": "Kom i kontakt med oss – starta livechatt",
      "contactUsAria": "Kontakta oss – ring HighLevel på +1(888)732-4197",
      "copied": "Kopierad",
      "highlevelEventsAria": "Highlevel Events – klicka för att öppna i ny flik",
      "joinFacebookGroupAria": "Gå med i vår Facebook-grupp – klicka för att öppna i ny flik",
      "onboardingVideoTutorialsAria": "Introduktionsvideohandledningar – klicka för att öppna i en ny flik",
      "recommended": "Rekommenderad",
      "visitHelpCenterAria": "Besök vårt hjälpcenter – klicka för att öppna i en ny flik",
      "contactUs": "Kontakt oss",
      "agentChatWaitTime": "Agentchatt (~2–5 minuters väntetid)",
      "aiSupportChat": "AI-supportchatt",
      "startChat": "Starta chatt",
      "announcements": "Meddelanden",
      "fastestGrowingCommunity": "Var en del av den snabbast växande communityn.",
      "callHighlevelPhone": "Ring HighLevel på +1(888)732-4197",
      "connectCertifiedAdmin": "Anslut med en certifierad administratör",
      "connectTeamVideoCall": "Kontakta vårt team för hjälp via ett livevideosamtal!",
      "connectWithUs": "Kontakta oss",
      "dailyBrainstormingSessions": "Dagliga brainstorming-sessioner med Highlevel",
      "certifiedAdminDescription": "Utforska HighLevel-experter som kan hjälpa dig att konfigurera ditt system, automatisera arbetsflöden eller anpassa ditt projekt.",
      "getAccessWelcomeCourse": "Få tillgång till HighLevels introduktionskurs",
      "premiumSupportDescription": "Få prioriterad felsökning, expertrådgivning och direktåtkomst till vårt tekniska team via Slack.",
      "highlevelEvents": "Highlevel-evenemang",
      "joinFacebookGroup": "Gå med i vår Facebook-grupp",
      "onboardingVideoTutorials": "Videoguider för onboarding",
      "premiumSupport": "Premiumsupport",
      "setupAccountFreeTutorials": "Konfigurera ditt konto med gratis guider",
      "viewSupportTicketsArticles": "Visa dina supportärenden, våra supportartiklar och hjälpsamma vanliga frågor!",
      "visitHelpCenter": "Besök vårt Hjälpcenter",
      "welcomeCourse": "Introduktionskurs",
      "beta": "Beta",
      "closeHelpSupportDrawer": "Stäng Hjälp och support-fönstret",
      "upgradePlanToEnable": "Ni behöver uppgradera ert abonnemang för att aktivera den här funktionen",
      "premiumSupportActive": "Din premiumsupport är aktiv",
      "premiumSupportClickUpgrade": "Premiumsupport – Klicka för att uppgradera ditt abonnemang",
      "premiumSupportActiveAria": "Premiumsupport – Er premiumsupport är aktiv",
      "keepUpToDateNews": "Håll dig uppdaterad med de senaste nyheterna och releaserna!"
    },
    "hi": "Hej",
    "is_scheduled_for_deletion_on": "är planerad att raderas den",
    "k": "K",
    "limit_updated_from": "Gränsen uppdaterades från",
    "minimum_must_be": "Minsta måste vara",
    "more_emails_in_thread": "fler e-postmeddelanden i tråden",
    "multipleUsers": {
      "chooseAccount": "Välj ett konto för att fortsätta"
    },
    "must_be_in_range_of_0": "Måste vara inom intervallet 0-",
    "numbers_and": "antal och",
    "premiumSupport": {
      "assigningManager": "Tilldelar teknisk kontoansvarig ...",
      "bookCall": "Boka ett samtal",
      "hiIm": "Hej, jag är {name}",
      "joinZoomNow": "Gå med i Zoom-samtalet",
      "quickActions": "Snabba supportåtgärder",
      "quickLinks": "Snabblänkar",
      "raiseFeatureRequest": "Skapa en funktionsförfrågan",
      "slackChannelCreating": "Håll ut – din Premium Slack-kanal håller på att startas! 🚀",
      "technicalAccountManager": "Teknisk kontoansvarig",
      "viewRoadmap": "Visa produktfärdplan"
    },
    "prospecting": "Prospektering",
    "reloadPopup": {
      "message": "Vi har märkt att du inte har uppdaterat sidan på ett tag. Ladda om appen för att få den bästa upplevelsen.",
      "refreshNow": "Uppdatera nu"
    },
    "resell_settings": "Återförsäljningsinställningar",
    "row": "rad",
    "select_upto": "Välj högst",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Få dedikerad support när det passar dig.",
      "title": "Boka ett samtal med Highlevels support"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "Det här är marginaler som faktureras till dina kunder utöver",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "Låt oss hantera Twilio åt dig utan problem",
        "benefit2": "Vårt supportteam tar hand om dina Twilio-problem",
        "button": "Gör det åt mig",
        "drawback": "Betala {price} extra på VAS jämfört med om du gör det själv",
        "title": "Vi gör det åt dig"
      },
      "lowCreditsMessage": "Du måste ansluta ett Twilio-konto för att hantera samtal och sms som skickas/tas emot på HighLevel.",
      "lowCreditsTitle": "Du har bara ett fåtal gratis Twilio-krediter kvar, men vi hjälper dig!",
      "selfSetup": {
        "benefit1": "Hantera dina utgifter",
        "benefit2": "Få mer kontroll över din Twilio-tjänst",
        "button": "Jag löser det",
        "drawback1": "Anlita någon för att hantera Twilio-tjänsten",
        "drawback2": "Kontakta Twilios support när något inte fungerar.",
        "title": "Gör det själv"
      },
      "wip": {
        "button": "Konfigurera Twilio nu",
        "fallback": "För tillfället måste du hantera ditt eget Twilio-konto.",
        "message": "Tack för att du valde oss, men vi arbetar fortfarande med att utveckla den här funktionen. Du kommer att höra från oss så snart vi kan lansera detta för ditt konto.",
        "title": "Vi arbetar fortfarande på det !!"
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "Läs in fler alternativ ...",
      "noElementsFound": "Hoppsan! Inga element hittades. Överväg att ändra sökfrågan.",
      "noLocationsFound": "Inga platser hittades. Prova en annan sökning.",
      "typeToSearch": "Skriv för att söka",
      "enterUserEmail": "Ange användarens e-postadress"
    },
    "updating": "Uppdaterar",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Använd mall"
    },
    "validEmail": {
      "andYouCan": "Och du kan",
      "as": "som",
      "canReverify": "Du kan verifiera din e-postadress igen",
      "emailIs": "Den här e-postadressen är",
      "emailMarkedAs": "Den här e-postadressen har markerats som",
      "markedAsInvalid": "Detta e-postmeddelande är markerat som",
      "notVerified": "Inte verifierad",
      "reverifyHere": "Verifiera på nytt här",
      "verifyHere": "Verifiera här"
    },
    "will_give_you_about": "kommer att ge er ungefär",
    "checkout": {
      "confirm": "Bekräfta",
      "cardInformation": "Kortuppgifter",
      "cardNumberInvalid": "Ditt kortnummer är ogiltigt.",
      "commitment": "åtagande",
      "paymentConsent": "Genom att bekräfta tillåter du att LeadConnector debiterar ditt kort för denna betalning.",
      "subscriptionConsent": "Genom att bekräfta ditt abonnemang tillåter du LeadConnector att debitera ditt kort för denna betalning och framtida betalningar för detta abonnemang.",
      "endingIn": "slutar på",
      "month": "månad",
      "pay": "Betala",
      "payWithCard": "betala med kort",
      "paymentBeingProcessed": "Betalningen behandlas. Uppdatera inte sidan och tryck inte på bakåtknappen",
      "proceedWithExistingCard": "Fortsätt med befintligt kort",
      "proceedWithNewCard": "Fortsätt med ett nytt kort",
      "purchase": "köp",
      "subscribe": "Prenumerera",
      "subscribeTo": "Prenumerera på",
      "pleaseUpdateCardDetails": "Uppdatera kortuppgifterna",
      "zip": "postnummer",
      "retry": "försök igen",
      "initialChargesProrated": "Initiala avgifter är proportionellt fördelade och regelbunden fakturering kommer att börja från",
      "youWillBeChargedFor": "Du kommer att debiteras för",
      "days": "dagar",
      "rightNowForPeriodTill": "just nu för perioden fram till",
      "startGettingChargedFullAmount": "och börja debiteras det fulla beloppet",
      "perMonthStartingFrom": "/månad med start från",
      "nameOnCard": "Namn på kortet",
      "somethingWentWrong": "Något gick fel",
      "errorImg": "felbild",
      "networkError": "Nätverksfel, försök igen om en stund",
      "paymentCouldNotBeProcessed": "Betalningen kunde inte behandlas. Försök att lägga till ett kort igen."
    },
    "deleteLocation": {
      "back": "Tillbaka",
      "delete": "Radera",
      "completeStepsToDelete": "Du måste slutföra några enkla steg för att radera den här platsen",
      "alsoCloseAssociated": "Även nära associerad",
      "scheduling": "Schemalägger...",
      "subAccountAndDeletePhoneNumbers": "underkonto och radera alla telefonnummer",
      "somethingWentWrongTryAgain": "Något gick fel ... Försök igen om en stund.",
      "deleteSubAccount": "Ta bort underkontot",
      "scheduleForDeletion": "Schemalägg för borttagning"
    },
    "productRebilling": {
      "enableRebilling": "Aktivera återfakturering",
      "ratesMayDifferUK": "Priserna kan variera beroende på region. De visade beräkningarna är baserade på priser för Storbritannien,",
      "examplePricingGpt4oMini": "Exempelprissättning – GPT-4o Mini",
      "input": "Indata",
      "output": "Utdata",
      "supportDoc": "supportdokument",
      "unsavedChanges": "Osparade ändringar",
      "to": "till",
      "chargedToCustomerLower": "Debiteras kunden",
      "model": "Modell",
      "profit": "Vinst",
      "saving": "Sparar ...",
      "type": "Typ",
      "updating": "Uppdaterar ...",
      "clickHere": "Klicka här",
      "chargedToCustomer": "Debiteras till kunden",
      "enabling": "Aktiverar ...",
      "forMoreDetails": "för mer information.",
      "tenDollarsWillGive": "10 USD ger dig ungefär",
      "yourCost": "Din kostnad",
      "seeHow": "Se hur",
      "clientCompanyBillingPage": "kundens företagsfaktureringssida",
      "connectStripeToEnable": "För att aktivera återfakturering måste du ansluta din Stripe",
      "companyStripeIntegrationPage": "företagets Stripe-integrationssida",
      "enterClientCardInfo": "För att aktivera återfakturering måste du ange din klients kortinformation på",
      "gpt4oMini": "GPT-4o-mini",
      "for750kWords": "(för 750 000 ord)",
      "words": "ord",
      "yourCostLower": "Er kostnad",
      "and": "och",
      "or": "eller",
      "minimumMustBeBetween": "Minimum måste vara mellan",
      "upgradeToAgencyPro": "uppgradera till Agency Pro",
      "planToSetMargins": "abonnemanget för att ställa in marginaler"
    },
    "m": "m",
    "label": "Etikett",
    "company_email_": "Företagets e-post (",
    "me_": "Mig (",
    "automation_type": "Automationstyp",
    "calendar_groups": "Kalendergrupper",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "Inga produkter är tillgängliga",
    "selectProduct": "Välj en produkt"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". Ytterligare {product}-meddelanden debiteras inte platserna. För att återfakturera kunden aktiverar du SaaS-läget och återfakturering.",
      "agreementPrefix": "Jag godkänner aktivering",
      "agreementSuffix": "för den här klienten utan återförsäljning och jag bekräftar att jag kommer att debiteras",
      "buildResellerOffer": "Bygg ditt återförsäljningserbjudande",
      "deployDirectlyDescription": "Använd det här alternativet om du erbjuder {product} som en del av ditt erbjudande eller om du vill fakturera din kund externt",
      "deployPrefix": "Distribuera",
      "directlySuffix": "Direkt",
      "learnMore": "Läs mer.",
      "offerPrefix": "Erbjudande",
      "resellPrefix": "Återförsälja",
      "resellingPrefix": "Återförsäljning",
      "subscriptionRestriction": "Det går inte att ändra konfigurationen eftersom platsen redan prenumererar",
      "zero": "0",
      "highlevelPrice": "HighLevel-pris",
      "howDoesItWork": "Hur fungerar det?",
      "payNowButton": "Betala nu",
      "priceValidationError": "Priset måste vara lika med eller högre än HighLevel-priset",
      "saving": "Sparar",
      "yourPrice": "Ditt pris",
      "yourProfit": "Din vinst"
    },
    "whatsapp": {
      "inboundMessagesInfo": "Det är gratis att ta emot inkommande meddelanden och svara på dem med ett gratis SMS i konversationsfönstret. Det tillkommer ytterligare avgifter för utgående mallmeddelanden om sådana skickas.",
      "whatsappLocation": "WhatsApp-plats"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "Det går inte att ändra konfigurationen eftersom platsen redan prenumererar",
        "offerPrefix": "Erbjudande ",
        "poweredByPrefix": " (Drivs av Search Atlas)",
        "toggleTooltipDisable": "Denna åtgärd kommer att inaktivera SEO-verktyg för alla underkonton.",
        "toggleTooltipEnable": "Denna åtgärd kommer att aktivera SEO-verktyg för alla underkonton.",
        "resellPrefix": "Återförsälj ",
        "howDoesItWork": "Hur fungerar det?",
        "buildResellerOffer": "Bygg ditt återförsäljningserbjudande",
        "yourPrice": "Ditt pris",
        "highlevelPrice": "HighLevel-pris",
        "yourProfit": "Din vinst",
        "priceValidationError": "Priset måste vara lika med eller högre än HighLevel-priset",
        "saving": "Sparar",
        "save": "Spara",
        "deployPrefix": "Distribuera ",
        "directlySuffix": "Direkt",
        "deployDirectlyDescription": "Använd det här alternativet om du erbjuder SEO som en del av ditt erbjudande eller om du vill fakturera din klient externt",
        "agreementPrefix": "Jag godkänner aktivering ",
        "agreementSuffix": " för denna klient utan återförsäljning och jag bekräftar att jag kommer att debiteras",
        "payNowButton": "Betala nu",
        "subscriptionCreating": "Ett abonnemang håller på att skapas.<br/>Uppdatera inte sidan och tryck inte på bakåtknappen",
        "subscriptionCreated": "Abonnemanget har skapats. Vänta ett ögonblick ...",
        "subscriptionError": "Det gick inte att skapa abonnemanget. Kontakta supporten."
      },
      "adManager": {
        "subscriptionRestriction": "Det går inte att ändra konfigurationen eftersom platsen redan prenumererar",
        "offerPrefix": "Erbjudande ",
        "resellingPrefix": "Återförsäljning",
        "resellPrefix": "Återförsälj ",
        "howDoesItWork": "Hur fungerar det?",
        "bookACall": "Boka ett samtal",
        "bookCallTooltip": "Boka ett samtal med vårt team för att lära Er mer om Ad Manager",
        "buildResellerOffer": "Bygg ditt återförsäljningserbjudande",
        "yourPrice": "Ditt pris",
        "highlevelPrice": "HighLevel-pris",
        "yourProfit": "Din vinst",
        "priceValidationError": "Priset måste vara lika med eller högre än HighLevel-priset",
        "loading": "Läser in ...",
        "save": "Spara",
        "deployPrefix": "Distribuera ",
        "directlySuffix": "Direkt",
        "deployDirectlyDescription": "Använd det här alternativet om du erbjuder Annonshanterare som en del av ditt erbjudande eller om du vill fakturera din klient externt",
        "agreementPrefix": "Jag godkänner aktivering ",
        "agreementMiddle": " för den här klienten utan återförsäljning och jag bekräftar att jag kommer att debiteras",
        "agreementSuffix": " per månad",
        "stripeNotConnectedLocationWarning": "Stripe är inte anslutet för den här platsen. Anslut Stripe för att aktivera den här funktionen.",
        "stripeNotConnectedAgencyWarning": "Stripe är inte anslutet till denna byrå. Anslut Stripe för att aktivera den här funktionen.",
        "underSubAccountReselling": "per månad vid återförsäljning för underkonto"
      },
      "dedicatedIp": {
        "description": "Detta gör att du kan återfakturera dedikerad IP (som används för utgående e-post) till dina kunder och inkludera ett påslag",
        "numberOfIps": "Antal IP-adresser:",
        "yourCost": "Er kostnad:",
        "chargedToCustomer": "Debiteras till kunden:",
        "profit": "Vinst:",
        "monthlyProfit": "Månadsvinst:",
        "loading": "Läser in ...",
        "save": "Spara",
        "revokeDedication": "Återkalla dedikation",
        "revokeDescription": "Använd det här alternativet för att sluta erbjuda ny dedikerad IP till din kund utan att debitera dem",
        "existingSubscriptionsNote": "Nuvarande IP-abonnemang kommer inte att påverkas",
        "revoke": "Återkalla",
        "provideDirectlyTitle": "Tillhandahåll dedikerad IP direkt för mejl",
        "provideDirectlyDescription": "Använd det här alternativet för att ge en dedikerad IP till din kund utan att debitera dem",
        "agreeToProvideText": "Jag åtar mig att tillhandahålla IP för denna kund utan merförsäljning",
        "acknowledgeChargeText": "Jag bekräftar att jag kommer att debiteras 59 USD/månad/IP",
        "agree": "Godkänn",
        "yourMonthlyCost": "Din IP-kostnad varje månad:",
        "monthlyChargeToCustomer": "Månadsavgift till kunden:",
        "resellingSettingsSuffix": " Återförsäljningsinställningar",
        "ipRebillingAmount": "IP-återfaktureringsbelopp"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "Jag bekräftar att jag har diskuterat detta med min kund och fått deras godkännande",
        "confirmQuestion": "Är du säker på att du vill inaktivera SaaS-läget för det här kontot?",
        "dataLossAck": "Jag bekräftar att all omfaktureringsdata, SaaS-abonnemangsdata och transaktionsboken kommer att gå förlorade.",
        "disableSaas": "Inaktivera SaaS",
        "irreversibleAck": "Jag förstår att den här åtgärden inte kan ångras"
      },
      "confirmationModal": {
        "cancelSubscription": "Annullera även det tillhörande SaaS-abonnemanget",
        "confirmDisable": "Bekräfta inaktivering",
        "confirmQuestion": "Är du säker på att du vill inaktivera SaaS-läget?",
        "somethingWentWrong": "Någonting gick fel... Vänligen försök igen efter en stund"
      },
      "processingModal": {
        "closeNow": "Stäng nu",
        "closeWindowInstructions": "Du kan stänga det här fönstret. Vi kommer att informera dig via e-post när processen är klar",
        "title": "SaaS kommer snart att inaktiveras för den här platsen.",
        "typicalTime": "Detta tar vanligtvis 10 minuter eller mindre."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Lägg till anpassat fält",
      "fieldKey": "Fältnyckel",
      "fieldName": "Fältnamn",
      "idWillBeAdded": "ID kommer att läggas till efter att orsak till förlust har skapats",
      "lostReasonID": "ID på orsak till att den förlorades",
      "placeholder": "Platshållare"
    },
    "locationMailGun": {
      "bccAddress": "BCC-adress",
      "clearError": "Rensa felet",
      "deleteConfirmationMessage": "Den här åtgärden tar bort Mailgun-anslutningen.",
      "deleteConnection": "Radera anslutning",
      "domain": "Domän",
      "domainsAvailable": "{count} tillgängliga",
      "invalidApiKey": "Ogiltig API-nyckel",
      "selectDomain": "Välj domän"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Fel vid hämtning av transaktionsdetaljer",
      "transactions": "Transaktioner"
    },
    "noShowSMS": {
      "smsWithImage": "Uteblev-SMS med bild",
      "title": "Anpassa recensions-SMS"
    },
    "optOut": {
      "addKeywords": "Inkludera ett av följande nyckelord för avanmälan: STOPPA, STOPPALL, AVPRENUMERERA, ANNULLERA, SLUTA eller AVSLUTA",
      "customizeTitle": "Anpassa meddelandet för avanmälan",
      "disableConfirm": "Är du säker på att du vill inaktivera meddelande för avanmälan?",
      "disableOptOut": "Inaktivera avanmälan",
      "disableTitle": "Inaktivera meddelande för avanmälan?",
      "optInConfirmClient": "Jag bekräftar att jag kommer att se till att sms endast skickas till de kontakter som har valt att ta emot dem.",
      "quickTipMessage": "Det första meddelandet du skickar till en person måste innehålla ett av följande standardnyckelord för avanmälan: STOP, STOPALL, UNSUBSCRIBE, CANCEL, END eller QUIT.",
      "reallyDisableConfirm": "Är du helt säker på att du vill inaktivera meddelande för avanmälan?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "Begäran POST-text",
        "requestQueryParameters": "Begär frågeparametrar",
        "responseBody": "Svarstext"
      },
      "logs": "Loggar",
      "logsPage": {
        "clearAll": "Rensa alla",
        "loadMore": "Läs in mer",
        "price": "Pris",
        "product": "Produkt",
        "tabsAriaLabel": "Flikar för betalningsloggar"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Lägg till allmän text vid",
      "beginning": "Början",
      "complianceConfirm": "Jag bekräftar att jag kommer att säkerställa att alla sms-meddelanden som skickas från detta konto följer den aktuella policyn",
      "customizeTitle": "Anpassa allmän text",
      "disableConfirm": "Är du säker på att du vill inaktivera avsändar-ID?",
      "disableSenderID": "Inaktivera SenderID",
      "disableTitle": "Inaktivera avsändar-ID?",
      "end": "Avsluta",
      "pleaseAdd": "Lägg till {text} som nämnts i snabbtipset.",
      "quickTipMessage": "Det första meddelandet som du skickar till en individ måste innehålla avsändarens identifieringsinformation. Lägg till {text} i den allmänna textrutan.",
      "reallyDisableConfirm": "Är du helt säker på att du vill inaktivera avsändar-ID?",
      "senderID": "Avsändar-ID"
    },
    "shopify": {
      "adminApiAccessToken": "Åtkomsttoken för admin API",
      "apiTokenRequired": "API-åtkomsttoken krävs",
      "checkDocumentation": "Mer information finns i denna dokumentation",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "API-åtkomsttoken för anpassad app",
      "deleteWarning": "Om du raderar detta tas den befintliga anslutningen bort.",
      "existStoreAlertTitle": "Shopify-butiksintegrationen finns redan",
      "integration": "Shopify-integration",
      "integrationHealth": "Integrationshälsa",
      "orders": "Beställningar",
      "scopePermissionsWarning": "Kontrollera att din app har behörigheterna som är markerade med ett rött kryss",
      "scopes": "Omfattningar",
      "scopesDescription": "Auktoriseringsomfattningar krävs för att få åtkomst till Shopify-informationen. På grund av de senaste ändringarna i Shopify krävs nu read_customers för att få fullständig information från kunderna, på grund av Shopifys skyddade kunddata.",
      "storeConnectedMessage": "Shopify-butiken är redan ansluten till underkontot {locationName}",
      "storeNameHelp": "Ditt butiksnamn finns i URL:en för ditt Shopify-konto – efter https:// och före .myshopify.",
      "storeNameLabel": "Shopify-butikens namn",
      "storeNamePlaceholder": "butiksnamn",
      "storeNameRequired": "Butiksnamn krävs",
      "typeRemoveConfirm": "Skriv 'REMOVE' för att bekräfta",
      "webhooks": "Webhooks",
      "webhooksDescription": "För att ta emot alla händelser från Shopify måste vi registrera dessa Shopify-webhooks under integrationen. Dessa webhooks är nödvändiga för att Shopify-funktionerna ska fungera korrekt."
    },
    "slack": {
      "accountConnected": "anslutet konto",
      "accountsConnected": "anslutna konton",
      "accountsList": "Lista över alla Slack-konton",
      "added": "Tillagd {date}",
      "connectChannel": "Anslut din Slack-kanal",
      "description": "Få omedelbara aviseringar på din Slack-kanal. Klicka på 'Connect' för att lägga till en Slack-kanal.",
      "manage": "Hantera",
      "manageAccounts": "Hantera Slack-konton",
      "noIntegrations": "Inga Slack-integrationer hittades."
    },
    "smtpService": {
      "addFirstService": "Lägg till din första SMTP-tjänst.",
      "addService": "Lägg till tjänst",
      "bccEmails": "BCC-e-postadresser",
      "cannotDeleteDefaultProvider": "Du kan inte radera standardleverantören.",
      "contactDeveloper": "Kontakta utvecklaren av den här appen.",
      "customProvider": "Anpassad leverantör",
      "defaultProvider": "Standardleverantör",
      "defaultProviderUpdated": "Standardleverantören har uppdaterats!",
      "emailDomain": "E-post/domän",
      "emailService": "EMAIL Service",
      "enableReplyTracking": "Aktivera svarsspårning",
      "forwardToAssignedUser": "Vidarebefordra till tilldelad användare",
      "providerType": "Leverantörstyp",
      "smtpConnectionIssue": "Det finns ett problem med denna SMTP-anslutning. Återanslut den här integrationen.",
      "useLcEmailMessage": "Använd LC Email för att skicka e-post för din byrå och dina kunder."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Automatisk publicering aktiverad",
      "dailyPostLimit": "Daglig inläggsgräns",
      "directoriesDescription": "När du får en ny recension publicerar vi den automatiskt i över 80 onlinekataloger som automatiskt hjälper dig att stärka ditt varumärke och din SEO.",
      "directoriesTitle": "80+ Kataloger och Webbplatser",
      "fivePosts": "5 inlägg",
      "fiveStars": "5 stjärnor",
      "fourPosts": "4 inlägg",
      "fourStars": "4 stjärnor",
      "googlePlus": "Google +",
      "manageSettingsDescription": "Anpassa hur och när dina recensioner automatiskt publiceras på alla sociala nätverk.",
      "manageSettingsTitle": "Hantera dina inställningar för sociala medieinlägg",
      "postReviewsForRating": "Publicera recensioner för detta betyg eller högre.",
      "searchEngines": "Sökmotorer",
      "threePosts": "3 inlägg",
      "threeStars": "3 stjärnor",
      "title": "Sociala medieinlägg"
    },
    "tags": {
      "addNewTag": "Lägg till ny tagg",
      "allTags": "Alla taggar",
      "deletedTags": "Borttagna taggar",
      "here": "härifrån.",
      "newTag": "Ny tagg",
      "noTagsYet": "Inga taggar att visa ännu",
      "searchTags": "Sök efter taggar",
      "viewDeletedTags": "Du kan visa och återställa borttagna taggar på sidan Granskningsloggar."
    },
    "templateMessage": {
      "addEmailTemplate": "Lägg till e-postmall (utdrag)",
      "addTemplate": "Lägg till mall (utdrag)",
      "addTextTemplate": "Lägg till textmall (utdrag)",
      "body": "Brödtext",
      "deleteTemplateConfirmation": "Är du säker på att du vill radera den här mallen?",
      "templatesCount": "{count} mallar",
      "title": "Meddelandemallar (utdrag)"
    },
    "unsubscribe": {
      "content": "Innehåll",
      "contentTooltip": "Innehållet i detta meddelande kommer automatiskt att läggas till i alla e-postmeddelanden.",
      "customizeTitle": "Anpassa innehåll för avprenumeration",
      "disableConfirm": "Är du säker på att du vill inaktivera avprenumerationslänken från e-post?",
      "disableTitle": "Inaktivera avprenumerationslänk?",
      "disableUnsubscribe": "Inaktivera avprenumeration",
      "pleaseAddTag": "Lägg till taggen /*unsubscribe*/",
      "reallyDisableConfirm": "Är du helt säker på att du vill inaktivera länken för avregistrering från e-post?",
      "subscribedConfirm": "Jag bekräftar att e-post endast kommer att skickas till kontakter som har prenumererat på att ta emot e-postmeddelanden.",
      "subscribedConfirmClient": "Jag bekräftar att jag kommer att säkerställa att e-post endast skickas till kontakter som har prenumererat på att ta emot e-postmeddelanden.",
      "suspensionWarning": "Aktiviteter som inte uppfyller kraven kan leda till att ditt kontos e-postfunktioner stängs av.",
      "tagRequirement": "Det första e-postmeddelandet som du skickar till en individ måste innehålla taggen /*unsubscribe*/"
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "Detta är standardröstmeddelandet för alla Twilio-nummer på platsen, om det inte anpassas under",
      "forwardCallsToWebApp": "Vidarebefordra samtal till webbapplikation",
      "forwardCallsToMobileApp": "Vidarekoppla samtal till mobilappen",
      "dedicatedNumberRequiredInfo": "Detta krävs endast om användarna behöver ett dedikerat nummer. Det krävs inte för röstbrevlåda eller för vidarekoppling av samtalet till den tilldelade användaren.",
      "voicemailMessageInfo": "Detta röstmeddelande kommer att spelas upp istället för telefonoperatörens. Vi rekommenderar en timeout på 20 sekunder eller mindre.",
      "noTimeout": "Ingen timeout",
      "10Secs": "10 sekunder",
      "20Secs": "20 sek",
      "voicemailMessageDuration": " Vi kommer att spela in ett röstmeddelande om samtalet inte besvaras inom denna tidsperiod.",
      "saveCallSettings": "Spara samtalsinställningar"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "När denna tagg finns på kontakten kommer dessa meddelanden INTE att levereras till Eliza",
      "sendToElizaNote": "Som standard kommer alla konversationer att levereras till Eliza. Om denna tagg är konfigurerad <br />kommer de nya konversationerna att skickas till Eliza, endast när denna tagg finns på en kontakt.<br /> Om både Eliza-bypasstaggen och Send to Eliza-taggen är konfigurerade, kommer endast Send to Eliza att respekteras",
      "permissionNote": "Era användarbehörigheter är inte aktiverade för den här sidan. <br />Vänligen tala med er administratör",
      "addFAQ": "Lägg till FAQ"
    },
    "locationSettings": {
      "ownCardWarning": "Lägg inte till ert eget kort på underkonton!!",
      "addClientCardWarning": "Lägg till din klients (underkontots) kort och inte ditt eget, eftersom detta kort kommer att användas för att fakturera din klient på dina vägnar.",
      "stripeConnectMissing": "Stripe-anslutning saknas",
      "pleaseContactAgencyToAddPaymentMethods": "Kontakta byrån ({email}) för att lägga till betalningsmetoder"
    },
    "integrations": {
      "connectWaveAccount": "Anslut Wave-konto för din plats",
      "connectXeroAccount": "Anslut Xero-kontot för din plats"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "GBP-samtalsspårning är aktiverad på ett annat underkonto. Samtalsspårning kan endast aktiveras på ett underkonto i taget.",
      "gbpCallTrackingEnabledOnAnotherPage": "GBP-samtalsspårning är aktiverad på en annan sida ({pageName}). Samtalsspårning kan aktiveras på ett enda underkonto och en enda sida per plats åt gången.",
      "gbpCallsProperlySetup": "GBP-samtal är korrekt inställda och samtal kommer in från",
      "tooManyEditsToPrimaryPhone": "Du har gjort för många redigeringar av den primära telefonen för det här företaget. Försök igen senare.",
      "setupTwilioToStartCallTracking": "Konfigurera Twilio för att börja spåra samtal",
      "twoSecondaryNumbersSetupAlready": "Du har redan 2 sekundära nummer inställda, du kan inte byta nummer",
      "yourAgentIDIs": "Din agentID är"
    },
    "numberPool": {
      "title": "Vad du ska spåra",
      "tracking": {
        "percentComplete": "34% slutförd",
        "searchLower": "sök"
      },
      "create": {
        "title": "Skapa spårningsnummer"
      }
    },
    "phoneNumbers": {
      "title": "Vad du ska spåra",
      "tracking": {
        "percentComplete": "34% slutförd",
        "heading": "Skapa spårningsnummer"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Ange ett värde",
      "selectOption": "* Välj ett alternativ"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* Minst ett {filterName} krävs",
      "select": "Välj {filterName}"
    },
    "newEmailStats": {
      "timeStamp": "Tidsstämpel"
    },
    "recordsNav": {
      "clickToReloadList": "Klicka för att uppdatera listan"
    },
    "reviewRequestActions": {
      "emailReviewReq": "Recensionsförfrågan via e-post",
      "smsReviewReq": "Recensionsförfrågan via SMS",
      "whatsappReviewReq": "Recensionsförfrågan via WhatsApp"
    },
    "smartListFilters": {
      "clearAllFilters": "Rensa alla filter",
      "noneFound": "inga träffar",
      "saveChangesToList": "Spara ändringar av filtret i den här smarta listan",
      "saveCombinationAsNew": "Spara kombinationen av filter, kolumner och sortering som en ny smart lista",
      "saveCurrentAsNew": "Spara aktuella filter som ny smart lista",
      "searchAndAddFilter": "Sök och lägg till ett filter",
      "searching": "söker …",
      "undoUnsavedChanges": "Ångra osparade ändringar"
    },
    "smsStatsPanel": {
      "smsStats": "SMS-statistik"
    },
    "manageDuplicates": "Hantera dubbletter",
    "emailAction": {
      "attachFiles": "Bifoga filer",
      "customValues": "Anpassade värden",
      "triggerLinks": "Utlösarlänkar"
    },
    "atLeastOneRequired": "* Minst ett {filterName} krävs",
    "arrayInput": {
      "searchPlaceholder": "Sök efter {filterName}",
      "searching": "Söker…"
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Fel vid hämtning av lägesbildinnehåll",
      "overwriteAll": "Skriv över alla",
      "skipAll": "Hoppa över alla",
      "somethingWentWrongWhileFindingConflicts": "Något gick fel när konflikter skulle hittas",
      "step": "Steg"
    },
    "confirmOverwrite": {
      "confirmButton": "Bekräfta överskrivning",
      "description": "Den här åtgärden kan inte ångras och kan ändra konfigurationen av kampanjer, potentiella kunder, trattar etc. Bekräfta åtgärden genom att skriva följande i inmatningsfältet.",
      "title": "Är du säker på att du vill skriva över markerade data?"
    },
    "conflicts": {
      "noConflictsDetected": "Inga konflikter har upptäckts",
      "overwrite": "Skriv över"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Länkade tillgångar hittades",
      "checkingConflicts": "Kontrollerar om det finns konflikter",
      "chooseSnapshot": "Välj en lägesbild",
      "copyingDataNotification": "Kopierar data till valda platser. Vänta ett ögonblick ...",
      "linkedLocations": "Länkade platser",
      "noConflictsFound": "Inga konflikter hittades",
      "notAuthorizedMessage": "Endast byråadministratörer kan utföra den här åtgärden",
      "overwriteConflicts": "Skriv över konflikter",
      "pickSnapshot": "Välj en lägesbild",
      "response": "Svar",
      "selectAssetsToPush": "Välj tillgångar att skicka",
      "selectLocationsToUpdate": "Välj platserna att uppdatera",
      "snapshotNotAuthorized": "Denna lägesbild är inte godkänd för denna plats",
      "snapshotNotSelected": "Lägesbild ej markerad"
    },
    "share": {
      "agencyRestrictedLink": "Byråbegränsad länk",
      "deleteShareLink": "Radera delningslänk",
      "editShareLink": "Redigera delningslänk",
      "permanentLink": "Permanent länk",
      "subaccountRestrictedLink": "Begränsad länk för underkonto"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(Lägg till ett kommatecken (<span class='text-base font-bold'> , </span>) efter varje relationsnummer)",
      "addCommaAfterEachSubAccount": "(Lägg till ett kommatecken (<span class='text-base font-bold'> , </span>) efter varje underkonto-ID)",
      "atLeast1EmailRequired": "Alteast 1 e-postadress krävs.",
      "emailShareLink": "Mejla delningslänk",
      "enterOnePerLine": "(Ange en per rad)",
      "errorGettingLink": "Något gick fel när länken hämtades, försök igen senare!",
      "getAgencyRestrictedLink": "Hämta begränsad länk för byrå",
      "getLink": "Få länk",
      "getOneTimeLink": "Få en engångslänk för delning",
      "getPermanentLink": "Få permanent länk",
      "getSubAccountRestrictedLink": "Hämta begränsad länk för underkonto",
      "shareType": "Delningstyp",
      "title": "Dela lägesbild"
    },
    "snapshot": {
      "copySnapshotID": "Kopiera lägesbilds-ID",
      "deleteSnapshot": "Radera lägesbild",
      "editSnapshot": "Redigera lägesbild",
      "pushUpdate": "Skicka uppdatering till länkade konton",
      "refreshSnapshot": "Uppdatera lägesbild"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(Lägg till ett kommatecken efter varje relationsnummer)",
      "addCommaAfterEachSubAccount": "(Lägg till ett kommatecken efter varje underkonto-ID)",
      "title": "Uppdatera delningslänk"
    }
  },
  "socialMedia": {
    "engagement": "Engagemang",
    "potentialReach": "Potentiell räckvidd",
    "storiesCreated": "Skapade berättelser",
    "recentPosts": "Senaste inlägg",
    "notConnected": "Inte ansluten (Anslut nu!)",
    "totalAudience": "Total målgrupp",
    "activeAudience": "Aktiv målgrupp",
    "socialMediaOverview": "Översikt över sociala medier"
  },
  "suspendModal": {
    "currentStatus": "Nuvarande abonnemangsstatus: pausad",
    "instructions": "Du måste slutföra några enkla steg för att {action} detta underkonto",
    "nextBillingDate": "Nästa faktureringsdatum:",
    "noKeepCharging": "Nej, fortsätt att debitera kunden.",
    "pauseSubscriptionQuestion": "Vill du pausa abonnemanget också med underkontot?",
    "resumeSubAccount": "Återuppta underkontot",
    "resuming": "Återupptar …",
    "saasSubscriptionActive": "Detta underkonto har ett aktivt SaaS-abonnemang.",
    "saasSubscriptionResumed": "SaaS-abonnemanget för detta konto kommer att återupptas.",
    "yesPause": "Ja, pausa abonnemanget"
  },
  "table": {
    "perPageOptions": {
      "5": "5 per sida",
      "10": "10 per sida",
      "15": "15 per sida",
      "20": "20 per sida",
      "25": "25 per sida",
      "50": "50 per sida",
      "100": "100 per sida"
    },
    "filterPlaceholder": "Sök ...",
    "emptyText": "Inga poster hittades",
    "loading": "Läser in ...",
    "showingEntries": "Visar {from} till {to} av {total} poster",
    "noEntriesToShow": "Inga poster att visa"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "Läser in kontodata …",
      "toContinueWith": "för att fortsätta med"
    },
    "switcherModal": {
      "comingSoon": "Kommer snart!",
      "multiLocationMessage": "Den här funktionen är för närvarande endast tillgänglig för enskilda konton. Vi arbetar hårt för att snart kunna erbjuda detta till konton med flera platser."
    },
    "importedMessage": "{productName} har importerats! Navigera till Mallbiblioteket och hitta det under fliken {productName}.",
    "permissionErrorMsg": "Detta alternativ är endast tillgängligt på högre abonnemangsplaner. Uppgradera nu för att låsa upp den.",
    "errors": {
      "sourceDeleted": "Fel: källmallen har raderats. Den är inte längre tillgänglig. Kontrollera mallens status eller kontakta källan för att få hjälp.",
      "sourceDraft": "Fel: källmallen har flyttats till utkast. Kontrollera mallens status eller kontakta källan för att få hjälp.",
      "linkedDeleted": "Fel: Källmallen, som är kopplad till den delade mallen, har tagits bort. Kontrollera mallens status eller kontakta källan för att få hjälp.",
      "fetchError": "Det verkar bli fel när detaljer för {productName} hämtades. Kontrollera URL:en eller försök igen!",
      "sameAgency": "Kan inte dela mall inom samma byrå"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "Åtgärden ”Lägg till kontakt-tagg” kräver att det finns en tagg.",
    "addNotesRequiresData": "För att lägga till anteckningar krävs anteckningsdata.",
    "addTaskRequiresFields": "För att lägga till en uppgift krävs titel och förfallodag.",
    "addToCampaignRequiresCampaign": "Åtgärden ”Lägg till i kampanj” kräver att det finns en kampanj.",
    "addToCustomAudienceRequires": "Åtgärden ”Lägg till i anpassad målgrupp” kräver ett annonskonto och en anpassad målgrupp.",
    "addTrigger": "Lägg till utlösare",
    "anyAction": "Någon åtgärd",
    "anyCondition": "Något villkor",
    "brokenCustomVariables": "Vissa fält innehåller felaktiga anpassade variabler. Korrigera dem innan du sparar.",
    "conditionCannotBeEmpty": "Villkoret ”{condition}” får inte vara tomt",
    "confirmDeleteTrigger": "Är du säker på att du vill radera den här utlösaren?",
    "customDateFieldRequired": "Filter för anpassat datumfält krävs för utlösare av datumbaserad påminnelse",
    "detailPage": {
      "chooseTriggerPlaceholder": "Välj en utlösare",
      "lastUpdate": "Senaste uppdatering:",
      "loopIdentifiedWarning": "Den här utlösaren har låsts som ett utkast eftersom den orsakar en loop. Om du vill aktivera utlösaren kontaktar du supporten.",
      "ruleNotActiveWarning": "Den här regeln körs inte förrän du aktiverar den.",
      "triggerCreation": "Skapa utlösare:",
      "triggerDeletedPrompt": "Utlösaren har raderats! Vill du återställa den?",
      "triggerRunDailyTooltip": "Utlösare körs dagligen kl. 08:00",
      "whatTriggersRule": "Vad ska utlösa den här regeln?",
      "whichEventTriggersAutomation": "Vilken händelse ska utlösa den här automatiseringen?"
    },
    "dndContactRequiresState": "DND-kontaktåtgärden kräver att DND-status är inställd.",
    "emptyConditionNotAllowed": "Tomma villkor är inte tillåtet.",
    "emptyFieldNotAllowed": "Tomma fält är inte tillåtna.",
    "executeWebhookRequiresUrl": "För att utföra en webhook-åtgärd krävs en webhook-URL.",
    "fieldCannotBeEmpty": "{field} får inte vara tomt",
    "fillRequiredFields": "Fyll i alla obligatoriska fält i åtgärderna.",
    "googleAdwordsRequiresConversion": "Åtgärden ”Lägg till i Google Adwords” kräver konvertering.",
    "googleAnalyticsRequiresFields": "Åtgärden ”Lägg till i Google Adwords” kräver spårnings-ID, åtgärdstyp och åtgärdskategori",
    "membershipGrantOfferRequiresOffer": "För att bevilja ett medlemserbjudande krävs att det finns ett erbjudande.",
    "membershipRemoveOfferRequiresOffer": "För att ta bort ett medlemserbjudande krävs att det finns ett erbjudande.",
    "newBasicRule": "Ny Enkel regel",
    "opportunitiesRequirePipeline": "Om du vill kunna utföra åtgärder för möjligheter måste du välja en pipeline.",
    "opportunityLoopWarning": "Den här utlösaren kommer att resultera i att möjligheter skapas i loop. Ta bort alternativet Tillåt dubbletter eller ändra steget som du refererar till.",
    "removeContactTagRequiresTag": "Åtgärden ”Ta bort kontakt-tagg” kräver att det finns en tagg.",
    "removeFromCampaignRequiresCampaign": "Åtgärden ”Ta bort från kampanj” kräver att det finns en kampanj.",
    "removeFromCustomAudienceRequires": "Åtgärden ”Ta bort från anpassad målgrupp” kräver ett annonskonto och en anpassad målgrupp.",
    "rulesBasedOn": "regler baserade på",
    "selectUserForNotification": "Välj användare för att skicka avisering.",
    "sendEmailRequiresFields": "För att skicka e-post krävs avsändare, mottagare, ämne och meddelande.",
    "sendNotificationRequiresFields": "För att skicka en avisering krävs titel, brödtext och användartyp.",
    "sendSmsRequiresFields": "För att skicka ett sms krävs ett nummer och ett meddelande.",
    "stripeMinAmountUSD": "Beloppet måste vara minst 50 cent.",
    "stripeRequiresFields": "Stripe-engångsavgift kräver kund-ID, belopp och valuta",
    "thatWillFire": "som kommer att utlösas",
    "triggerCannotBeEmpty": "Utlösaren får inte vara tom",
    "updateContactFieldRequires": "Fältet Uppdatera kontakt bör ha minst ett fält."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "Betala ${amount} och prenumerera",
      "commitment": "Inga förpliktelser, avbryt när som helst",
      "features": {
        "billedOnUsage": "Faktureras baserat på användning efter att gränsen har överskridits",
        "externalAI": "Utesluter externa AI-modellåtgärder, som faktureras separat",
        "leadingPricing": "Branschledande prissättning!",
        "monthlyPurchase": "Giltig för ett köp per månad",
        "premiumActions": "Gäller premiumåtgärder och -utlösare"
      },
      "planDetails": "Detaljer om abonnemanget",
      "subscribeAndSave": "Abonnera och spara pengar idag!",
      "title": "${amount} för {executions} åtgärder per månad"
    }
  },
  "appointmentWidget": {
    "movedMessage": "Den här inställningen har flyttats till kalendersidan.",
    "toNavigate": "här för att navigera. Den här sidan kommer snart att tas bort."
  },
  "attribution": {
    "description": "Den första interaktionen är helt enkelt den första beröringspunkten en användare har. Så om någon först upptäckte dig via en betald sökannons (PPC), skulle den kanalen få äran när det gäller en konvertering. Å andra sidan skulle den senaste interaktionen vara den senaste kanalen.",
    "firstInteraction": "Första interaktionen",
    "lastInteraction": "Senaste interaktion",
    "title": "Attribution"
  },
  "campaign": {
    "addEvent": "Lägg till händelse",
    "a2p": {
      "address": {
        "chooseState": "Välj delstat …",
        "city": "Stad*",
        "postalCode": "Postnummer*",
        "streetAddress": "Gatuadress*",
        "streetAddressHelper": "Adressen måste vara giltig och kopplad till ditt företag.",
        "title": "Företagsadress"
      },
      "addressError": {
        "title": "Inlämning av adress misslyckades"
      },
      "authorizedRep": {
        "jobPosition": "Befattning*",
        "jobTitle": "Jobbtitel*",
        "title": "Information om auktoriserad representant"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Varumärke för enskild firma",
          "point1": "Endast ett telefonnummer är tillåtet",
          "point2": "EIN/SSN/DUNS krävs inte"
        },
        "solePropCampaign": {
          "heading": "Sole Prop-kampanj",
          "point1": "Endast 1 nummer får kopplas till en kampanj för en enskild firma",
          "point2": "När det har godkänts kommer ert standardnummer att kopplas automatiskt",
          "infoText": "Du kan också uppdatera antalet efter godkännande",
          "warningText": "Endast 1 nummer får kopplas till en kampanj för en enskild firma. När ditt standardnummer har godkänts kopplas det automatiskt. Du kan också uppdatera numret efter godkännandet."
        },
        "solePropSubtitle": "Varumärkes- och kampanjdetaljer för enskild firma",
        "standardBrand": {
          "heading": "4,41 $ – en gång",
          "point1": "EIN/SSN/DUNS krävs",
          "point2": "Mer än ett telefonnummer är tillåtet"
        },
        "standardCampaign": {
          "heading": "16,54 $ – en gång",
          "point1": "Mer än ett nummer får länkas till en standardkampanj",
          "point2": "EIN/SSN/DUNS krävs",
          "infoText": "En extra kampanjavgift på upp till 12 $ per månad tillkommer i enlighet med TCR-reglerna."
        },
        "standardSubtitle": "Standard varumärkes- och kampanjdetaljer",
        "title": "Varumärkes- och kampanjdetaljer"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Kontaktuppgifter",
          "contactInfoSubtitle": "Det kan vara vem som helst som kan svara på frågor om varumärket, om det behövs. Observera att du inte kan återanvända kontaktuppgifter mellan olika varumärken. Varje varumärke du skapar måste ha unika kontaktuppgifter.",
          "emailHelper": "Använd inte samma e-postadress för fler än fem varumärken.",
          "phoneNumberHelper": "Använd inte samma telefonnummer för fler än fem varumärken.",
          "profileName": "Företagsnamn eller ditt för- och efternamn*",
          "profileNameHelper": "Använd antingen det juridiska namnet på organisationen som skickar meddelandena eller ditt eget namn om varumärket inte tillhör en organisation.",
          "nextLoading": "Nästa...",
          "invalidPhoneNumber": "Ogiltigt telefonnummer",
          "phoneNumberWithCountryCode": "Telefonnummer (med landskod)*",
          "phoneNumberRequired": "Telefonnummer krävs.",
          "emailRequired": "E-post krävs.",
          "profileNameRequired": "Profilnamn krävs."
        },
        "standard": {
          "businessType": "Företagstyp*",
          "legalBusinessName": "Juridiskt företagsnamn*",
          "legalBusinessNameHelper": "Ange det exakta företagsnamnet så som det är registrerat hos myndigheterna och som anges i dina skattedokument (CP 575). Exempel: Leadconnector LLC istället för Leadconnector.",
          "regionsOfOperations": "Företagets verksamhetsregioner*",
          "registrationNumber": "Organisationsnummer*",
          "registrationNumberHelper": "Numret som används för att identifiera ditt företag. Om det är ett amerikanskt EIN-nummer måste det vara ett niosiffrigt nummer, t.ex. 12-3456789.",
          "registrationType": "Typ av företagsregistrerings-ID*",
          "website": "Företagets webbplats*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Steg {currentStep} av {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "Din företagsprofil har skickats in.",
        "startA2P": "Starta A2P-registrering",
        "title": "Företagsprofilen har skickats in framgångsrikt",
        "tooltips": {
          "agency": "Byråanvändare kan påbörja A2P-registrering",
          "location": "Platsanvändare kan börja registrera sig för A2P"
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Stäng exemplet",
          "optInKeywords": "Opt-in-nyckelord*",
          "optInKeywordsHelper": "Maximal längd: 255 tecken.",
          "optInKeywordsPlaceholder": "Nyckelord separerade med kommatecken, till exempel: ABONNERA, STARTA.",
          "optInMessage": "Meddelande för anmälan*",
          "optInMessageInfo": "Måste innehålla företagsnamn och nyckelord för avanmälan",
          "optInMessagePlaceholder": "Exempel: Du har framgångsrikt anmält dig för att ta emot aviseringar och marknadsförings-SMS från [företagsnamn]. Svara STOPP om du vill avanmäla dig i framtiden.",
          "placeholder": "Exempel: Slutanvändare anmäler sig genom att besöka https://www.mycompany.com/book och fylla i sina uppgifter. Användarna samtycker genom att markera en ruta för att ta emot aviseringar och reklammeddelanden från oss. Slutanvändare kan också sms:a START till +1 (213) 725-2867.",
          "question": "Hur samtycker slutanvändare till att ta emot meddelanden?*",
          "seeExample": "Se exempel"
        },
        "messageDetails": {
          "embeddedLink": "Meddelandet kommer att innehålla en inbäddad länk",
          "phoneNumbers": "Meddelandena kommer att inkludera telefonnummer",
          "sampleMessage1Placeholder": "Exempel: Hej John! Det här är Jane från [företagsnamn]. Vårt möte den 20 juli klockan 11:00 är bekräftat. Kontakta +1(213) 725-2867 om du behöver boka om. Svara STOP för att avprenumerera.",
          "sampleMessage2Placeholder": "Exempel: Hej Brian! Det här är Jane från [företagsnamn]. Jag ser att du inte kunde komma till vårt möte. Skulle du vilja boka om? – https://www.mycompany.com/book. Svara STOPP för att avsluta prenumerationen.",
          "sampleMessageInfo": "Måste inkludera namn på potentiell kund, ditt namn, företagsnamn och språk för avanmälan",
          "subtitle": "Lägg till exempelmeddelanden"
        },
        "useCaseDetails": {
          "explainInDetail": "Förklara i detalj",
          "pickUseCase": "Välj användningsfall för kampanj",
          "solePropLabel": "Enskild firma",
          "subtitle": "Ange kampanjens detaljer och beskrivning",
          "useCase": "Användningsfall för kampanj*",
          "useCaseDescription": "Beskrivning av användningsfall*",
          "useCaseDescriptionPlaceholder": "Exempel: Den här kampanjen skickar mötesinformation – bekräftelse och påminnelser – till våra kunder när de har bokat ett möte med oss på vår webbplats och valt att ta emot aviseringar och säljande SMS från oss."
        }
      },
      "einModal": {
        "disableNoEINText": "Endast företag med giltig adress i USA och Kanada får registrera ett A2P-varumärke utan skatte-ID.",
        "hasEIN": "Ja, företaget jag registrerar har ett skatte-ID (t.ex. EIN, CCN etc.).",
        "infoText": "Du hittar ditt amerikanska EIN på din CP 575-blankett.",
        "noEIN": "Nej, företaget jag registrerar har inget skatte-ID (t.ex. EIN, CCN etc.).",
        "question": "Har företaget du registrerar ett skatte-ID (t.ex. EIN, CCN etc.)?*",
        "title": "Fastställ A2P-varumärkets behov"
      },
      "exampleModal": {
        "examples": "Exempel"
      },
      "otpError": {
        "message": "Det uppstod ett problem när OTP skulle skickas.",
        "title": "Det gick inte att skicka OTP igen"
      },
      "otpSuccess": {
        "title": "Din OTP har skickats."
      },
      "validation": {
        "cityRequired": "Stad krävs.",
        "countryRequired": "Land krävs.",
        "invalidMobileNumber": "Ogiltigt mobilnummer",
        "postalCodeRequired": "Postnummer krävs.",
        "stateRequired": "Delstat krävs.",
        "streetAddressRequired": "Gatuadress krävs."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "affiliate-about-iframe",
      "agencyOwner": "Byråägare",
      "agencyOwnerAndAdmins": "Byråägare och administratörer",
      "contactAgencyOwner": "Om du behöver hjälp kan du kontakta din",
      "firstPromoterAccessMessage": "Denna FirstPromoter-rapport är endast tillgänglig för",
      "firstPromoterIframe": "firstpromoter-iframe",
      "noPartnerFound": "Kunde inte hitta en partner som matchar dina filter. Klicka",
      "paymentDetailsAccessMessage": "Avsnittet med betalningsuppgifter är endast tillgängligt och redigerbart för",
      "toApplyPartner": "för att ansöka om att bli partner."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drive"
      },
      "labels": {
        "doc": "Doc"
      },
      "loading": "Läser in",
      "legalBusinessNameHelper": "Ange det exakta företagsnamnet så som det är registrerat hos myndigheterna och som anges i dina skattedokument (CP 575). Exempel: Leadconnector LLC istället för Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Klicka på <span class='font-semibold'>Öppna HighLevel</span> för att starta skrivbordsappen.<br>Fungerar det inte? Du kan också <a href=\"/\" class='!text-blue-700 hover:underline'>använda HighLevel i webbläsaren</a>",
        "launchingTitle": "Startar HighLevel Desktop",
        "launchButtonText": "Öppna HighLevel"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Klicka på <span class='font-semibold'>Öppna LeadConnector</span> för att starta skrivbordsappen.<br>Fungerar det inte? Du kan också <a href=\"/\" class='!text-blue-700 hover:underline'>använda LeadConnector i webbläsaren</a>",
        "launchingTitle": "Startar LeadConnector Desktop",
        "launchButtonText": "Öppna LeadConnector"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Välj en åtgärd",
        "destination": "Destination",
        "removeFromAllCampaigns": "Den här åtgärden tar bort leads från alla kampanjer utom den aktuella kampanjen",
        "triggerLinks": "Trigger-länkar"
      },
      "importTemplate": {
        "errorImporting": "Fel vid import av mall!",
        "importTemplate": "Importera mall",
        "importing": "Importerar",
        "title": "Importera {entityName} mall",
        "unnamedEntity": "Namnlös {entityName} -kopia"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "under",
          "confirmByTyping": "Bekräfta genom att skriva",
          "confirmWord": "CONFIRM",
          "existingNotMoved": "Om din kund redan har konfigurerat Mailgun eller SMTP flyttas de inte över",
          "notNow": "Inte nu",
          "pricingInfo": "LC Email är billigare än Mailgun och kostar cirka 0,68 $ för 1 000 e-postmeddelanden",
          "setAsDefault": "Ställ in LC Email som standardleverantör för din byrå och kunder som inte redan har Mailgun eller SMTP",
          "thisWill": "Detta kommer att:",
          "title": "Du migrerar till Lead Connector Email",
          "useLcEmail": "Använd LC Email"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Dra eller släpp media här",
        "editPost": "Redigera inlägg",
        "enterText": "Ange text här",
        "exampleComment": "Mycket coolt!! Ser fram emot detta!",
        "exampleName": "Test Tech",
        "hashtag1": "#hashtag",
        "hashtag2": "#awesome",
        "hashtag3": "#cool",
        "imagePlaceholder": "img(02).png",
        "needReview": "Behöver granskas?",
        "network": "Nätverk",
        "photo": "foto",
        "previewPost": "Förhandsgranska inlägg",
        "selectNetwork": "Välj socialt nätverk",
        "sizeExample": "245kb",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "Du har skapat ett nummerpool på {count} nummer för att spåra besökare på din webbplats. <br />Dina samtal kommer att vidarebefordras till",
          "createdSingle": "Du har skapat {count} nummer för att spåra besökare på din webbplats. <br />Dina samtal kommer att vidarebefordras till",
          "percentComplete": "100 % slutfört"
        },
        "create": {
          "correctErrors": "Rätta till dessa fel!",
          "forwardHelp": "Berätta vilken telefon som ska ringa när kunden ringer ditt spårningsnummer. Detta är vanligtvis ditt primära företagstelefonnummer. Exempel: 404-555-1212",
          "heading": "Nummerpool och vidarekoppling",
          "nameHelp": "'{name}' är hur vi kommer att referera till detta spårningsnummer i ditt konto. Välj ett kort och minnesvärt namn.",
          "newTrackingNumbers": "nya spårningsnummer.",
          "nextTracking": "Nästa: Spårningsalternativ",
          "percentComplete": "50 % klart",
          "pleaseConfirm": "Bekräfta:",
          "poolSize": "Poolstorlek",
          "poolSizeError": "Ange en poolstorlek mellan 4 och 30 spårningsnummer.",
          "poolSizeHelp": "Storleken på din nummerpool avgör hur många samtidiga besökare vi kan spåra på din webbplats samtidigt. Din poolstorlek bör vara en fjärdedel av den högsta timtrafiken som rapporteras i Google Analytics, med minst fyra siffror.",
          "swappingHelp": "Berätta för oss vilket telefonnummer vi ska byta ut på webbplatsen. Exempel: 404-555-1212",
          "swappingNumber": "Byt nummer",
          "validationError": "Det uppstod ett fel vid validering av formuläret"
        },
        "features": {
          "activateNumber": "Aktivera nummer",
          "address": "{type} Adress",
          "addressHelp": "Köp av nummer för vissa länder kräver en adress. Kontakta supporten om hur du lägger till en adress om du behöver hjälp.",
          "heading": "Nummerfunktioner",
          "leaveBlank": "Lämna tomt om du inte vill ha något meddelande",
          "recordingDescription": "Aktivera samtalsinspelning och spela upp ett kort meddelande för den som ringer.",
          "recordingHelp": "Vissa jurisdiktioner kräver att båda parter samtycker till alla inspelade samtal. För att underlätta efterlevnaden av dessa lagar kan du aktivera en hälsningsfras för att informera den som ringer om att samtalet kan komma att spelas in.",
          "whisperDescription": "Ett kort meddelande som spelas upp före samtalet. Den som ringer hör inte detta meddelande."
        },
        "tracking": {
          "heading": "Spårningsalternativ",
          "nextCreatePool": "Nästa: Skapa pool",
          "percentComplete": "34% slutförd",
          "searchLower": "sök"
        },
        "whatToTrack": {
          "heading": "Vad vill du spåra på din webbplats?",
          "trackCampaign": "Spåra en marknadsföringskampanj",
          "trackCampaignDescription": "Skapa ett telefonnummer som spårar alla uppringare till en enda marknadsföringskampanj.",
          "trackVisitor": "Spåra besökaraktivitet",
          "trackVisitorDescription": "Skapa flera nummer som korrelerar samtal till webbplatsbesökare, PPC-nyckelord och mer."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "klicka här för att uppdatera.",
      "issuesLoadingApp": "Om du har problem med att läsa in appen",
      "loadingFreshData": "Läser in nya data ...",
      "loadingNewSubAccountData": "Läser in data för nytt underkonto …"
    },
    "login": {
      "bySigningInYouAgree": "Genom att logga in godkänner du våra <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>regler och villkor</a>",
      "newPasswordSent": "Ett nytt lösenord skickas till din e-postadress."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "Av:"
        },
        "affiliates": {
          "partnerBadgeAlt": "Partneremblem"
        },
        "checkout": {
          "cardInformation": "Kortuppgifter",
          "cardNumberInvalid": "Ditt kortnummer är ogiltigt.",
          "commitment": "åtagande",
          "consentOneTime": "Genom att bekräfta tillåter du att LeadConnector debiterar ditt kort för denna betalning.",
          "consentSubscription": "Genom att bekräfta ditt abonnemang tillåter du att LeadConnector debiterar ditt kort för denna betalning och framtida betalningar för detta abonnemang.",
          "defaultIntervalCount": "1",
          "endingIn": "slutar på",
          "errorImageAlt": "Felillustration",
          "intervalSuffix": "(er)",
          "month": "Månad",
          "pay": "Betala",
          "payWithCard": "betala med kort",
          "paymentProcessing": "Betalningen behandlas. Uppdatera inte sidan och tryck inte på bakåtknappen",
          "proceedWithExistingCard": "Fortsätt med befintligt kort",
          "proceedWithNewCard": "Fortsätt med ett nytt kort",
          "prorationDetails": "Du debiteras nu för {days} dagar fram till {billingEnd}, och från och med {billingDate} debiteras du hela beloppet på ${amount}/månad.",
          "prorationMessage": "Startavgifterna beräknas proportionellt och den ordinarie faktureringen börjar den {billingDate}",
          "purchase": "köp",
          "subscribe": "Prenumerera",
          "subscribeTo": "Prenumerera på",
          "updateCardDetails": "Uppdatera kortuppgifterna",
          "zip": "postnummer"
        },
        "options": {
          "jobPosition": {
            "gm": "Vd",
            "vp": "VP"
          }
        },
        "registration": {
          "stepProgress": "Steg {currentStep} av 8",
          "successDescription": "Ditt A2P-varumärke och din kampanj har skickats in.",
          "successMessage": "Obs: Du kommer att få ett OTP-meddelande från TCR på ditt angivna mobilnummer för att verifiera. Svara Ja inom 24 timmar efter att du mottagit SMS:et.",
          "successWaitDays": "7 dagar",
          "successWaitPrefix": "Det kan ta upp till ",
          "successWaitSuffix": " för godkännande av ditt varumärke och ytterligare 4–5 veckor för godkännande av kampanjen."
        },
        "reminder": {
          "noReplyYet": "Inget svar ännu",
          "patientConfirmed": "Patient bekräftad"
        },
        "sendGrid": {
          "apiKeyRequired": "API-nyckel krävs"
        },
        "update": {
          "brandNameHelper": "Använd det juridiska namnet på den organisation som skickar meddelandena.",
          "businessVerticals": "Affärsvertikaler*",
          "resendOTP": "Skicka OTP igen",
          "retryOTPTitle": "Försök igen med OTP-verifiering"
        }
      },
      "addCustomEmailModal": {
        "title": "Lägg till anpassad e-postadress"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Lägg till leverantör",
        "clickHereForInfo": "Klicka här för att få mer information.",
        "clickHereToFindOut": "Klicka här för att få veta mer om dem.",
        "createProviderError": "Något gick fel med att skapa leverantören!",
        "gmailLimitations": "Gmail har vissa begränsningar.",
        "needHelp": "Behöver du hjälp med att hitta SMTP-server och portnummer?",
        "port25NotSupported": "Port 25 stöds inte! Använd port 2525 istället",
        "providerExists": "En leverantör med denna e-postadress/användarnamn finns redan.",
        "providerName": "Leverantörens namn",
        "selectProvider": "Välj leverantör",
        "smtpPortNumber": "SMTP-portnummer",
        "smtpProvider": "SMTP-leverantör",
        "smtpServer": "SMTP-server",
        "username": "Användarnamn",
        "usernameOrEmailRequired": "Antingen användarnamn eller e-post krävs.",
        "verifySmtpAccount": "Verifiera SMTP-konto"
      },
      "addTagModal": {
        "addTag": "Lägg till tagg",
        "editTag": "Redigera tagg",
        "tagAlreadyExists": "Taggen {tag} finns redan"
      },
      "affiliates": {
        "firstPromoterAccessMessage": "Dessa FirstPromoter-rapporter är endast tillgängliga för <strong>byråägare och administratörer</strong>. Om du behöver hjälp, kontaktar du din <strong>byråägare ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "FirstPromoter-kontrollpanel",
        "noPartnersFound": "Kunde inte hitta en partner som matchar dina filter. Klicka <a href='javascript:void(0);'>här</a> för att ansöka om att bli partner.",
        "paymentDetailsAccessMessage": "Avsnittet med betalningsuppgifter är endast tillgängligt och redigerbart för <strong>byråägaren</strong>. Om du behöver hjälp, kontaktar du din <strong>byråägare ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Mötesdetaljer"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Läs in lägesbild:",
        "loadSnapshotWarning": "Vill du läsa in lägesbilden som är kopplad till den här planen? <br /> <strong class='text-danger'>Befintlig data kan gå förlorade</strong>"
      },
      "auth": {
        "changePassword": {
          "changeButton": "Ändra lösenord",
          "confirmPassword": "Bekräfta nytt lösenord",
          "expired": "Din länk för återställning av lösenord har gått ut.",
          "regenerateLink": "Generera länken igen",
          "success": "Lösenordet har ändrats",
          "title": "Ange nytt lösenord",
          "passwordMismatch": "Lösenorden matchar inte"
        },
        "forgotPassword": {
          "contactAgency": "kontakta din byrå.",
          "contactSupport": "kontakta HighLevels support dygnet runt genom att ringa",
          "supportMessage": "Om du inte har åtkomst till den e-postlådan, vänligen kontakta supporten",
          "successMessage": "En länk för återställning av lösenordet har skickats till din e-postadress.",
          "rateLimitError": "För många förfrågningar om återställning av lösenord. Försök igen senare."
        },
        "login": {
          "inactivityMsg": "Vi har märkt att du har varit inaktiv ett tag, så vi har loggat ut dig av säkerhetsskäl.",
          "loginButton": "Logga in",
          "resetPasswordMsg": "En länk för återställning av lösenordet har skickats till din e-postadress.",
          "signInWithGoogle": "Logga in med Google",
          "contactHighLevelSupport": " kontakta HighLevels support dygnet runt genom att ringa"
        },
        "logout": {
          "loggingOut": "Loggar ut …"
        },
        "otp": {
          "enterBackupCode": "Ange din reservkod",
          "resend": "Skicka igen",
          "resendIn": "Skicka igen om",
          "sendToPhone": "Skicka kod till telefonnummer",
          "sending": "Skickar",
          "useAuthenticator": "Använd autentiseringsappen",
          "useBackupCode": "Använd reservkod",
          "verifyButton": "Verifiera med reservkod"
        },
        "sso": {
          "agreeTerms": "Genom att logga in godkänner du våra <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>regler och villkor</a>",
          "and": ", och",
          "loginDifferentMethod": "Logga in på ett annat sätt",
          "loginSuccessRedirecting": "Inloggningen lyckades, omdirigerar …",
          "processing": "Behandlar din förfrågan...",
          "redirecting": "Omdirigerar...",
          "redirectingToDashboard": "Omdirigerar till kontrollpanelen...",
          "signedIn": "Inloggad",
          "signingIn": "Loggar in …",
          "testFailedRedirecting": "Testet misslyckades, omdirigering pågår...",
          "testSuccessRedirecting": "Testet lyckades, omdirigerar..."
        }
      },
      "businessDetailModal": {
        "businessAddress": "Företagsadress: {address}",
        "businessDetailsText": "Följande företagsuppgifter kommer att skickas till Google Local Services Ads för Reserve with Google Integration. Kontrollera och bekräfta eller {link} för att uppdatera din företagsprofil.",
        "businessInfoRequired": "Ovanstående företagsinformation krävs för integration, {link} för att uppdatera saknade/felaktiga företagsuppgifter.",
        "businessName": "Företagsnamn: {name}",
        "businessNiche": "Affärsnisch: {niche}",
        "city": "Stad: {city}",
        "confirmDetails": "Jag bekräftar härmed att ovanstående uppgifter är korrekta",
        "country": "Land: {country}",
        "mustConfirmDetails": "Du måste bekräfta ovanstående uppgifter.",
        "phoneNumber": "Telefonnummer: {phone}",
        "state": "Delstat: {state}",
        "zipCode": "Postnummer: {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Lägg till timmar",
        "applyAll": "Tillämpa alla"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Svara på samtalet och ange den här verifieringskoden:",
          "leadConnectorCalling": "Lead Connector ringer ...",
          "title": "Lägg till nummerpresentation med rösten",
          "waitingForVerification": "Väntar på verifieringen …"
        },
        "callerIdVerificationStatus": {
          "failed": "Verifiering av nummerpresentation misslyckades. Försök igen.",
          "success": "Du har verifierat <strong>{contact}</strong>"
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Lägg till befintliga nummer",
          "areaCode": "Riktnummer:",
          "checkAvailability": "Kontrollera tillgänglighet",
          "checkingAvailability": "Kontrollerar tillgängliga nummer.",
          "chooseAreaCode": "Välj ett riktnummer",
          "choosePhoneNumbers": "Välj telefonnummer",
          "goBack": "Gå tillbaka",
          "localNumbers": "Lokal {type}",
          "nextNumberFeatures": "Nästa: Nummerfunktioner",
          "noExistingNumbers": "Inga befintliga nummer att lägga till",
          "noNumbersAvailable": "Inga nummer tillgängliga",
          "notEnoughNumbers": "Inte tillräckligt många nummer tillgängliga",
          "numbersAvailable": "Tillgängliga nummer",
          "numbersDifferentArea": "Nummer i ett annat riktnummerområde",
          "numbersLocalTo": "Lokala nummer för <strong>{number}</strong>",
          "problemChecking": "Problem med att kontrollera numrets tillgänglighet. Kontrollera nätverksanslutningen eller kontakta supporten.",
          "somethingWentWrong": "Något gick fel. Kontrollera dina Twilio-kontouppgifter och skicka ett meddelande till supporten om problemet kvarstår.",
          "tollFreeNumbers": "Avgiftsfria nummer (2,00 $ per nummer per månad i tilläggsavgift)",
          "percentageComplete": "67 % slutförd"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "Jag förstår konsekvenserna, radera poolen",
          "confirmText": "Bekräfta genom att skriva <b>{name}</b>",
          "title": "Ta bort nummerpool – <strong>{name}</strong>",
          "warning": "Åtgärden kan inte ångras. Detta raderar numret/numren permanent från ditt Twilio-konto samt från vår nummerpoolen i vår databas. Också, om du raderar nummerpoolen eftersom du stöter på ett problem, kontakta vårt supportteam."
        },
        "editNumberFormatModal": {
          "description": "Du kan uppdatera formateringen av bytesnummer och poolnummer efter eget tycke. Se till att bytesnumret/numren visas med samma format på webbplatsen.",
          "title": "Uppdatera nummerformatering – <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Lägg till/redigera grupp-ID",
          "callConnectTooltip": "Den här funktionen kräver att mottagaren trycker på en knapp för att koppla samtalet, vilket ger högre noggrannhet för samtalsrapportering.",
          "createGroupIdDescription": "Skapa/lägg till ett unikt grupp-ID för att använda flera nummerpooler med ett enda JavaScript-utdrag.",
          "enableCallConnect": "Aktivera funktionen för samtalskoppling",
          "groupId": "Grupp-ID",
          "outboundCallTimeout": "Timeout för utgående samtal",
          "passCallerID": "Skicka uppringt nummer som nummerpresentation",
          "passCallerIDTooltip": "Som standard vidarebefordrar systemet uppringarens nummer, men om du vill att nummerpresentationen istället ska visa det nummer som uppringaren har slagit kan du aktivera den här funktionen.",
          "selectCallerID": "Välj nummerpresentation",
          "timeDuration": "Tidslängd i sekund(er)",
          "titleNumber": "Nummer – <strong>{number}</strong>",
          "updateWhisperWarning": "Uppdatera viskningsmeddelandet eftersom den här funktionen kräver att mottagaren trycker på en knapp för att ansluta samtalet.",
          "useVerifiedNumber": "Använd ditt verifierade nummer som nummerpresentation för utgående samtal",
          "useVerifiedNumberTooltip": "Gäller endast verifierade telefonnummer. Du kan verifiera ett telefonnummer i Inställningar > Telefonnummer > Lägg till verifierad nummerpresentation"
        },
        "emailOTPModal": {
          "confirmCode": "Bekräfta koden",
          "resendCode": "Om du inte har fått koden klickar du här för att skicka igen",
          "unexpectedIssue": "Ett oväntat problem uppstod"
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Information om anpassat fält",
          "customFieldTooltip": "Verktygstips för anpassat fält: {options}",
          "field": "{companyName} -fält",
          "trackingParameters": "Spårningsparametrar",
          "zipCode": "Postnummer"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Lägg till byte av nummer",
          "addingSnippets": "Lägga till JavaScript-utdrag",
          "groupSnippet": "Gruppera {id}-utdrag",
          "normalSnippet": "Normalt utdrag",
          "noswapDescription": "Om du inte vill att vi ska byta ut numret på en viss plats lägger du till klassen \"noswap\".",
          "notReplacing": "Byt inte ut på vissa platser",
          "requiredSteps": "Obligatoriska steg",
          "snippetsDescription": "Kopiera koden nedan och lägg till den precis ovanför den avslutande body-taggen på varje sida där du vill ersätta numren.",
          "swappingDescription": "Använd numren nedan för att aktivera byte av telefonnummer. Välj ett lokalt eller internationellt format, eller båda."
        },
        "newPhoneNumberModal": {
          "areaCode": "Riktnummer",
          "availableNumbers": "Tillgängliga nummer",
          "bundle": "Paket",
          "chooseAddress": "Välj adress …",
          "chooseBundle": "Välj paket...",
          "createRegulatory": "Skapa ett föreskriftspaket/adress här.",
          "monthlyFee": "Månadsavgift",
          "noNumbersFound": "Inga nummer hittades, försök med ett annat riktnummer.",
          "selectAddress": "Välj ”Adress” för att köpa numret.",
          "selectBundle": "Välj ”Paket” för att köpa numret.",
          "title": "Lägg till telefonnummer",
          "upgradeAccount": "Uppgradera ditt Twilio-konto. Endast uppgraderade konton kan köpa telefonnummer och ringa samtal.",
          "cardAuthenticationFailed": "Kortautentisering misslyckades!"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "Du måste godkänna villkoren och sekretesspolicyn.",
          "clickingProceed": "Om du klickar på Fortsätt öppnas LSA-länksidan i en ny flik",
          "configureCalendar": "Konfigurera minst en kalender om du vill fortsätta med integrationen Boka med Google",
          "configureCalendarBtn": "Konfigurera kalendern",
          "linkOneAccount": "Se till att du endast länkar ett konto. Kontakta supporten om du inte kan se sidan i skärmbilden ovan.",
          "readInstructions": "Jag har läst igenom ovanstående instruktioner"
        },
        "updateTrackingModal": {
          "title": "Uppdatera spårningsalternativet"
        },
        "usageSummary": {
          "agencyOnlyVisible": "(Detta är endast synligt för byråadministratörer)",
          "updatedEvery24Hours": "(uppdateras var 24:e timme)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Kalendern är inte markerad för synkronisering",
          "check": "Kontrollera {email}",
          "checkForConflicts": "Kontrollera om det finns konflikter",
          "checkForConflictsTooltip": "Ställ in kalendrarna för att kontrollera om det finns konflikter och förhindra dubbelbokningar.",
          "contactCreationAllowed": "Kontaktskapande tillåts",
          "googleCalendar": "Google Kalenders logotyp",
          "noGoogleAccounts": "Inga Google/Outlook-konton har lagts till i Integrationsinställningarna ännu",
          "noGoogleAccountsTeamMember": "Inga konton på Google/Outlook har lagts till för den här teammedlemmen på den aktuella platsen. Be teammedlemmen att logga in via sitt konto och lägga till Google-anslutningen från sina integrationsinställningar.",
          "outlookCalendar": "Outlook UserCalendar",
          "primaryCalendarTooltip": "Välj den kalender som du vill lägga till nya händelser i när de schemaläggs.",
          "runTriggerAllowed": "Kör utlösare tillåts"
        },
        "warningModal": {
          "contactAgency": "Kontakta din byrå om du vill ändra e-postinställningarna.",
          "title": "Varning"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Snabbare chattsupport dygnet runt",
            "faster247Ticket": "Snabbare ärendesupport och svarstider dygnet runt"
          },
          "highlight": {
            "description": "Vi förstår, du måste jobba snabbare. När du har en fråga eller problem vill du att det ska besvaras så snart som möjligt! Med uppgraderingen Prioriterad support kan du hoppa över kön och automatiskt få dina förfrågningar hanterade snabbare.",
            "heading": "Är du redo för VIP-behandlingen?"
          },
          "name": "Prioriterad support",
          "success": {
            "description": "Prioriterad support har aktiverats på ditt konto. Inget mer köande för dig.",
            "heading": "Du är nu en prioriterad kund!"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "Klona {entityName}",
        "cloning": "Klonar …",
        "cloningLimit": "Kloning är begränsad till 3 platser åt gången",
        "error": "Fel vid kloning av tratten!",
        "locationsLabel": "Välj platser",
        "nameLabel": "Namn för den klonade {entityName}",
        "namePlaceholder": "Ange namn för klonad {entityName}",
        "selectUpTo": "Välj upp till {maxSelectableLocations} platser",
        "title": "Klona {entityName}"
      },
      "cnam": {
        "learnMore": {
          "description": "Med CNAM visas ditt företagsnamn på nummerpresentatören, vilket gör att kunderna genast känner igen dina samtal och får större förtroende för dig. Låt kunderna veta att det är du som ringer – varje gång.",
          "title": "Få dina samtal att sticka ut!"
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Bekräfta och registrera",
          "description": "Visa ditt företagsnamn för mottagarna för att öka förtroendet och få fler att svara på samtalen.",
          "title": "Öka förtroendet för samtal med CNAM",
          "warning": "Visning av företagsnamnet garanteras inte, särskilt inte på mobila enheter."
        },
        "submitted": {
          "checkStatus": "Kontrollera CNAM-status",
          "description": "Ditt företagsnamn bör visas för relevanta kontakter inom cirka 3–5 dagar.",
          "subtitle": "Din CNAM-förfrågan har skickats in.",
          "title": "Grattis!"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Bekräfta radering",
        "confirmation": "Bekräftelse"
      },
      "createAddress": {
        "successTitle": "Adressen har skickats in",
        "underReview": "Den inskickade adressen granskas"
      },
      "createEndUser": {
        "dateFormat": "Datumformatet ska vara ÅÅÅÅ-MM-DD.",
        "phoneExample": " Exempel: +14155552671",
        "title": "Företagsinformation:"
      },
      "customValueModal": {
        "changingNameWarning": "Att ändra namnet kommer inte att påverka fältnyckeln.",
        "editCustomValue": "Redigera anpassat värde",
        "fieldKeyCreatedWarning": "Fältnyckeln skapas enligt namnet och kan inte ändras i efterhand.",
        "nameRequired": "Namnfältet krävs",
        "nameValidation": "Namnet bör vara alfanumeriskt och innehålla minst ett tecken",
        "valueRequired": "Värdefältet krävs"
      },
      "details": {
        "addressName": "Adressnamn",
        "addressTitle": "Adressuppgifter",
        "bundleName": "Paketnamn",
        "bundleTitle": "Info om regulatoriskt paket",
        "countryFlag": "{country} flagga",
        "id": "ID",
        "organisation": "Organisation",
        "rejectionReason": "Orsak till avslag",
        "status": {
          "approved": "Godkänd",
          "notValidated": "Inte validerad",
          "rejected": "Nekad",
          "validated": "Validerad"
        },
        "typeOfNumber": "Typ av nummer"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Välj kontor",
        "whichOffice": "Vilket kontor vill du länka till det här kontot?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Tillåt att kontakter skapas:",
        "allowTrigger": "Tillåt utlösare:",
        "doNotSync": "Synkronisera inte nya händelser till den primära kalendern",
        "primaryCalendarTooltip": "Du kan bara välja en kalender med skrivåtkomst som du inte har valt för konfliktkontroll.",
        "selectDefaultCalendar": "Välj standardkalender",
        "whichCalendar": "Vilken kalender ska vi använda för att synkronisera (läsa och skriva) händelser till?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Kontrollera om det finns konflikter på dessa platser",
        "howToCheckConflicts": "Hur ska vi kolla efter konflikter?"
      },
      "ejectModal": {
        "agencyClosing": "Elite Marketing-byråns konto hos Highlevel stängs. Om du vill behålla ditt konto, vänligen kontakta {userName} för att migrera ditt konto direkt till Highlevel.",
        "cancelWarning": "Observera att ditt konto avslutas officiellt den 30 juni 2025, och vi kommer inte att kunna återställa dina uppgifter efter det datumet om överföringen inte har slutförts.",
        "contactEmail": "transfers{'@'}gohighlevel.com",
        "contactUs": "Om du har frågor kan du kontakta oss på",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "För att stödja dig under den kostnadsfria övergången ger vi dig {months} kostnadsfri åtkomst till din nya prenumeration.",
        "intro": "På grund av upprepade överträdelser av HighLevels användarvillkor har Elite Marketing Authority (EMA) permanent tagits bort från HighLevel-plattformen.",
        "platformCommitment": "Eftersom HighLevel är plattformen bakom EMA:s tjänster är vi fast beslutna att upprätthålla en säker, kompatibel och pålitlig miljö för alla användare. För att undvika störningar i ditt konto är vi här för att hjälpa dig med en smidig övergång – antingen till en annan white label-leverantör eller direkt till HighLevel.",
        "questions": "Om du har frågor kan du",
        "retainAccess": "Om du vill behålla åtkomsten till dina befintliga data och verktyg klickar du på knappen nedan och följer instruktionerna för att påbörja överföringen.",
        "speakWithTeam": "att tala med vårt team.",
        "startTransfer": "Starta din gratisöverföring",
        "title": "Information till kunder hos Elite Marketing",
        "viewFaqs": "Visa vanliga frågor här:",
        "whiteLabel": "Om du hellre vill använda HighLevel genom en annan white label-leverantör hjälper vi dig gärna med den ändringen via vårt supportsystem efter att du har överfört ditt konto direkt till HighLevel."
      },
      "emailTemplate": {
        "createdOn": "Skapad På",
        "updatedOn": "Uppdaterad den"
      },
      "error": {
        "title": "Inlämning av regulatoriskt paket misslyckades"
      },
      "errors": {
        "funnel": {
          "multiplePages": "Den här URL:en finns på mer än en sida. Ändra sökvägen till den här sidan så att den fungerar.",
          "urlNotFound": "Vi kan tyvärr inte hitta URL:en du letade efter"
        },
        "productRebilling": {
          "requestFailed": "Förfrågan misslyckades"
        },
        "template": {
          "categoryNotFound": "Vi kan tyvärr inte hitta kategorin du letade efter.",
          "internalError": "Ett internt fel har uppstått!"
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "Underkontot som du försöker överföra har HIPAA aktiverat och kan inte överföras till en byrå utan HIPAA."
          },
          "limitExceeded": {
            "message": "Byrån som du försöker överföra underkontot till har nått sin användningsgräns och kan inte ha fler underkonton.  Be dem att antingen radera ett underkonto som inte används eller uppgradera till ett högre abonnemang för att ta del av det här underkontot."
          },
          "pendingRequest": {
            "heading": "En överföringsförfrågan för det här underkontot väntar redan.",
            "message": "Avbryt den befintliga förfrågan om överföring för underkontot innan du skapar en ny."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "Hittar du inte sidan du söker? Gå till dina Facebook-inställningar och se till att alla sidor är markerade.",
        "instagramAvailable": "Instagram är tillgängligt för det här kontot!",
        "noPages": "Du har inga sidor på det här kontot.",
        "title": "Välj vilken Facebook-sida du vill länka till den här platsen"
      },
      "googleLocationSelect": {
        "closeButton": "Stäng!",
        "enableCallTracking": "Aktivera GBP-samtalsspårning",
        "noBusinesses": "Du har inga anslutna företag på det här kontot."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "Mer effektiv",
          "faster": "Snabbare",
          "itsText": "Det är",
          "smoother": "Smidigare",
          "title": "En ny importupplevelse är här!",
          "warningMessage": "Om du aktiverar den nya importfunktionen aktiveras Labs för detta underkonto och betafunktionen slås på."
        },
        "validateEmails": "Validera e-postadresser?"
      },
      "initBundle": {
        "numberType": "Typ av nummer du planerar att använda",
        "numberTypes": {
          "local": "Lokala nummer",
          "mobile": "Mobil",
          "tollfree": "Avgiftsfritt"
        },
        "selectCountry": "Välj ditt land",
        "selectUserType": "Välj användartypen",
        "userTypes": {
          "business": "Företag",
          "individual": "Individ"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Kredit senast tillagd den:",
        "currentBalance": "Aktuellt saldo",
        "debitBalance": "– Debetsaldo",
        "depositComplimentaryCreditsOf": "Sätt in kostnadsfria krediter för",
        "manageBalance": "Hantera saldo",
        "mustBeValidInteger": "Måste vara ett giltigt heltal",
        "nextDate": "Nästa datum:",
        "perMonth": "per månad",
        "remainingWalletBalance": "Återstående plånbokssaldo för detta underkonto",
        "rolloverCredits": "Överför krediter till nästa månad",
        "toManageMonthlyCredits": "För att hantera månadskrediter,"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Lägg till nytt abonnemang"
      },
      "manualActions": {
        "confirmDelete": "Är du säker på att du vill radera den här åtgärden?",
        "confirmDeleteAll": "Är du säker på att du vill radera alla manuella åtgärder på den här sidan?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Skapa ett starkt lösenord",
          "sendEmailNotification": "Skicka även en e-postavisering."
        }
      },
      "modal": {
        "description": "Du måste slutföra några enkla efterlevnadssteg för att använda telefonsystem",
        "submit": "Skicka",
        "title": "LeadConnectors telefontjänst"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Besökare på startsidan",
          "launched": "Lanserades",
          "newNotification": "Ny avisering",
          "startMessage": "Börja öka dina konverteringar genom att skapa din första avisering",
          "types": {
            "combination": "Kombination"
          }
        },
        "page": {
          "createTitle": "Skapa ny avisering",
          "steps": {
            "display": "Visa",
            "track": "Spåra"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Ytterligare info",
          "calendarEvent": "Kalenderhändelse",
          "hideAssignedTo": "Dölj tilldelad till",
          "hideTags": "Dölj taggar"
        },
        "filters": {
          "dateAddedAsc": "↑ Datum tillagt (stigande)",
          "dateAddedDesc": "↓ Datum tillagt (fallande)",
          "orderBy": "OrderBy"
        },
        "getStarted": "komma igång!",
        "noPipelines": "Hoppsan! Det verkar inte finnas några pipelines. Skapa en ny pipeline för att"
      },
      "pages": {
        "pageMoved": {
          "title": "Online-listningar har flyttats"
        }
      },
      "recentlyVisited": {
        "prices": "{count} priser"
      },
      "reminders": {
        "appointmentReminders": "Påminnelser om möten",
        "apptTime": "Mötestid",
        "defaultDateRange": "Sön 1 apr. 2018–mån 31 apr. 2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "Parkerad",
        "rebillingOnHoldWarning": "Det här kontot har redan parkerade inställningar för återfakturering. SaaS-abonnemanget kan endast anslutas efter att klienten har lagt till en betalningsmetod.",
        "subscriptionId": "Abonnemangs-ID:"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Bekräfta och fortsätt",
        "documents": {
          "acceptedDocuments": "Godkända dokument",
          "acceptedDocumentsLabel": "Godkända dokument:",
          "additionalInfo": "Ytterligare information:",
          "createAddressLink": "Skapa adress.",
          "createAddressPrompt": "Skapa först en adress och fortsätt sedan med att skapa paketet.",
          "documentInfo": "PNG, JPG, PDF upp till 5 MB",
          "documentType": "Dokumenttyp",
          "option": "Alternativ {number}",
          "selectAddress": "Välj adress:",
          "selectDocumentType": "Välj dokumenttyp:",
          "selectFile": "Välj fil",
          "title": "Obligatoriska dokument:",
          "updateDocuments": "Uppdatera dokument"
        },
        "everythingIn": "Allt i <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "lägg till kreditkort här",
          "message": "Var vänlig be er kund att",
          "title": "Platsen måste först lägga till betalningsmetod."
        },
        "noSaasPlan": {
          "linkText": "Skapa dina SaaS-abonnemang här.",
          "message": "Vänligen",
          "title": "Du har ingen konfigurerad SaaS-plan."
        },
        "saasModeSetupPendingWarning": "SaaS-abonnemanget kommer att aktiveras efter att kunden har lagt till en betalningsmetod. Fram till dess kommer deras kontoåtkomst att vara begränsad.",
        "skipForNow": "Hoppa över tills nu",
        "skipPlan": "Hoppa över abonnemang",
        "success": {
          "title": "Föreskriftspaket skickat",
          "underReview": "Det inskickade paketet granskas"
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "Det här alternativet lägger till en ny adress till ditt konto",
          "label": "Adresspaket"
        },
        "regulatoryBundle": {
          "description": "Det här alternativet hjälper dig att skapa ett nytt regulatoriskt paket",
          "label": "Regulatoriskt paket"
        },
        "title": "Välj vilket paket du vill lägga till"
      },
      "settings": {
        "billing": "Fakturering",
        "calendars": "Kalendrar",
        "customEmails": "Anpassade e-postmeddelanden",
        "domains": "Domäner",
        "domainsAndUrlRedirects": "Domäner och URL-omdirigeringar",
        "facebookFormFieldsMapping": "Fältmappning för Facebook-formulär",
        "groups": "Grupper",
        "integrations": "Integrationer",
        "labs": "Labs",
        "media": "Media",
        "noShowSMS": "SMS vid utebliven ankomst",
        "pipelines": "Pipelines",
        "profile": "Profil",
        "smtpAndMailGunService": "SMTP- och MailGun-tjänst",
        "templates": "Mallar",
        "urlRedirects": "URL-omdirigeringar"
      },
      "shakenStir": {
        "confirmation": {
          "title": "Dina samtal är nu verifierade!"
        },
        "modal": {
          "andThe": " och ",
          "certification": "Jag intygar att den tillhörande företagsprofilen är upphovsman till telefonsamtalen och intygar att jag kommer att delta i spårningsinsatser, inklusive sådana som initieras av",
          "failedTitle": "Inlämningen misslyckades",
          "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 kl 19:47:14",
          "linkInfo": {
            "description": "Alla nuvarande tillgängliga nummer och nummer som köps i framtiden registreras automatiskt med SHAKEN/STIR.",
            "title": "Alla nummer länkas automatiskt"
          },
          "stiPa": "Administratör för säker telefonidentitetspolicy (STI-PA)",
          "subtitle": "Ange detaljerna och beskrivningen",
          "successMessage": "Din förfrågan om SHAKEN/STIR-registrering har skickats in. Det kan ta upp till <b>3–4 dagar</b> innan den godkänns. Statusen kommer att uppdateras snart.",
          "successTitle": "Säker samtalsverifiering via SHAKEN/STIR aktiverad.",
          "title": "Aktivera säker samtalsverifiering via SHAKEN/STIR",
          "tracebackGroup": "US Telecoms grupp för samtalsspårning"
        },
        "withCnam": {
          "cnamPromo": "Vill du gå ett steg längre? Visa ditt företagsnamn i samtal med CNAM.",
          "registerCnam": "Registrera dig för CNAM",
          "title": "Skapa kundförtroende och öka svarsfrekvensen"
        },
        "successMessage": "Din förfrågan om SHAKEN/STIR-registrering har skickats in. Det kan ta upp till <b>3–4 dagar</b> innan den godkänns. Statusen kommer att uppdateras snart."
      },
      "shopify": {
        "selectLocation": "Välj vilken plats du vill länka till den här Shopify-butiken"
      },
      "signup": {
        "accountType": "Kontotyp",
        "agencyProAccount": "Byrå Pro-konto (497 $/månad)",
        "agencyTestAccount": "Testkonto för byrå",
        "freeTrialMessage": "Få en 14-dagars <strong>gratis</strong> provperiod genom att registrera dig nu.",
        "freelancerAccount": "Frilansare-konto (297 $/månad)",
        "getStartedForFree": "Kom igång gratis!",
        "pickPassword": "Välj ett lösenord",
        "signUp": "Registrera dig",
        "starterAccount": "Startversion-konto (97 $/månad)",
        "termsAndConditions": "Genom att registrera dig godkänner du våra <a href='https://www.gohighlevel.com/privacy' target='_blank'>regler och villkor</a>",
        "yourCompanyName": "Ditt företagsnamn",
        "yourFullName": "Ditt fullständiga namn"
      },
      "standardPlan": {
        "description": "Vi har följande abonnemang för registrering av standardvarumärken.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN krävs för registrering",
            "moreThan1Phone": "Mer än ett telefonnummer är tillåtet"
          },
          "highVolume": {
            "heading": "Hög volym Standard",
            "point3": "Upp till 600 000 segment per dag",
            "infoText": "En engångsavgift på 20,95 USD debiteras för registrering av varumärke och kampanj. En extra kampanjavgift på upp till 2,25 USD per månad tillkommer i enlighet med TCR-reglerna.",
            "point2": "Skicka upp till 3 000 segment per dag",
            "point1": "EIN krävs för registrering"
          },
          "lowVolume": {
            "heading": "Låg volym Standard",
            "recommended": "Rekommenderad",
            "point3": "Upp till 6 000 segment per dag",
            "infoText": "En engångsavgift på 20,95 USD debiteras för registrering av varumärke och kampanj. En extra kampanjavgift på upp till 2,25 USD per månad tillkommer i enlighet med TCR-reglerna.",
            "point2": "Skicka upp till 3 000 segment per dag",
            "point1": "EIN krävs för registrering"
          }
        },
        "title": "Välj abonnemang för standardvarumärket"
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Bokningsinformation",
          "form": "Formulär",
          "quiz": "Quiz",
          "submissionDetail": "Inlämningsdetalj",
          "survey": "Undersökning"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Endast byråadministratörer/användare har tillgång till detta underkonto. För närvarande har du och andra kontoadministratörer/användare inte tillgång till detta underkonto.",
          "heading": "Det här underkontot har pausats."
        },
        "temporarily": {
          "description": "Alla dina data är säkra och alla utlösare/kampanjer etc. kommer att fungera igen efter aktiveringen.",
          "heading": " Ditt konto har tillfälligt stängts av."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Tillämpa endast på ej tilldelade kontakter",
          "splitTraffic": "Dela upp trafiken",
          "trafficWeightage": "Trafikviktning",
          "userRequired": "Användaren måste markeras",
          "weightage": "Viktning"
        },
        "birthdayFilters": {
          "afterDays": "Efter antal dagar",
          "beforeDays": "Före antal dagar",
          "dayIs": "Dagen är",
          "daysInNumber": "Antal dagar",
          "hasTag": "Har tagg",
          "monthIs": "Månaden är",
          "selectDay": "Välj dag",
          "selectMonth": "Välj månad"
        },
        "botConversation": {
          "enterTimeout": "Ange en timeout (timmar)",
          "selectEliza": "Välj Eliza",
          "selectThankyouTemplate": "Välj tackmall",
          "selectWelcomeTemplate": "Välj välkomstmall"
        },
        "contactField": {
          "addField": "Lägg till fält",
          "defineFilters": "Definiera filter"
        },
        "copyModal": {
          "title": "Kopiera utlösare"
        },
        "detailModal": {
          "actionsPerform": "Vilka åtgärder ska vi utföra?",
          "campaignNameRequired": "Fältet Kampanjnamn krävs",
          "campaignsDeprecation": "Kampanjer underhålls inte längre. För att säkerställa en smidig övergång ber vi dig att konvertera dina befintliga kampanjer till arbetsflöden.",
          "folderName": "Mappnamn",
          "mustSelectFolder": "Du måste välja en mapp.",
          "newFolderName": "Nytt namn på mapp",
          "selectFolder": "Välj mapp",
          "triggerNameRequired": "Fältet Utlösarnamn krävs",
          "triggersDeprecation": "Utlösare underhålls inte längre. För att säkerställa en smidig övergång ber vi dig att konvertera dina befintliga utlösare till arbetsflöden.",
          "triggerName": "Utlösarens namn"
        },
        "dnd": {
          "disableAll": "Inaktivera DND för alla kanaler",
          "disableSpecific": "Inaktivera DND för specifika kanaler",
          "enableAll": "Aktivera DND för alla kanaler",
          "enableSpecific": "Aktivera DND för specifika kanaler",
          "selectAction": "Välj åtgärd"
        },
        "email": {
          "sendTestEmail": "Skicka testmejl",
          "smtpWarning": "SMTP-leverantörer har vissa begränsningar. Klicka här om du vill veta mer."
        },
        "facebook": {
          "avatarAlt": "Facebook-avatar",
          "selectCustomAudience": "Välj anpassad målgrupp"
        },
        "googleAds": {
          "conversionName": "Konverteringsnamn",
          "conversionTooltip": "Konverteringskällan ska vara Importera från klick och kategorin ska vara Importerad potentiell kund eller Potentiell kund",
          "noConversions": "Inga konverteringsfrekvenser hittades",
          "selectConversion": "Välj konvertering"
        },
        "googleAnalytics": {
          "eventAction": "Händelseåtgärd",
          "eventActionRequired": "Händelseåtgärd krävs.",
          "eventCategory": "Händelsekategori",
          "eventCategoryRequired": "Händelsekategori krävs.",
          "eventLabel": "Händelseetikett",
          "eventValue": "Händelsevärde",
          "hitType": "Träfftyp",
          "hitTypeRequired": "Träfftyp krävs.",
          "trackingId": "Spårnings-ID",
          "trackingIdRequired": "Spårnings-ID krävs."
        },
        "membershipOffer": {
          "selectOffer": "Välj erbjudande"
        },
        "notification": {
          "selectRedirectPage": "Välj omdirigeringssida",
          "selectUser": "Välj användare",
          "selectUserType": "Välj användartyp"
        },
        "sms": {
          "sendTestSMS": "Skicka test-SMS"
        },
        "stripeCharge": {
          "customerId": "Stripe kund-ID",
          "enterAmount": "Ange belopp",
          "selectCurrency": "Välj valuta"
        },
        "webhook": {
          "webhookUrl": "Webhook URL"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Aktivitetsdatum",
            "balance": "Saldo",
            "id": "id"
          }
        },
        "upgradeBanner": {
          "subtitle": "Byråer med Pro-abonnemang tjänar cirka 363 $ per månad genom att återfakturera telefonkostnaderna till sina kunder",
          "title": "Vill du fakturera detta vidare till dina kunder?"
        }
      },
      "updateModals": {
        "error": {
          "title": "Det gick inte att skicka in din profil."
        },
        "success": {
          "message": "Ditt A2P-varumärke och din kampanj har skickats in.<br/><br/><b>Obs:</b> Du kommer <b>att få ett OTP-meddelande från TCR på ditt angivna mobilnummer för att verifiera</b>. <b>Svara Ja inom 24 timmar</b> efter att du mottagit SMS:et."
        }
      },
      "usageLimit": {
        "contactLimit": "Kontaktgräns",
        "maxContactsAllowed": "Maximalt antal kontakter som tillåts på underkontot",
        "maxUsersAllowed": "Maximalt antal användare som tillåts på underkontot",
        "unlimited": "Obegränsat",
        "usageLimits": "Användningsgränser",
        "userLimit": "Användargräns",
        "userLimitHelpMessage": "Endast användare på underkontonivå räknas mot denna gräns. Du kan fortfarande lägga till så många byråanvändare till underkontona som du behöver"
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "Jag samtycker till att aktivera annonser för den här kunden utan uppsälj och jag godkänner att jag kommer att debiteras",
          "deployDirectly": "Distribuera listor direkt",
          "deployDirectlyDesc": "Använd det här alternativet om du erbjuder annonser som en del av ditt erbjudande eller om du vill fakturera din kund externt",
          "minimumCommitment": "med en minsta bindningstid på 1 månad.",
          "offerListings": "Erbjudandelistor",
          "resellListings": "Återförsäljningsannonser",
          "subscribedInfo": "{withoutUpsell} utan uppsäljning, {withUpsell} med uppsäljning och {withSaas} med SaaS-paket",
          "subscriptionCreated": "Abonnemang har skapats. Vänligen vänta...",
          "subscriptionCreating": "Ett abonnemang håller på att skapas.<br/>Vänligen uppdatera inte sidan och tryck inte på bakåtknappen",
          "unableToCreate": "Det gick inte att skapa abonnemanget. Kontakta supporten.",
          "unavailabilityForAgencyAdmin": "Yext är inte tillgängligt i det här landet. Om du tror att detta är ett misstag, vänligen föreslå det på vår roadmap på",
          "yourResellOffer": "Ditt återförsäljningserbjudande"
        }
      },
      "selectCountry": "Välj ditt land",
      "documents": {
        "additionalInfo": "Ytterligare info",
        "createAddressLink": "Skapa adress.",
        "createAddressPrompt": "Skapa först en adress och fortsätt sedan med att skapa paketet.",
        "selectAddress": "Välj adress:"
      }
    },
    "triggers": {
      "emptyTrigger": "Tom utlösare"
    },
    "util": {
      "addFiles": "+ Lägg till filer",
      "fillValues": "Fyll i värden",
      "image": "bild",
      "ok": "Ok",
      "pleaseTypeOrCancel": "Skriv {consentString} ovan eller avbryt åtgärden.",
      "pressEnterToAddCustomOption": "Tryck på retur för att lägga till anpassat alternativ",
      "required": "* krävs",
      "unsaved": "Osparad"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "Om du vill aktivera arbetsflödet för en plats går du till fliken Konton, klickar på ikonen med tre punkter till höger om ett underkonto och väljer <strong>Aktivera arbetsflödesbyggare</strong>. Processen är tillfällig eftersom Arbetsflöden lanseras på alla platser nästa vecka."
      },
      "faq": "FAQ",
      "gotIt": "Jag förstår",
      "workflowIsLive": "Arbetsflödet är live på ditt konto!"
    },
    "action": {
      "stats": {
        "bounced": "Avvisad",
        "clicked": "Klickad",
        "delivered": "Levererad",
        "opened": "Öppnad",
        "replied": "Svarade",
        "unsubscribed": "Avprenumererade",
        "total": "Totalt",
        "failed": "Misslyckades"
      },
      "actions": {
        "edit": "Redigera",
        "send": "Skicka",
        "remove": "Ta bort"
      },
      "timing": {
        "days": "Dagar",
        "immediately": "Omedelbart",
        "before": "Före",
        "after": "Efter",
        "minutes": "Minuter",
        "hours": "Timmar"
      },
      "labels": {
        "template": "Mall",
        "manual": "Manuell"
      },
      "details": {
        "hideDetail": "Dölj detaljer",
        "showDetail": "Visa detaljer"
      },
      "queue": {
        "people": "personer",
        "person": "person",
        "queued": "köad"
      },
      "tooltips": {
        "clickedHelp": "Noggrannheten för klickspårning kan variera beroende på e-postklient och användarinställningar.",
        "statsAccuracy": "Statistikens noggrannhet kan variera beroende på e-postklient och användarinställningar."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "Är du säker på att du vill radera denna bulk-förfrågan?",
        "startImmediately": "Starta omedelbart"
      },
      "modal": {
        "contactTypes": {
          "all": "Alla",
          "leads": "Potentiella kunder",
          "customers": "Kunder"
        },
        "buttons": {
          "cancel": "Avbryt",
          "update": "Uppdatera",
          "add": "Lägg till"
        },
        "labels": {
          "name": "Namn",
          "contactType": "Kontakttyp",
          "campaign": "Kampanj",
          "scheduledDate": "Schemalagt datum",
          "tag": "Tagg"
        },
        "placeholders": {
          "tags": "Taggar",
          "selectCampaign": "Välj kampanj",
          "pickType": "Välj typ"
        },
        "sections": {
          "bulkRequest": "Bulk-förfrågan",
          "whoShouldRun": "Vem ska den köras för?"
        },
        "titleAdd": "Lägg till bulk-förfrågan",
        "titleEdit": "Redigera bulk-förfrågan",
        "validation": {
          "scheduledDateRequired": "Schemalagt datum krävs"
        }
      }
    },
    "listFolder": {
      "expandIcon": "Expandera"
    },
    "list": {
      "confirmDeleteFolder": "Bekräfta att du vill radera mappen",
      "delete": "Radera",
      "confirmDelete": "Är du säker på att du vill radera den här kampanjen?",
      "moveToFolder": "Flytta till mapp",
      "pleaseRename": "byt namn",
      "removeFromFolder": "Ta bort från mappen"
    },
    "copy": {
      "title": "Kopiera kampanj",
      "newCampaignName": "Namn på ny kampanj",
      "locations": "Platser"
    }
  },
  "compliance": {
    "findOutMore": "Upptäck mer",
    "gdprDescription": "Vi tar skyddet av dina och dina kunders personuppgifter på största allvar och behandlar personuppgifter mycket konfidentiellt och i enlighet med de lagstadgade dataskyddsbestämmelserna och denna dataskyddsdeklaration.",
    "gdprTitle": "GDPR-efterlevnad",
    "hipaaDescription": "Aktivera säkerhetsuppgraderingar för att säkerställa att informationen i ditt HighLevel-konto är säker och uppfyller kraven i HIPAA",
    "hipaaTitle": "HIPAA-efterlevnad"
  },
  "customValues": {
    "key": "Nyckel",
    "selectedItemsCountSingular": "{count} rad har markerats",
    "selectedItemsCountPlural": "{count} rader har markerats"
  },
  "facebookAdFields": {
    "checkIcon": "Formuläret har mappats",
    "errorMessage": "Sidåtkomsttoken har antingen löpt ut eller så har den inte tillräckliga behörigheter. Se till att du har administratörsåtkomst till sidorna."
  },
  "fbLeadSync": {
    "confirmTitle": "Bekräfta synkronisering av Facebook Leads?",
    "impactMessage": "Förstå effekten av synkroniseringen av Facebook Leads innan du fortsätter:",
    "observations": "1. Detta synkroniserar Facebook Leads och skapar nya kontakter för varje potentiell kund som genererats under de senaste {days} dagarna som inte finns i din kontaktlista. <br>2. Om du har importerat saknade potentiella kunder manuellt med hjälp av CSV-fil som exporterats från Facebook Ads Manager, inaktivera Tillåt dubbletter av kontakter för att förhindra att synkroniseringen skapar dubbletter av kontakter. <br>3. Om du har arbetsflöden som utlöses vid <b>skapande av kontakter</b> eller <b>inskick av Facebook Lead-formulär</b>, kommer de att utlösas för varje ny kontakt som skapas. <br>4. Befintliga kontakter som skapats via Facebook Leads påverkas inte. <br>5. Den registrerade tiden för kontaktskapandet kommer att vara aktuell tid. <br>6. Synkroniseringen kan ta upp till en timme att slutföra, beroende på antalet potentiella kunder som ännu inte har synkroniserats. <br>",
    "proceedQuestion": "Vill du fortsätta med Facebook Leads-synkronisering?"
  },
  "integrationAI": {
    "accountDisconnected": "Konto frånkopplat!",
    "appNotFound": "Appkonfigurationen hittades inte. Använder reservdata.",
    "checkingConnection": "Kontrollerar anslutningsstatus...",
    "connecting": "Ansluter ...",
    "disconnectApp": "Koppla från app",
    "disconnecting": "Kopplar från ...",
    "loadingAppInfo": "Läser in appinformation...",
    "refreshConnection": "Uppdatera anslutningen",
    "refreshing": "Uppdaterar ...",
    "svgNotAvailable": "SVG är inte tillgänglig"
  },
  "phoneSystem": {
    "additionalSettings": "Ytterligare inställningar",
    "messaging": "Korrespondens",
    "messagingAnalytics": "Meddelandeanalys",
    "regulatoryBundles": "Regulatoriska paket",
    "title": "Telefonsystem",
    "trustCenter": "Trust Center",
    "voice": "Röst"
  },
  "demo": {
    "draggable": {
      "title": "Test av dragbar komponent",
      "usingVue3": "Använda Vue 3-kompatibel draggbar",
      "description": "Den här komponenten använder nu den reviderade Vue 3-kompatibla dragbara komponenten.",
      "buttons": {
        "resetAllLists": "Återställ alla listor",
        "clearLog": "Rensa logg",
        "stopLoading": "Stoppa inläsning",
        "simulateLoading": "Simulera inläsning",
        "refreshData": "Uppdatera data"
      },
      "examples": {
        "basicDraggable": "Grundläggande dragbar",
        "draggableWithElement": "Dragbar med element",
        "draggableWithTransitionGroup": "Dragbar med övergångsgrupp",
        "draggableWithMoveFunction": "Dragbar med flyttfunktion"
      },
      "eventLog": "Händelselogg",
      "handle": "Handle",
      "name": "Namn",
      "cannotMove": "(kan inte flytta)"
    },
    "tableDemo": {
      "title": "Vue 3 UIBTable Demo",
      "basicControls": "Grundläggande kontroller",
      "labels": {
        "filter": "Filtrera:",
        "sortBy": "Sortera efter:",
        "sortDirection": "Sorteringsriktning:",
        "perPage": "Per sida:",
        "tableStyling": "Tabellstil:"
      },
      "placeholders": {
        "typeToSearch": "Skriv för att söka ..."
      },
      "checkboxLabels": {
        "striped": "Randig",
        "bordered": "Med kantlinje",
        "hover": "Hovra",
        "small": "Liten",
        "responsive": "Responsiv"
      },
      "fields": {
        "id": "ID",
        "name": "Namn",
        "email": "E-post",
        "status": "Status",
        "created": "Skapad",
        "actions": "Åtgärder"
      },
      "statuses": {
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "pending": "Väntar",
        "banned": "Bannlyst"
      },
      "modal": {
        "title": "Artikelinformation",
        "close": "Stäng"
      },
      "messages": {
        "confirmDelete": "Är du säker på att du vill radera {name}?",
        "editItem": "Redigera objekt {id}",
        "showingItems": "Visar {count} av {total} objekt"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Bekräfta och fortsätt",
      "everythingIn": "Allt i <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "lägg till kreditkort här",
        "message": "Var vänlig be er kund att",
        "title": "Platsen måste först lägga till betalningsmetod."
      },
      "noSaasPlan": {
        "linkText": "skapa dina SaaS-planer här.",
        "message": "Vänligen",
        "title": "Du har ingen konfigurerad SaaS-plan."
      },
      "saasModeSetupPendingWarning": "SaaS-abonnemanget kommer att aktiveras efter att kunden har lagt till en betalningsmetod. Fram till dess kommer deras kontoåtkomst att vara begränsad.",
      "skipForNow": "Hoppa över tills vidare",
      "skipPlan": "Hoppa över abonnemang"
    }
  },
  "isv": {
    "business_registration_id_type": "Typ av företagsregistrerings-ID",
    "business_registration_number": "Organisationsnummer",
    "business_website": "Företagets webbplats",
    "enter_your_business_registration_id_type": "Ange typ av företagsregistrerings-ID",
    "name_of_other_registration_id_type": "Namn på annan typ av registrerings-ID",
    "pick_business_industry": "Välj affärsbransch",
    "pick_business_registration_id_type": "Välj typ av företagsregistrerings-ID",
    "emailWithStar": "E-post*",
    "businessIndustry": "Affärsbransch*",
    "businessType": "Företagstyp*",
    "regionsOfOperations": "Affärsregioner för verksamhet*",
    "registrationNumber": "Organisationsnummer*",
    "registrationNumberHelper": "Numret som används för att identifiera ditt företag. Om det är ett amerikanskt EIN-nummer måste det vara ett niosiffrigt nummer, t.ex. 12-3456789.",
    "businessWebsiteWithStar": "Företagets webbplats*",
    "businessTypeWithStar": "Företagstyp",
    "businessWebsite": "Företagets webbplats"
  },
  "aiProductRebilling": {
    "enableRebilling": "Aktivera återfakturering",
    "ratesMayDiffer": "Priserna kan variera beroende på region. De visade beräkningarna är baserade på priser för Storbritannien,",
    "supportDoc": "supportdokument",
    "cancel": "Avbryt",
    "profit": "Vinst",
    "chargedToCustomer": "Debiteras till kunden",
    "enabling": "Aktiverar ...",
    "forMore": "för mer information.",
    "rebillAmount": "Belopp för återfakturering",
    "tenDollarsWillGive": "10 USD ger dig ungefär",
    "yourCost": "Din kostnad",
    "clientBillingPage": "kundens företagsfaktureringssida",
    "needStripeConnection": "För att aktivera återfakturering, måste du ansluta till din Stripe på",
    "per1000Words": "per 1 000 ord",
    "perImage": "per bild",
    "perReviewResponse": "per recensionssvar",
    "perFunnel": "per tratt",
    "minimumBetween": "Minimum måste vara mellan {min} och {max}.",
    "images": "bilder",
    "reviewResponse": "recensionssvar",
    "funnel": "tratt",
    "pleaseCheckSupport": "kontrollera"
  },
  "a2p": {
    "otpSuccess": {
      "title": "OTP-framgång",
      "message": "Framgångsmeddelande för OTP"
    },
    "otpError": {
      "title": "OTP-fel",
      "message": "OTP-felmeddelande"
    },
    "businessProfileError": {
      "title": "Fel i företagsprofil",
      "message": "Felmeddelande om företagsprofil"
    },
    "addressError": {
      "title": "Adressfel",
      "status": "Status för adressfel"
    },
    "profileError": {
      "title": "A2P-profilfel",
      "message": "Felmeddelande för A2P-profil"
    },
    "address": {
      "country": "Land",
      "state": "Delstat",
      "chooseCountry": "Välj land...",
      "statePlaceholder": "Ange delstat",
      "chooseState": "Välj delstat …",
      "city": "Stad*",
      "postalCode": "Postnummer*",
      "streetAddress": "Gatuadress*",
      "streetAddressHelper": "Adressen måste vara giltig och kopplad till ditt företag.",
      "title": "Företagsadress"
    },
    "validation": {
      "brandNameRequired": "Varumärkesnamn krävs.",
      "businessVerticalRequired": "Affärsvertikal krävs.",
      "cityRequired": "Stad krävs.",
      "countryRequired": "Land krävs.",
      "invalidMobileNumber": "Ogiltigt mobilnummer.",
      "mobileNumberRequired": "Mobilnummer krävs.",
      "postalCodeRequired": "Postnummer krävs.",
      "stateRequired": "Delstat krävs.",
      "streetAddressRequired": "Gatuadress krävs."
    },
    "authorizedRep": {
      "email": "E-post*",
      "firstName": "Förnamn*",
      "jobPosition": "Befattning*",
      "jobTitle": "Jobbtitel*",
      "jobTitlePlaceholder": "Ange jobbtitel",
      "lastName": "Efternamn*",
      "phoneNumber": "Telefonnummer*",
      "phoneNumberPlaceholder": "Ange telefonnummer",
      "pickJobPosition": "Välj jobbposition",
      "title": "Detaljer om auktoriserad representant"
    },
    "registration": {
      "stepProgress": "Steg {currentStep} av 8",
      "successTitle": "Ditt A2P-varumärke och din kampanj har skickats in.",
      "successWaitDays": "7 dagar",
      "successWaitPrefix": "Det kan ta upp till ",
      "successWaitSuffix": " för godkännande av ditt varumärke och ytterligare 4–5 veckor för godkännande av kampanjen.",
      "otpNote": "Obs: Du kommer att få ett OTP-meddelande från TCR på ditt angivna mobilnummer för att verifiera. Svara Ja inom 24 timmar efter att du mottagit SMS:et."
    },
    "update": {
      "brandDetailsTitle": "Uppdatera varumärkesdetaljer",
      "brandName": "Namn på varumärke*",
      "brandNameHelper": "Använd antingen det juridiska namnet på organisationen som skickar meddelandena eller ditt eget namn om varumärket inte tillhör en organisation.",
      "businessVerticals": "Affärsbransch*",
      "chooseVertical": "Välj vertikal ...",
      "mobileNumber": "Mobilnummer för OTP-verifiering (med landskod)*",
      "mobileNumberHelper": "Ange ett mobilnummer som du har tillgång till så att du kan bekräfta OTP-verifiering. Endast amerikanska/kanadensiska nummer kommer att godkännas. Du får inte använda ett CPaaS-telefonnummer som ett som erhållits från LeadConnector. Du kan inte använda samma mobilnummer för att registrera fler än tre varumärken för enskild firma. Denna gräns hanteras av TCR.",
      "updateButton": "Uppdatera",
      "retryOTPTitle": "Försök igen med OTP",
      "retryOTPMessage": "Klicka på knappen nedan för att skicka OTP-verifieringsmeddelandet igen.",
      "sending": "Skickar ...",
      "resendOTP": "Skicka OTP igen"
    },
    "einModal": {
      "title": "Har ni ett EIN?",
      "question": "Har ni ett arbetsgivaridentifikationsnummer (EIN)?",
      "hasEIN": "Ja, jag har ett EIN",
      "noEIN": "Nej, jag har inget EIN",
      "disableNoEINText": "EIN krävs för platser utanför USA/Kanada",
      "infoText": "Ett EIN-nummer krävs för företag i USA och Kanada."
    },
    "brandDetails": {
      "brandHeading": "Varumärkesdetaljer",
      "brandName": "Namn på varumärke*",
      "brandNameHelper": "Använd antingen det juridiska namnet på organisationen som skickar meddelandena eller ditt eget namn om varumärket inte tillhör en organisation.",
      "businessIndustry": "Affärsbransch*",
      "chooseVertical": "Välj vertikal ...",
      "mobileNumber": "Mobilnummer för OTP-verifiering (med landskod)*",
      "mobileNumberHelper": "Ange ett mobilnummer som du har tillgång till så att du kan bekräfta OTP-verifiering. Endast amerikanska/kanadensiska nummer kommer att godkännas. Du får inte använda ett CPaaS-telefonnummer som ett som erhållits från LeadConnector. Du kan inte använda samma mobilnummer för att registrera fler än tre varumärken för enskild firma. Denna gräns hanteras av TCR.",
      "solePropBrand": {
        "heading": "Varumärke för enskild firma",
        "point1": "Endast ett telefonnummer är tillåtet",
        "point2": "EIN/SSN/DUNS krävs inte",
        "subheading": "Registrering av varumärke för enskild firma"
      },
      "solePropCampaign": {
        "heading": "Sole Prop-kampanj",
        "point1": "Endast 1 nummer får kopplas till en kampanj för en enskild firma",
        "point2": "När det har godkänts kommer ert standardnummer att kopplas automatiskt",
        "infoText": "Ni kan också uppdatera antalet efter godkännande",
        "warningText": "Endast 1 nummer får kopplas till en kampanj för en enskild firma. När ditt standardnummer har godkänts kopplas det automatiskt. Du kan också uppdatera numret efter godkännandet.",
        "subheading": "Registrering av kampanj för enskild firma"
      },
      "solePropSubtitle": "Varumärkes- och kampanjdetaljer för enskild firma",
      "standardBrand": {
        "heading": "4,41 $ – en gång",
        "point1": "EIN/SSN/DUNS krävs",
        "point2": "Mer än ett telefonnummer är tillåtet",
        "subheading": "Standard varumärkesregistrering"
      },
      "standardCampaign": {
        "heading": "16,54 $ – en gång",
        "point1": "Mer än ett nummer får länkas till en standardkampanj",
        "point2": "EIN/SSN/DUNS krävs",
        "infoText": "En extra kampanjavgift på upp till 12 $ per månad tillkommer i enlighet med TCR-reglerna.",
        "subheading": "Standardregistrering för kampanj"
      },
      "standardSubtitle": "Detaljer om standardvarumärke och kampanj",
      "title": "Varumärkes- och kampanjdetaljer"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Detaljer om kampanjens användningsfall",
        "subtitle": "Ange kampanjens detaljer och beskrivning",
        "useCase": "Användningsfall för kampanj*",
        "pickUseCase": "Välj användningsfall för kampanj",
        "useCaseDescription": "Beskrivning av användningsfall*",
        "explainInDetail": "Förklara i detalj",
        "useCaseDescriptionPlaceholder": "Exempel: Den här kampanjen skickar mötesinformation – bekräftelse och påminnelser – till våra kunder när de har bokat ett möte med oss på vår webbplats och valt att ta emot aviseringar och säljande SMS från oss.",
        "useCaseDescriptionHelper": "Ge en detaljerad beskrivning av hur du kommer att använda denna kampanj.",
        "solePropLabel": "Enskild firma",
        "seeExamples": "Se exempel",
        "closeExamples": "Stäng exempel"
      }
    }
  },
  "opportunities": {
    "email": "E-post",
    "phone": "Telefon",
    "status": "Status",
    "contactType": "Kontakttyp",
    "bulkOperation": "Bulk-process",
    "contactName": "Kontaktpersonens namn",
    "unassigned": "Ej tilldelad",
    "abandoned": "Övergivna",
    "addOpportunityName": "Lägg till möjlighetens namn",
    "companyName": "Företagets namn",
    "contactInfo": "Kontaktuppgifter",
    "enterValue": "Ange värde",
    "lost": "Förlorad",
    "open": "Öppen",
    "opportunityInfo": "Info om möjlighet",
    "opportunityName": "Möjlighetens namn",
    "opportunitySource": "Möjlighetskälla",
    "owner": "Ägare",
    "pipeline": "Pipeline",
    "selectPipeline": "Välj pipeline",
    "selectStage": "Välj stadie",
    "stage": "Stadium",
    "won": "Vunnen",
    "createdOn": "Skapad På",
    "goToContactDetail": "Gå till sidan för kontaktuppgifter",
    "leadValue": "Värde för potentiell kund",
    "removeOwner": "Ta bort ägare",
    "createdBy": "Skapad av",
    "notAllowedToChange": "Ni får inte ändra denna kontakt",
    "opportunityAlreadyExists": "En möjlighet finns redan för denna kontakt i den valda pipelinen",
    "filters": {
      "all": "Alla",
      "statuses": {
        "all": "Alla",
        "open": "Öppen",
        "won": "Vunna",
        "lost": "Förlorade",
        "abandoned": "Övergivna"
      },
      "search": "Sök",
      "status": "Status",
      "campaign": "Kampanj",
      "owner": "Ägare",
      "pipeline": "Pipeline",
      "dateAddedAsc": "↑ Datum tillagt (stigande)",
      "dateAddedDesc": "↓ Datum tillagt (fallande)",
      "orderBy": "OrderBy"
    },
    "columns": {
      "note": "Anteckning",
      "task": "Uppgift",
      "companyName": "Företagets namn",
      "additionalInfo": "Ytterligare info",
      "calendarEvent": "Kalenderhändelse",
      "hideAssignedTo": "Dölj tilldelad till",
      "hideTags": "Dölj taggar"
    },
    "buttons": {
      "new": "Ny"
    },
    "dragActions": {
      "abandoned": "Övergiven",
      "lost": "Förlorad",
      "won": "Vunnen"
    },
    "getStarted": "komma igång!",
    "noPipelines": "Hoppsan! Det verkar inte finnas några pipelines. Skapa en ny pipeline för att",
    "addTask": "Lägg till uppgift",
    "tasksCount": "{count} uppgifter"
  },
  "appointmentDetails": "Mötesdetaljer",
  "cloneFunnel": {
    "cloneButton": "Klona {entityName}",
    "cloning": "Klonar …",
    "cloningLimit": "Kloning är begränsad till 3 platser åt gången",
    "error": "Fel vid kloning av tratten!",
    "locationsLabel": "Välj platser",
    "nameLabel": "Namn för den klonade {entityName}",
    "namePlaceholder": "Ange namn för klonad {entityName}",
    "selectUpTo": "Välj upp till {maxSelectableLocations} platser",
    "title": "Klona {entityName}"
  },
  "errors": "Fel",
  "renderEmailAddress": "Rendera e-postadress",
  "noPaymentMethodWarning": "Varning för ingen betalningsmetod",
  "pageDetail": "Sidadetalj",
  "activityHistory": "Aktivitetshistorik",
  "uiAlert": "UI-varning",
  "eventModals": {
    "wait": {
      "save": "Spara",
      "days": "Dagar",
      "fri": "fre",
      "mon": "mån",
      "sat": "lör",
      "sun": "sön",
      "thu": "tors",
      "tue": "tis",
      "wed": "ons",
      "wait": "Vänta",
      "minutes": "Minuter",
      "hours": "Timmar",
      "title": "Redigera väntahändelse",
      "whichDaysResume": "Vilka dagar ska vi återuppta arbetet?",
      "pickDayError": "Vänligen välj minst en dag",
      "whatTimeResume": "Vilken tid ska vi återuppta?"
    },
    "sms": {
      "send": "Skicka",
      "name": "Namn",
      "attachFile": "Bifoga fil",
      "learnMore": "Läs mer",
      "sendTest": "Skicka test",
      "title": "Redigera {eventType}-händelse",
      "titleTemplate": "Redigera {eventType}-mall",
      "nameRequired": "Namn krävs",
      "pickTemplate": "Välj mall",
      "appCharacters": "Apptecken",
      "numSegments": "Antal segment",
      "approximateCost": "Ungefärlig kostnad",
      "costEstimateNote": "Kostnadsuppskattningsanteckning",
      "urlAttachmentAutocompleteToken": "URL-bilaga",
      "addFileUrl": "Lägg till en fil-URL",
      "urlImageAlt": "Bild-URL",
      "fileImageAlt": "Filbild",
      "enterMessage": "Ange meddelande",
      "mobilePhonePlaceholder": "Mobiltelefon",
      "unsupportedContentType": "Innehållstypen stöds inte: {fileType}",
      "urlAttachmentWarning": "{count} URL-bilaga{plural} kunde inte laddas. Vill du fortsätta?",
      "provideMobileNumber": "Vänligen ange ett mobilnummer"
    },
    "email": {
      "text": "Text",
      "checkLinks": "Kontrollera länkarna där du har ett anpassat värde. Det finns ett extra '%20' mellan {{ och custom_values.",
      "errorOccurred": "Ett fel uppstod, försök igen.",
      "insertToAddress": "Ange en adress."
    },
    "voicemail": {
      "save": "Spara",
      "dropFile": "Släpp filen här eller klicka för att ladda upp",
      "faq": "FAQ",
      "title": "Redigera röstmeddelandehändelse",
      "voicemailFile": "Röstmeddelandefil",
      "warning": "Varning: Röstmeddelandefiler måste vara i MP3-, WAV- eller GSM-format.",
      "unsupportedFormat": "Filformatet stöds inte. Använd MP3, WAV eller GSM."
    },
    "call": {
      "title": "Redigera samtalshändelse",
      "save": "Spara",
      "name": "Namn",
      "nameRequired": "Namn krävs",
      "callWhisper": "Samtalsviskning",
      "whisperMessage": "Viskningsmeddelande",
      "thisIsTheMessage": "Detta är meddelandet som kommer att spelas upp för agenten innan samtalet kopplas.",
      "callTimeoutS": "Timeout för samtal (s)",
      "timeoutSeconds": "Timeout (sekunder)",
      "disableVoicemailDetect": "Inaktivera upptäckt av röstmeddelanden",
      "callWillPatchInstantly": "Samtalet kommer att kopplas direkt utan att upptäcka röstbrevlådan."
    }
  },
  "emailTemplate": {
    "createdOn": "Skapad den",
    "updatedOn": "Uppdaterad den"
  },
  "cnam": {
    "learnMore": {
      "title": "CNAM Läs mer",
      "description": "CNAM-beskrivning"
    },
    "submitted": {
      "checkStatus": "Kontrollera CNAM-status",
      "description": "Ditt företagsnamn bör visas för relevanta kontakter inom cirka 3–5 dagar.",
      "subtitle": "Din CNAM-förfrågan har skickats in.",
      "title": "Grattis!"
    },
    "registration": {
      "confirm": "Bekräfta",
      "learnMore": "Läs mer",
      "characterLimit": "{count}/15",
      "title": "CNAM-registrering",
      "description": "Ange ditt företagsnamn (max 15 tecken)",
      "warning": "Varning: Ditt företagsnamn kommer att visas på nummerpresentatören. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Uppdateringsfel",
      "message": "Uppdateringsfelmeddelande"
    },
    "success": {
      "message": "Ditt A2P-varumärke och din kampanj har skickats in.<br/><br/><b>Obs:</b> Du kommer <b>att få ett OTP-meddelande från TCR på ditt angivna mobilnummer för att verifiera</b>. <b>Svara Ja inom 24 timmar</b> efter att du mottagit SMS:et.",
      "title": "Ditt A2P-varumärke och din kampanj har skickats in. Det kan ta upp till <b>7 dagar</b> för godkännande av ditt varumärke och ytterligare 4–5 veckor för godkännande av kampanjen."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Fel i regulatoriskt paket",
      "status": "Felstatus för regulatoriskt paket"
    },
    "createAddress": {
      "successMessage": "Ditt A2P-varumärke och din kampanj har skickats in.",
      "successTitle": "Adressen har skickats in",
      "underReview": "Den inskickade adressen granskas"
    },
    "createEndUser": {
      "dateFormat": "Datumformatet ska vara ÅÅÅÅ-MM-DD.",
      "phoneExample": " Exempel: +14155552671",
      "title": "Företag Info:"
    },
    "success": {
      "title": "Föreskriftspaket skickat",
      "underReview": "Det inskickade paketet granskas",
      "message": "Din förfrågan om SHAKEN/STIR-registrering har skickats in. Det kan ta upp till <b>3–4 dagar</b> innan den godkänns. Statusen kommer att uppdateras snart."
    },
    "documents": {
      "additionalInfo": "Ytterligare info",
      "createAddressLink": "Skapa adress.",
      "createAddressPrompt": "Skapa först en adress och fortsätt sedan med att skapa paketet.",
      "selectAddress": "Välj adress:"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "Det här alternativet lägger till en ny adress till ditt konto",
        "label": "Adresspaket"
      },
      "regulatoryBundle": {
        "description": "Det här alternativet hjälper dig att skapa ett nytt regulatoriskt paket",
        "label": "Regulatoriskt paket"
      },
      "title": "Välj vilket paket du vill lägga till"
    },
    "modal": {
      "back": "Tillbaka",
      "next": "Nästa",
      "submit": "Skicka",
      "title": "Nytt regelverkspaket",
      "description": "Skapa ett nytt regulatoriskt paket för er plats"
    }
  },
  "reminder": {
    "phone": "Telefon",
    "noReplyYet": "Inget svar ännu"
  },
  "sendGrid": {
    "apiKey": "SendGrid API-nyckel",
    "save": "SendGrid Spara",
    "apiKeyRequired": "SendGrid API-nyckel krävs"
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Uppgradera",
      "subtitle": "Byråer med Pro-abonnemang tjänar cirka 363 $ per månad genom att återfakturera telefonkostnaderna till sina kunder",
      "title": "Vill ni återfakturera detta till era kunder?"
    }
  },
  "emailField": {
    "label": "E-post",
    "placeholder": "E-post",
    "tooltip": {
      "primary": "Primär",
      "emails": "Mejl"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Läs in lägesbild:",
    "loadSnapshotWarning": "Vill du läsa in lägesbilden som är kopplad till den här planen? <br /> <strong class='text-danger'>Befintlig data kan gå förlorade</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Endast byråadministratörer/användare har tillgång till detta underkonto. För närvarande har du och andra kontoadministratörer/användare inte tillgång till detta underkonto.",
      "heading": "Det här underkontot har pausats."
    },
    "temporarily": {
      "description": "Alla dina data är säkra och alla utlösare/kampanjer etc. kommer att fungera igen efter aktiveringen.",
      "heading": " Ditt konto har tillfälligt stängts av."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Vänligt företagsnamn",
    "title": "Uppdatera nummerpresentation"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Välj kontor",
    "whichOffice": "Vilket kontor vill du länka till det här kontot?",
    "connect": "Anslut!"
  },
  "phoneField": {
    "label": "Telefon",
    "placeholder": "Telefonnummer",
    "tooltip": {
      "invalidNumber": "Ogiltigt telefonnummer",
      "notSmsCapable": "Detta {type}-nummer har inte SMS-funktionalitet"
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Bokningsinformation",
      "form": "Formulär",
      "quiz": "Quiz",
      "submissionDetail": "Inlämningsdetalj",
      "survey": "Undersökning"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "Din förfrågan om SHAKEN/STIR-registrering har skickats in. Det kan ta upp till <b>3–4 dagar</b> innan den godkänns. Statusen kommer att uppdateras snart.",
      "title": "Säker samtalsverifiering via SHAKEN/STIR aktiverad."
    },
    "modal": {
      "andThe": " och ",
      "businessProfile": "Företagsprofil",
      "certification": "Jag intygar att den tillhörande företagsprofilen är upphovsman till telefonsamtalen och intygar att jag kommer att delta i spårningsinsatser, inklusive sådana som initieras av",
      "failedTitle": "Inlämningen misslyckades",
      "friendlyName": "Vänligt namn",
      "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 kl 19:47:14",
      "linkInfo": {
        "description": "Alla nuvarande tillgängliga nummer och nummer som köps i framtiden registreras automatiskt med SHAKEN/STIR.",
        "title": "Alla nummer länkas automatiskt"
      },
      "stiPa": "Administratör för säker telefonidentitetspolicy (STI-PA)",
      "subtitle": "Ange detaljerna och beskrivningen",
      "successMessage": "Din förfrågan om SHAKEN/STIR-registrering har skickats in. Det kan ta upp till <b>3–4 dagar</b> innan den godkänns. Statusen kommer att uppdateras snart.",
      "successTitle": "Säker samtalsverifiering via SHAKEN/STIR aktiverad.",
      "title": "Aktivera säker samtalsverifiering via SHAKEN/STIR",
      "tracebackGroup": "US Telecoms grupp för samtalsspårning"
    },
    "withCnam": {
      "cnamPromo": "Registrera dig för CNAM för att visa ditt företagsnamn på nummerpresentation",
      "registerCnam": "Registrera CNAM"
    }
  },
  "task": {
    "2day": "2 dagar",
    "3day": "3 dagar",
    "4day": "4 dagar",
    "5day": "5 dagar",
    "addTask": "Lägg till uppgift",
    "countTasks": "{count} uppgifter"
  },
  "updatedProductsModal": {
    "title": "Uppdaterade produkter",
    "copyDirectSaleLink": "Kopiera länk för direktförsäljning",
    "setupFeeInstruction": "Startavgiften kan konfigureras i Stripe Dashboard. ",
    "doNotDeleteWarning": "Ta inte bort produkter eller priser från Stripe Dashboard. Detta kommer att bryta integrationen."
  },
  "termsOfService": {
    "privacyLink": "integritetspolicy",
    "accept": "Godkänn",
    "termsLink": "användarvillkor",
    "updateMessage": "Vi har uppdaterat våra användarvillkor och vår integritetspolicy. Granska och acceptera för att fortsätta.",
    "agreementPrefix": "Genom att fortsätta godkänner ni vår ",
    "agreementConjunction": " och "
  },
  "callerIdVerificationModal": {
    "answerCall": "Svara på samtalet och ange den här verifieringskoden:",
    "leadConnectorCalling": "Lead Connector ringer ...",
    "title": "Lägg till nummerpresentation med rösten",
    "waitingForVerification": "Väntar på verifieringen ..."
  },
  "emailOTPModal": {
    "confirmCode": "Bekräfta koden",
    "resendCode": "Om du inte har fått koden klickar du här för att skicka igen"
  },
  "survey": {
    "copy": {
      "cancel": "Avbryt",
      "location": "Plats",
      "copy": "Kopiera",
      "newSurveyName": "Nytt undersökningsnamn",
      "title": "Kopiera undersökning",
      "locationRequired": "Plats krävs"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Produktnamn",
    "planDetails": "Detaljer om abonnemanget",
    "title": "Produktinformation",
    "planId": "Plan-ID",
    "copiedToClipboard": "Kopierat till urklipp"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "Mer effektiv",
      "faster": "Snabbare",
      "itsText": "Det är",
      "smoother": "Smidigare",
      "title": "En ny importupplevelse är här!",
      "warningMessage": "Om du aktiverar den nya importfunktionen aktiveras Labs för detta underkonto och betafunktionen aktiveras.",
      "tryNow": "Testa nu"
    },
    "validateEmails": "Validera e-postadresser?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "HighLevel-pris",
      "howDoesItWork": "Hur fungerar det?",
      "payNow": "Betala nu",
      "priceError": "Priset måste vara lika med eller högre än HighLevel-priset",
      "saving": "Sparar",
      "yourPrice": "Ditt pris",
      "yourProfit": "Din vinst",
      "subscriptionCreating": "Ett abonnemang håller på att skapas.<br/>Uppdatera inte sidan och tryck inte på bakåtknappen",
      "subscriptionCreated": "Abonnemang har skapats. Vänta ett ögonblick ...",
      "unableToCreate": "Det gick inte att skapa abonnemanget. Kontakta supporten",
      "perMonth": "per månad",
      "agreeToEnable": "Jag samtycker till att aktivera annonser för den här kunden utan uppsälj och jag godkänner att jag kommer att debiteras",
      "deployDirectly": "Distribuera listor direkt",
      "deployDirectlyDesc": "Använd det här alternativet om du erbjuder annonser som en del av ditt erbjudande eller om du vill fakturera din kund externt",
      "minimumCommitment": "med en minsta bindningstid på 1 månad.",
      "offerListings": "Erbjudandeförteckningar",
      "resellListings": "Återförsäljningsannonser",
      "subscribedInfo": "{withoutUpsell} utan uppsälj, {withUpsell} med uppsälj och {withSaas} med SaaS-paket",
      "yourResellOffer": "Ditt återförsäljningserbjudande"
    }
  }
}
